import { getLanguageStr } from "./language.js";
// import Highcharts from "highcharts";
import * as routesDic from "@/util/routesDic";

let upgradeTime = 0; //第一次运行将始终检测
export function updateToDo(from) {
	// 发布版本之后的动作
	let time = new Date().getTime();
	function toDo() {
		if (stage.upgrade) {
			//需要刷新客户端
			location.reload();
		}
	}
	if (time - upgradeTime > 1000 * 60 * 60 * 2) {
		//控制版本检测周期
		$.getScript("/static/js/upgrade.js", function () {
			switch (from) {
				case "router":
					setTimeout(toDo, 500);
					break;
				case "api":
					toDo();
					break;
			}
		});
		upgradeTime = time;
	}
}
export function randomData(optionNew) {
	// 为演示数据用
	var array = [];
	// if(optionNew==undefined) optionNew={};
	var option = { min: 0, max: 100, array: 1 };
	$.extend(option, optionNew);
	var i = 0;
	while (i < option.array) {
		array.push(Math.round(Math.random() * (option.max - option.min) + option.min));
		++i;
	}
	// console.log(typeof(array[0]))
	return array.length > 1 ? array : array[0];
}
export function utc(number) {
	// 输出utc时间
	// trace( new Date(number).toUTCString() );
	return new Date(number).toUTCString();
}
window.utc = utc;
export function getUrlParam(name, encode) {
	// 获取url传递的参数
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
	var r = window.location.search.substr(1).match(reg); // 匹配目标参数
	if (encode) r[2] = encodeURIComponent(r[2]);
	if (r != null) return decodeURIComponent(r[2]);
	else return null; // 返回参数值
}

export function getCookie(Name) {
	var search = Name + "=";
	var returnvalue = "";
	if (document.cookie.length > 0) {
		var offset = document.cookie.indexOf(search),
			end;
		if (offset != -1) {
			// if cookie exists
			offset += search.length;
			end = document.cookie.indexOf(";", offset);
			if (end == -1) {
				end = document.cookie.length;
			}
			returnvalue = unescape(document.cookie.substring(offset, end));
		}
	}
	return returnvalue == "" ? null : returnvalue;
}
export function doPermissions(codes, outCodeComparison) {
	// 传入权限code判断是否有权限
	let out = false;
	// outCodeComparison传参示例：
	// {
	// 	targetCode:"A1",
	// 	codeList:[
	// 		{code:"OP/A1",isOn:0/1/2}
	// 	]
	// }
	let curCodeList = codes.split(","); //兼容多个code 方案，多个code情况下，只要有一个code权限，即为有当前节点
	let permissions = stage.permissions || JSON.parse(localStorage.getItem("buttonPermissions")) || [];
	out = curCodeList.find((code) => permissions.includes(code)) || false;
	if (out && outCodeComparison && outCodeComparison.codeList) {
		if (outCodeComparison.codeList && outCodeComparison.codeList.length > 0) {
			let outCodeList = [...outCodeComparison.codeList];
			$.each(outCodeList, function () {
				// 过滤code，去除/前面的
				this.code = this.code.split("/")[1] || this.code.split("/")[0];
			});
			let res = outCodeList.filter((el) => el.code == outCodeComparison.targetCode);
			if (res.length && res[0].isOn > 0) {
				out = true;
			} else {
				out = false;
			}
		} else {
			out = false;
		} //空数组作为无权限处理
	}
	if (stage.token && stage.browser.mobile) {
		// 手机不做权限判断
		out = true;
	}
	return out;
}
export function doLayoutRole(targetCode, ctrl1, ctrl2 = localStorage.getItem("businessTypeRole")) {
	if (targetCode) {
		let pass = false;
		ctrl1 = ctrl1.split(",");
		// ctrl2=ctrl2.split(",");
		// let max=[];
		// $.each(ctrl2,(index,val)=>{
		// 	if(ctrl1.indexOf(val)>=0){
		// 		max.push(val);
		// 	}
		// });
		return ctrl1.indexOf(targetCode) >= 0;
	} else {
		return true;
	}
}
export function stringFormatForJson(str, fix) {
	// 使字符能够转成obj
	// str=decodeURIComponent(str);
	str = decodeURIComponent(encodeURIComponent(str));
	if (fix && str.indexOf("{") !== 0) str = "{}";
	return str.replace(/'/g, '"'); // (/\'/g,'"')
}

export function getRoute(param, roleCodeList) {
	// 重定向路由
	if (param === "maintainRoutesDic" && stage.powerTypeList.length > 1) {
		//判断能源类型大于1才展示数据驾驶舱this.userInfo.organization.operateObject.indexOf('2') !== -1
		return [{ route: "/business/maintain/dataCockpit" }];
	}
	let res = [];
	if (roleCodeList && roleCodeList.length) {
		roleCodeList = roleCodeList.filter((_) => _.isOn !== 0).map((_) => _.code);
		routesDic[param].forEach((r) => {
			if (roleCodeList.includes(r.code)) {
				res.push(r);
			}
		});
	}
	if (
		(roleCodeList.includes("A/A") || roleCodeList.includes("A/B") || roleCodeList.includes("A/D")) &&
		param === "businessRoutesDic" &&
		stage.powerTypeList.length > 1
	) {
		res.unshift({ route: "/business/maintain/dataCockpit" });
	}

	// if(res.length==0){
	// 	res.push({title:"没有权限",route:"/noPermission"});
	// }
	return res;
}

export function statistic(a, b, c = "", d = "") {
	//统计埋点抽象方法
	if (stage.loc.statistic.baidu && a && b) {
		switch (a) {
			case "A01":
				a += "-登录";
				break;
			case "A02":
				a += "-注册第一步邮箱注册";
				break;
			case "A03":
				a += "-注册第一步手机号注册";
				break;
			case "A04":
				a += "-注册第二步完善账号信息";
				break;
			case "A05":
				a += "-注册第三步完善商家信息";
				break;
			case "A06":
				a += "-注册第四步注册成功";
				break;
			case "A07":
				a += "-忘记密码第一步邮箱确认";
				break;
			case "A08":
				a += "-忘记密码第一步手机号确认";
				break;
			case "A09":
				a += "-忘记密码第二步重置密码";
				break;
			case "A10":
				a += "-忘记密码第三步重置成功";
				break;
			case "A11":
				a += "-运维-首页";
				break;
			case "A12":
				a += "-运维-电站";
				break;
			case "A13":
				a += "-电站详情";
				break;
			case "A14":
				a += "-运维-报警";
				break;
			case "A15":
				a += "-设备-设备管理";
				break;
			case "A16":
				a += "-滑入应用展开常用应用";
				break;
			case "A17":
				a += "-点击应用进入应用首页";
				break;
			case "A18":
				a += "-点击管理进入管理-关于商家";
				break;
			case "A19":
				a += "-点击进入消息盒子详情";
				break;
			case "A22":
				a += "-滑入个人名称展开个人相关功能";
				break;
			case "A23":
				a += "-点击新建电站";
				break;
			case "A24":
				a += "-点击编辑电站";
				break;
			case "A25":
				a += "-编辑所属标签";
				break;
			case "A26":
				a += "-点击添加网关/采集器";
				break;
			case "A29":
				a += "-点击编辑系统布局";
				break;
			case "A30":
				a += "-点击电站设置";
				break;
			case "A31":
				a += "-点击子系统/设备";
				break;
			case "A33":
				a += "-点击系统布局";
				break;
			case "A34":
				a += "-点击维保记录";
				break;
			case "A35":
				a += "-点击关于电站";
				break;
			case "A37":
				a += "-点击打开报警详情";
				break;
			case "A38":
				a += "-点击打开大屏";
				break;
			case "A39":
				a += "-点击打开应用-报表";
				break;
			case "A40":
				a += "-点击打开SIM卡充值";
				break;
			case "A41":
				a += "-点击打开应用-维保记录";
				break;
			case "A42":
				a += "-点击打开应用-保险";
				break;
			case "A43":
				a += "-点击打开应用-虚拟气象站";
				break;
			case "A44":
				a += "-点击打开应用-体检";
				break;
			case "A45":
				a += "-点击组/成员";
				break;
			case "A46":
				a += "-点击角色";
				break;
			case "A47":
				a += "-点击外部关系进入商家界面";
				break;
			case "A48":
				a += "-点击外部角色";
				break;
			case "A49":
				a += "-点击标签";
				break;
			case "A50":
				a += "-点击报警消息管理";
				break;
			case "A51":
				a += "-点击我的主页";
				break;
			case "A52":
				a += "-点击个人设置";
				break;
			case "A57":
				a += "-预设大屏详情";
				break;
			case "A61":
				a += "-点击多个体检报告详情";
				break;
			case "A62":
				a += "-点击单个体检报告详情";
				break;
			case "A63":
				a += "-点击商家详情";
				break;
			case "A64":
				a += "-点击用户详情";
				break;
			case "A65":
				a += "-点击添加新特殊规则";
				break;
			case "A66":
				a += "-点击编辑特殊规则";
				break;
			case "A67":
				a += "-点击查看特殊规则详情";
				break;
			case "A68":
				a += "-点击设备详情";
				break;
			case "A69":
				a += "-设备控制";
				break;
			case "A70":
				a += "-固件升级";
				break;
			case "A71":
				a += "-固件管理";
				break;
			case "A72":
				a += "-上传固件";
				break;
			case "A73":
				a += "-编辑固件信息";
				break;
			case "A74":
				a += "-固件详情";
				break;
			case "A75":
				a += "-操作日志";
				break;
		}
		switch (b) {
			case "A0101":
				b += "-显示登录界面";
				break;
			case "A0102":
				b += "-点击手机号登录";
				break;
			case "A0103":
				b += "-点击用户名登录";
				break;
			case "A0104":
				b += "-点击登录";
				break;
			case "A02":
				b += "-点击注册按钮进入注册第一步邮箱注册";
				break;
			case "A07":
				b += "-忘记密码第一步邮箱确认";
				break;
			case "A0201":
				b += "-显示邮箱注册界面";
				break;
			case "A03":
				b += "-点击切换为手机号注册";
				break;
			case "A0301":
				b += "-显示手机号注册界面";
				break;
			case "A02":
				b += "-点击切换为邮箱注册";
				break;
			case "A0401":
				b += "-显示完善账号信息界面";
				break;
			case "A0402":
				b += "-点击下一步";
				break;
			case "A0501":
				b += "-显示完善商家信息界面";
				break;
			case "A0505":
				b += "-点击下一步";
				break;
			case "A0601":
				b += "-显示注册成功界面";
				break;
			case "A0602":
				b += "-点击完成并登录商家版";
				break;
			case "A0701":
				b += "-显示忘记密码邮箱确认界面";
				break;
			case "A08":
				b += "-点击切换为手机号确认";
				break;
			case "A0801":
				b += "-显示忘记密码手机号确认界面";
				break;
			case "A09":
				b += "-点击切换为邮箱确认";
				break;
			case "A0901":
				b += "-显示重置密码界面";
				break;
			case "A0902":
				b += "-点击下一步";
				break;
			case "A1001":
				b += "-显示重置成功界面";
				break;
			case "A1002":
				b += "-点击登录商家版";
				break;
			case "A1101":
				b += "-显示运维-首页界面";
				break;
			case "A1102":
				b += "-点击国家筛选内的任意国家";
				break;
			case "A1103":
				b += "-点击标签筛选内的任意标签";
				break;
			case "A1104":
				b += "-点击电站总数";
				break;
			case "A1105":
				b += "-点击接入中电站";
				break;
			case "A1106":
				b += "-滑入接入中电站解释";
				break;
			case "A1107":
				b += "-点击全部设备离线电站";
				break;
			case "A1108":
				b += "-点击部分设备离线电站";
				break;
			case "A1109":
				b += "-点击通讯正常电站";
				break;
			case "A1110":
				b += "-点击通讯状态简报更多";
				break;
			case "A1111":
				b += "-点击有报警电站";
				break;
			case "A1112":
				b += "-点击无报警电站";
				break;
			case "A1113":
				b += "-点击报警状态简报更多";
				break;
			case "A1114":
				b += "-点击日满发小时排名时间选择器往前一天";
				break;
			case "A1116":
				b += "-点击日满发小时排名时间选择器往后一天";
				break;
			case "A1117":
				b += "-选择后10名";
				break;
			case "A1118":
				b += "-选择前10名";
				break;
			case "A1119":
				b += "-点击日满发小时排名更多";
				break;
			case "A1122":
				b += "-点击我的关注更多";
				break;
			case "A1123":
				b += "-点击整体发电历史时间选择器往前一月";
				break;
			case "A1125":
				b += "-点击整体发电历史时间选择器往后一月";
				break;
			case "A1126":
				b += "-点击整体发电历史年时间选项";
				break;
			case "A13":
				b += "-点击打开电站详情";
				break; //A12
			case "A1201":
				b += "-显示运维-电站界面";
				break;
			case "A1202":
				b += "-点击电站搜索";
				break;
			case "A1211":
				b += "-点击高级筛选";
				break;
			case "A1221":
				b += "-点击名称/位置排序中的升序";
				break;
			case "A1222":
				b += "-点击名称/位置排序中的降序";
				break;
			case "A1223":
				b += "-点击发电功率排序中的升序";
				break;
			case "A1224":
				b += "-点击发电功率排序中的降序";
				break;
			case "A1225":
				b += "-点击昨日满发小时排序中的升序";
				break;
			case "A1226":
				b += "-点击昨日满发小时排序中的降序";
				break;
			case "A1227":
				b += "-点击当日发电量排序中的升序";
				break;
			case "A1228":
				b += "-点击当日发电量排序中的降序";
				break;
			case "A1229":
				b += "-点击累计发电量排序中的升序";
				break;
			case "A1230":
				b += "-点击累计发电量排序中的降序";
				break;
			case "A1231":
				b += "-点击昨日PR排序中的升序";
				break;
			case "A1232":
				b += "-点击昨日PR排序中的降序";
				break;
			case "A1233":
				b += "-点击数据更新时间排序中的升序";
				break;
			case "A1234":
				b += "-点击数据更新时间排序中的降序";
				break;
			case "A1235":
				b += "-点击操作区中关注";
				break;
			case "A1236":
				b += "-点击操作区中的取消关注";
				break;
			case "A1237":
				b += "-点击操作区中的授权";
				break;
			case "A1238":
				b += "-点击操作区中的标签";
				break;
			case "A1239":
				b += "-点击操作区中的删除";
				break;
			case "A1240":
				b += "-点击电站列表中的通讯状态图标";
				break;
			case "A22":
				b += "-滑入个人名称展开个人相关功能";
				break;
			case "A23":
				b += "-点击新建电站";
				break;
			case "A24":
				b += "-点击编辑电站";
				break;
			case "A1302":
				b += "-点击系统概要-当前报警总数查看";
				break;
			case "A1303":
				b += "-点击系统概要-当前逆变器总数查看";
				break;
			case "A1304":
				b += "-点击系统概要-当前电表总数查看";
				break;
			case "A1305":
				b += "-点击系统概要-当前组件总数查看";
				break;
			case "A1306":
				b += "-点击系统概要-当前气象站总数查看";
				break;
			case "A1307":
				b += "-点击系统概要-当前微逆总数查看";
				break;
			case "A1308":
				b += "-点击系统概要-当前汇流箱总数查看";
				break;
			case "A1309":
				b += "-点击系统概要-当前中继器总数查看";
				break;
			case "A1310":
				b += "-点击系统概要-当前电池总数查看";
				break;
			case "A1311":
				b += "-点击系统概要-当前采集器总数查看";
				break;
			case "A1312":
				b += "-点击系统概要-当前DTU总数查看";
				break;
			case "A1313":
				b += "-鼠标移入发电历史-日图表-参数选择";
				break;
			case "A1314":
				b += "-点击发电历史-日图表-参数选择中确定";
				break;
			case "A1315":
				b += "-点击发电历史-日图表-概览数据中的购买";
				break;
			case "A1316":
				b += "-点击发电历史-日图表时间选择器往前一天";
				break;
			case "A1318":
				b += "-点击发电历史-日图表时间选择器往后一天";
				break;
			case "A1319":
				b += "-鼠标移入发电历史-月图表-参数选择";
				break;
			case "A1320":
				b += "-点击发电历史-月图表-参数选择中的确定";
				break;
			case "A1321":
				b += "-点击发电历史-月图表-概览数据中的购买";
				break;
			case "A1322":
				b += "-点击发电历史-月图表时间选择器往前一月";
				break;
			case "A1324":
				b += "-点击发电历史-月图表时间选择器往后一月";
				break;
			case "A1325":
				b += "-鼠标移入发电历史-年图表-参数选择";
				break;
			case "A1326":
				b += "-点击发电历史-年图表-参数选择中的确定";
				break;
			case "A1327":
				b += "-点击发电历史-年图表-概览数据中的购买";
				break;
			case "A1328":
				b += "-点击发电历史-年图表时间选择器往前一年";
				break;
			case "A1330":
				b += "-点击发电历史-年图表时间选择器往后一年";
				break;
			case "A1331":
				b += "-鼠标移入发电历史-总图表-参数选择";
				break;
			case "A1332":
				b += "-点击发电历史-总图表-参数选择中的确定";
				break;
			case "A1333":
				b += "-点击发电历史-总图表-概览数据中的购买";
				break;
			case "A1334":
				b += "-鼠标移入自发自用历史-日图表-参数选择";
				break;
			case "A1336":
				b += "-点击自发自用历史-日图表时间选择器往前一天";
				break;
			case "A1338":
				b += "-点击自发自用历史-日图表时间选择器往后一天";
				break;
			case "A1339":
				b += "-鼠标移入自发自用历史-月图表-参数选择";
				break;
			case "A1341":
				b += "-点击发电历史-月图表时间选择器往前一月";
				break;
			case "A1343":
				b += "-点击发电历史-月图表时间选择器往后一月";
				break;
			case "A1344":
				b += "-鼠标移入自发自用历史-年图表-参数选择";
				break;
			case "A1346":
				b += "-点击发电历史-年图表时间选择器往前一年";
				break;
			case "A1348":
				b += "-点击发电历史-年图表时间选择器往后一年";
				break;
			case "A1349":
				b += "-鼠标移入自发自用历史-总图表-参数选择";
				break;
			case "A1351":
				b += "-点击子系统切换列表中的任意子系统";
				break;
			case "A1352":
				b += "-点击本商家对当前电站的权限";
				break;
			case "A25":
				b += "-编辑所属标签";
				break;
			case "A1401":
				b += "-显示运维-报警界面";
				break;
			case "A1501":
				b += "-显示设备-设备管理界面";
				break;
			case "A1502":
				b += "-点击SN搜索";
				break;
			case "A1503":
				b += "-选择逆变器";
				break;
			case "A1504":
				b += "-选择采集器";
				break;
			case "A1505":
				b += "-选择电表";
				break;
			case "A1506":
				b += "-选择电池";
				break;
			case "A1507":
				b += "-选择组件";
				break;
			case "A1508":
				b += "-选择汇流箱";
				break;
			case "A1509":
				b += "-选择气象站";
				break;
			case "A1510":
				b += "-选择微逆";
				break;
			case "A1511":
				b += "-选择DTU";
				break;
			case "A1512":
				b += "-选择中继器";
				break;
			case "A1513":
				b += "-选择电源";
				break;
			case "A1514":
				b += "-选择水质空气监测";
				break;
			case "A1515":
				b += "-选择谐波表";
				break;
			case "A1516":
				b += "-选择智能家居";
				break;
			case "A1517":
				b += "-选择空调";
				break;
			case "A1518":
				b += "-选择其他";
				break;
			case "A1519":
				b += "-选择风机";
				break;
			case "A1520":
				b += "-选择水泵";
				break;
			case "A1521":
				b += "-选择混合系统能源柜";
				break;
			case "A1522":
				b += "-选择未激活";
				break;
			case "A1523":
				b += "-选择在线";
				break;
			case "A1524":
				b += "-选择报警";
				break;
			case "A1525":
				b += "-选择离线";
				break;
			case "A1526":
				b += "-点击操作区中-查看所属系统";
				break;
			case "A1527":
				b += "-点击操作区中-删除";
				break;
			case "A1528":
				b += "-点击单个导入";
				break;
			case "A1529":
				b += "-点击单个导入-取消";
				break;
			case "A1530":
				b += "-点击单个导入-确定";
				break;
			case "A1531":
				b += "-点击批量导入-选择文件";
				break;
			case "A1532":
				b += "-点击批量导入-上传";
				break;
			case "A1533":
				b += "-点击批量导入-取消";
				break;
			case "A1534":
				b += "-点击批量删除";
				break;
			case "A1535":
				b += "-点击批量删除-选择文件";
				break;
			case "A1536":
				b += "-点击批量删除-上传";
				break;
			case "A1537":
				b += "-点击批量删除-确认";
				break;
			case "A1538":
				b += "-点击批量删除-取消";
				break;
			case "A38":
				b += "-点击打开大屏";
				break;
			case "A39":
				b += "-点击打开报表";
				break;
			case "A40":
				b += "-点击打开SIM卡充值";
				break;
			case "A41":
				b += "-点击打开维保记录";
				break;
			case "A42":
				b += "-点击打开保险";
				break;
			case "A43":
				b += "-点击打开虚拟气象站";
				break;
			case "A44":
				b += "-点击打开体检";
				break;
			case "A17":
				b += "-点击更多应用进入应用首页";
				break;
			case "A1701":
				b += "-显示应用首页界面";
				break;
			case "A38":
				b += "-点击打开大屏";
				break;
			case "A39":
				b += "-点击打开报表";
				break;
			case "A40":
				b += "-点击打开SIM卡充值";
				break;
			case "A41":
				b += "-点击打开维保记录";
				break;
			case "A42":
				b += "-点击打开保险";
				break;
			case "A43":
				b += "-点击打开虚拟气象站";
				break;
			case "A44":
				b += "-点击打开体检";
				break;
			case "A1801":
				b += "-显示关于商家界面";
				break;
			case "A1802":
				b += "-点击编辑注册信息";
				break;
			case "A1901":
				b += "-显示消息盒子详情界面";
				break;
			case "A1902":
				b += "-点击报警消息分类";
				break;
			case "A1903":
				b += "-点击任意报警id消息分类";
				break;
			case "A37":
				b += "-点击打开报警详情";
				break;
			case "A50":
				b += "-点击报警消息管理";
				break;
			case "A68":
				b += "-点击添加新特殊规则";
				break;
			case "A69":
				b += "-点击编辑新特殊规则";
				break;
			case "A2201":
				b += "-退出登录";
				break;
			case "A51":
				b += "-点击我的主页";
				break;
			case "A2301":
				b += "-显示新建电站界面";
				break;
			case "A2302":
				b += "-点击取消";
				break;
			case "A2303":
				b += "-点击保存";
				break;
			case "A2304":
				b += "-点击完成";
				break;
			case "A26":
				b += "-点击添加网关/采集器";
				break;
			case "A25":
				b += "-编辑所属标签";
				break;
			case "A53":
				b += "-授权用户";
				break;
			case "A54":
				b += "-授权商家";
				break;
			case "A55":
				b += "-授权内部成员";
				break;
			case "A56":
				b += "-添加新子系统";
				break;
			case "A2401":
				b += "-显示编辑电站界面";
				break;
			case "A2402":
				b += "-点击取消";
				break;
			case "A2403":
				b += "-点击完成";
				break;
			case "A2501":
				b += "-显示编辑所属标签界面";
				break;
			case "A2502":
				b += "-点击+添加标签";
				break;
			case "A2503":
				b += "-点击确定";
				break;
			case "A2504":
				b += "-选择任意标签";
				break;
			case "A2605":
				b += "-点击子设备添加方式";
				break;
			case "A2606":
				b += "-点击手动选择子设备";
				break;
			case "A2901":
				b += "-显示编辑系统布局界面";
				break;
			case "A2902":
				b += "-点击导出";
				break;
			case "A2903":
				b += "-点击导入";
				break;
			case "A2904":
				b += "-在导入中点击选择文件";
				break;
			case "A2905":
				b += "-在导入中点击“点击这里”";
				break;
			case "A2906":
				b += "-在导入中点击“布局信息怎么填”";
				break;
			case "A2907":
				b += "-在导入中点击“点击下载导入文件模版”";
				break;
			case "A2908":
				b += "-在导入中点击取消";
				break;
			case "A2909":
				b += "-在导入中点击确定";
				break;
			case "A2910":
				b += "-点击搜索";
				break;
			case "A2912":
				b += "-点击电气布局";
				break;
			case "A2914":
				b += "-点击预览";
				break;
			case "A2915":
				b += "-点击保存";
				break;
			case "A2916":
				b += "-点击取消";
				break;
			case "A3001":
				b += "-显示电站设置界面";
				break;
			case "A3102":
				b += "-在状态筛选中选择未激活状态";
				break;
			case "A3103":
				b += "-在状态筛选中选择在线状态";
				break;
			case "A3104":
				b += "-在状态筛选中选择报警状态";
				break;
			case "A3105":
				b += "-在状态筛选中选择离线状态";
				break;
			case "A3106":
				b += "-点击添加子系统";
				break;
			case "A3107":
				b += "-点击搜索";
				break;
			case "A3301":
				b += "-显示系统布局界面";
				break;
			case "A3302":
				b += "-点击初始化编辑系统布局";
				break;
			case "A3303":
				b += "-点击编辑系统布局";
				break;
			case "A3304":
				b += "-点击全屏显示系统布局";
				break;
			case "A3305":
				b += "-点击系统布局-日图表时间选择器往前一天";
				break;
			case "A3307":
				b += "-点击系统布局-日图表时间选择器往后一天";
				break;
			case "A3308":
				b += "-点击系统布局-月图表";
				break;
			case "A3309":
				b += "-点击系统布局-月图表时间选择器往前一月";
				break;
			case "A3311":
				b += "-点击系统布局-月图表时间选择器往后一月";
				break;
			case "A3312":
				b += "-点击系统布局-年图表";
				break;
			case "A3313":
				b += "-点击系统布局-年图表时间选择器往前一年";
				break;
			case "A3314":
				b += "-点击系统布局-年图表时间选择器";
				break;
			case "A3315":
				b += "-点击系统布局-年图表时间选择器往后一年";
				break;
			case "A3316":
				b += "-点击系统布局-总图表";
				break;
			case "A3401":
				b += "-显示维保记录界面";
				break;
			case "A3402":
				b += "-点击添加新维保记录";
				break;
			case "A3403":
				b += "-点击任意维保记录";
				break;
			case "A3501":
				b += "-显示关于电站界面";
				break;
			case "A3701":
				b += "-显示报警详情界面";
				break;
			case "A3702":
				b += "-点击电站";
				break;
			case "A3703":
				b += "-点击设备";
				break;
			case "A3704":
				b += "-点击分布-日图表时间选择器往前一天";
				break;
			case "A3705":
				b += "-点击分布-日图表时间选择器";
				break;
			case "A3706":
				b += "-点击分布-日图表时间选择器往后一天";
				break;
			case "A3707":
				b += "-点击参数选择";
				break;
			case "A3801":
				b += "-显示大屏界面";
				break;
			case "A3802":
				b += "-点击设置";
				break;
			case "A57":
				b += "-点击大屏列表里的任意大屏进入大屏详情";
				break;
			case "A3902":
				b += "-选择时间段内任意时间段";
				break;
			case "A3904":
				b += "-点击查询";
				break;
			case "A3905":
				b += "-点击导出";
				break;
			case "A4001":
				b += "-显示SIM卡充值界面";
				break;
			case "A4101":
				b += "-显示维保记录界面";
				break;
			case "A4102":
				b += "-点击添加新维保记录";
				break;
			case "A4103":
				b += "-点击任意维保记录";
				break;
			case "A4201":
				b += "-显示保险界面";
				break;
			case "A4301":
				b += "-显示虚拟气象站界面";
				break;
			case "A4401":
				b += "-显示发起体检界面";
				break;
			case "A4402":
				b += "-点击请选择体检对象";
				break;
			case "A4403":
				b += "-点击开始体检";
				break;
			case "A4404":
				b += "-点击体检报告";
				break;
			case "A4405":
				b += "-点击多个电站体检报告";
				break;
			case "A4406":
				b += "-点击单个电站体检报告";
				break;
			case "A61":
				b += "-点击多个体检报告详情";
				break;
			case "A62":
				b += "-点击单个体检报告详情";
				break;
			case "A4501":
				b += "-显示组/成员界面";
				break;
			case "A4502":
				b += "-点击添加下级组";
				break;
			case "A4503":
				b += "-点击添加平行组";
				break;
			case "A4504":
				b += "-点击编辑组";
				break;
			case "A4505":
				b += "-点击删除组";
				break;
			case "A4506":
				b += "-点击添加新成员";
				break;
			case "A4507":
				b += "-点击重置密码";
				break;
			case "A4601":
				b += "-显示角色界面";
				break;
			case "A4602":
				b += "-点击添加新角色";
				break;
			case "A4603":
				b += "-点击克隆";
				break;
			case "A4604":
				b += "-点击编辑角色";
				break;
			case "A4605":
				b += "-点击删除角色";
				break;
			case "A4701":
				b += "-显示外部关系商家界面";
				break;
			case "A4702":
				b += "-点击添加已有商家";
				break;
			case "A4703":
				b += "-点击创建新商家";
				break;
			case "A4704":
				b += "-点击编辑商家";
				break;
			case "A4705":
				b += "-点击删除商家";
				break;
			case "A4706":
				b += "-点击外部关系用户";
				break;
			case "A4707":
				b += "-点击添加已有用户";
				break;
			case "A4708":
				b += "-点击创建新用户";
				break;
			case "A4709":
				b += "-点击编辑用户";
				break;
			case "A4710":
				b += "-点击删除用户";
				break;
			case "A4801":
				b += "-显示外部角色界面";
				break;
			case "A4802":
				b += "-点击添加新外部角色";
				break;
			case "A4803":
				b += "-点击克隆";
				break;
			case "A4804":
				b += "-点击编辑外部角色";
				break;
			case "A4805":
				b += "-点击删除外部角色";
				break;
			case "A4901":
				b += "-显示标签界面";
				break;
			case "A4902":
				b += "-点击添加新标签";
				break;
			case "A4903":
				b += "-点击编辑标签";
				break;
			case "A4804":
				b += "-点击删除标签";
				break;
			case "A5001":
				b += "-显示报警消息管理默认规则界面";
				break;
			case "A5002":
				b += "-点击设置";
				break;
			case "A5003":
				b += "-hover哪些情况下规则不会立即生效";
				break;
			case "A5004":
				b += "-点击特殊规则";
				break;
			case "A5005":
				b += "-点击删除特殊规则";
				break;
			case "A65":
				b += "-点击添加新特殊规则";
				break;
			case "A66":
				b += "-点击编辑特殊规则";
				break;
			case "A67":
				b += "-点击查看特殊规则";
				break;
			case "A5101":
				b += "-显示我的主页界面";
				break;
			case "A5102":
				b += "-点击查看授权给该成员的电站";
				break;
			case "A5201":
				b += "-显示个人设置界面";
				break;
			case "A5202":
				b += "-点击修改姓名";
				break;
			case "A5203":
				b += "-点击修改邮箱";
				break;
			case "A5204":
				b += "-点击修改手机号";
				break;
			case "A5205":
				b += "-点击修改登录密码";
				break;
			case "A5206":
				b += "-点击修改用户名";
				break;
			case "A5701":
				b += "-显示预设大屏详情界面";
				break;
			case "A5702":
				b += "-点击预设大屏详情内的锚点";
				break;
			case "A6101":
				b += "-显示多个体检报告详情界面";
				break;
			case "A6102":
				b += "-点击再次体检";
				break;
			case "A6103":
				b += "-点击等级的定义";
				break;
			case "A6201":
				b += "-显示单个体检报告详情";
				break;
			case "A6301":
				b += "-显示商家详情界面";
				break;
			case "A6302":
				b += "-点击查看授权给该商家的电站";
				break;
			case "A6401":
				b += "-显示用户详情界面";
				break;
			case "A6402":
				b += "-点击查看授权给该用户的电站";
				break;
			case "A6501":
				b += "-显示添加新特殊规则界面";
				break;
			case "A6502":
				b += "-点击取消";
				break;
			case "A6503":
				b += "-点击保存";
				break;
			case "A6601":
				b += "-编辑特殊规则界面";
				break;
			case "A6602":
				b += "-点击取消";
				break;
			case "A6603":
				b += "-点击保存";
				break;
			case "A6701":
				b += "-显示查看特殊规则详情界面";
				break;
			case "A66":
				b += "-点击编辑特殊规则";
				break;
			case "A6801":
				b += "-显示设备详情-详情首页";
				break;
			case "A6802":
				b += "-点击设备详情-详情首页-日图表-参数选择";
				break;
			case "A6803":
				b += "-点击设备详情-详情首页-日图表-参数选择中的确定";
				break;
			case "A6804":
				b += "-点击设备详情-详情首页-日图表时间选择器往前一天";
				break;
			case "A6805":
				b += "-点击设备详情-详情首页-日图表时间选择器";
				break;
			case "A6806":
				b += "-点击设备详情-详情首页-日图表时间选择器往后一天";
				break;
			case "A6837":
				b += "-点击设备详情-详情首页-周图表-参数选择";
				break;
			case "A6838":
				b += "-点击设备详情-详情首页-周图表-参数选择中的确定";
				break;
			case "A6839":
				b += "-点击设备详情-详情首页-周图表时间选择器往前一周";
				break;
			case "A6840":
				b += "-点击设备详情-详情首页-周图表时间选择器";
				break;
			case "A6841":
				b += "-点击设备详情-详情首页-周图表时间选择器往后一周";
				break;
			case "A6807":
				b += "-点击设备详情-详情首页-月图表";
				break;
			case "A6808":
				b += "-点击设备详情-详情首页-月图表-参数选择";
				break;
			case "A6809":
				b += "-点击设备详情-详情首页-月图表-参数选择中的确定";
				break;
			case "A6810":
				b += "-点击设备详情-详情-月图表时间选择器往前一月";
				break;
			case "A6811":
				b += "-点击设备详情-详情首页-月图表时间选择器";
				break;
			case "A6812":
				b += "-点击设备详情-详情首页-月图表时间选择器往后一月";
				break;
			case "A6813":
				b += "-点击设备详情-详情首页-年图表";
				break;
			case "A6814":
				b += "-点击设备详情-详情首页-年图表-参数选择";
				break;
			case "A6815":
				b += "-点击设备详情-详情首页-年图表-参数选择中的确定";
				break;
			case "A6816":
				b += "-点击设备详情-详情首页-年图表-时间选择器往前一年";
				break;
			case "A6817":
				b += "-点击设备详情-详情首页-年图表-时间选择器";
				break;
			case "A6818":
				b += "-点击设备详情-详情首页-年图表-时间选择器往后一年";
				break;
			case "A6819":
				b += "-点击设备详情-详情首页-总图表";
				break;
			case "A6820":
				b += "-点击设备详情-详情首页-总图表-参数选择";
				break;
			case "A6821":
				b += "-点击设备详情-详情首页-总图表-参数选择中的确定";
				break;
			case "A6822":
				b += "-点击设备详情-详情首页-总图表-时间选择器";
				break;
			case "A37":
				b += "-点击打开报警详情";
				break;
			case "A6828":
				b += "-点击设备详情-连接信息页";
				break;
			case "A6829":
				b += "-点击设备详情-操作日志页";
				break;
			case "A6833":
				b += "-点击设备详情-操作日志-升级日志页";
				break;
			case "A6901":
				b += "-显示设备控制-自定义命令页面";
				break;
			case "A6902":
				b += "-点击设备控制-自定义命令页面-发送";
				break;
			case "A6903":
				b += "-进入设备控制-参数设置页面";
				break;
			case "A7001":
				b += "-显示固件升级页面";
				break;
			case "A7002":
				b += "-点击固件升级页面-固件升级按钮";
				break;
			case "A7101":
				b += "-显示固件管理列表";
				break;
			case "A7102":
				b += "-点击固件名称搜索";
				break;
			case "A7201":
				b += "-显示上传固件页面";
				break;
			case "A7202":
				b += "-点击上传固件-保存";
				break;
			case "A7203":
				b += "-点击上传固件-取消";
				break;
			case "A7301":
				b += "-显示编辑固件信息页面";
				break;
			case "A7302":
				b += "-点击-编辑固件信息-保存";
				break;
			case "A7303":
				b += "-点击-编辑固件信息-取消";
				break;
			case "A7401":
				b += "-显示固件详情首页";
				break;
			case "A7501":
				b += "-显示操作日志页面";
				break;
			case "A7502":
				b += "-点击操作日志页面-SN搜索";
				break;
		}
		switch (c) {
			case "":
				c += "";
				break;

			case "":
				c += "";
				break;
		}
		switch (d) {
			case "":
				d += "";
				break;

			case "":
				d += "";
				break;
		}

		_hmt.push(["_trackEvent", a, b, c, d]);
	}
}
window.statistic = statistic;

export function setSideNav(newList, routeList) {
	var delayTime = 0;
	if (newList[1] == "sim") {
		if (routeList.length && routeList[2] != newList[2]) {
			$("#sideNav nav").children().stop().fadeOut(200);
			delayTime = 220;
		}
		routeList = newList;

		setTimeout(function () {
			$("#sideNav nav")
				.children("." + routeList[1] + "-" + routeList[2])
				.stop()
				.fadeIn(200);
		}, delayTime);
		return newList;
	} else {
		if (routeList.length && routeList[1] != newList[1]) {
			$("#sideNav nav").children().stop().fadeOut(200);
			delayTime = 220;
		}
		routeList = newList;

		setTimeout(function () {
			$("#sideNav nav")
				.children("." + routeList[1])
				.stop()
				.fadeIn(200);
		}, delayTime);
		return newList;
	}
}
export function operateModeChange() {
	// 控制列表操作列的显示模式
	// let $target=$(".operate [mode]");
	// let mode=$target=$(".operate [mode]").attr("mode");
	if (stage.setting.loc.operateMode === "min") stage.setting.loc.operateMode = "def";
	else stage.setting.loc.operateMode = "min";
	$(".operate").css({ pointerEvents: "none" });
	setTimeout(function () {
		$(".operate").css({ pointerEvents: "" });
	}, 1000);
}
export function formModeChange(btn, action) {
	// 详情中的表单模式切换
	let $btn = $(btn);
	if ($btn.parents("li[mode]").first().length > 0) {
		// 确保格式正确
		let type = (function () {
			if ($btn.hasClass("edit")) return "edit";
			else if ($btn.hasClass("cancel")) return "cancel";
			else if ($btn.hasClass("save")) return "save";
		})();
		let $group = $btn.parents(".content").first().find(".changeGroup");
		let groupHeight = $group.find(".content-view").innerHeight(); // $group.find(".content-view").data("targetH")||
		switch (action) {
			case "update":
				setTimeout(function () {
					let nowMode = $btn.parents("li[mode]").first().attr("mode");
					switch (nowMode) {
						case "edit":
							$group.css("height", $group.find(".content-edit").innerHeight());
							break;
						default:
							$group.css("height", $group.find(".content-def").innerHeight());
							break;
					}
				}, 500);
				break;
			default:
				switch (type) {
					case "edit":
						$group.css("height", $group.find(".content-view").innerHeight());
						groupHeight = $group.find(".content-edit").innerHeight();
						break;
					case "cancel":
						// $group.css("height",$group.find(".content-edit").innerHeight());
						type = "def";
						break;
					case "save":
						type = "def";
						break;
				}
				$group.css("height", groupHeight);
				setTimeout(function () {
					if ($btn.parents("li[mode]").first().attr("mode") == "def") $group.css("height", "");
				}, 500);
				$btn.parents("li[mode]").first().attr("mode", type);
				setTimeout(function () {
					// 延时检查确保高度
					if ($btn.parents("li[mode]").first().attr("mode") == "edit" && $group.find(".content-edit").innerHeight() != groupHeight)
						$group.css("height", $group.find(".content-edit").innerHeight());
				}, 1000);
				break;
		}
	} else {
		trace("DOM格式不正确");
	} // if end
}

export function transitionAction(dom, action, speed = 500) {
	// transition动画补充
	let option = {};
	switch (action) {
		case "hide-x":
			option = {
				opacity: 0,
				width: 0,
				marginLeft: 0,
				padding: 0,
			};
			break;
		case "hide":
			option = {
				opacity: 0,
				width: 0,
				height: 0,
				margin: 0,
				padding: 0,
			};
			break;
	}
	$(dom).css({ transition: "none" }).stop(true, true).animate(option, speed, "easeInOutExpo");
}

export function getFileType(pathOrFullName) {
	// 输出文件类型，不带点
	pathOrFullName = pathOrFullName.split(".");
	pathOrFullName = pathOrFullName[pathOrFullName.length - 1];
	return pathOrFullName;
}

export function inRunType(arrStr) {
	// 判断是否在允许的运行类型内，B端或者C端
	var runList = arrStr.split(",");
	return $.inArray(stage.type, runList) >= 0;
}
export function validValue(val, array) {
	// 判断值的有效性，支持多条件
	var outArray = [];
	$(array).each(function (index) {
		switch (array[index]) {
			case "empty": // 为空
				(!val && val !== 0) || !String(val).split(" ").join("") ? outArray.push(true) : outArray.push(false);
				break;
			case "notEmpty": // 不为空
				val && val !== 0 && val.split(" ").join("") ? outArray.push(true) : outArray.push(false);
				break;
			case "notPassword": // 不为有效密码
				/^.{6,50}$/.test(val) ? outArray.push(false) : outArray.push(true); /// ^[a-z0-9_-]{6,32}$/
				break;
			case "email": // 为email
				// 原有 验证时过长会卡死
				// (/^([a-z0-9A-Z]+[_\-|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}/).test(val) ? outArray.push(true) : outArray.push(false);
				// 百度
				// (/\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/).test(val) ? outArray.push(true) : outArray.push(false)
				// 页面中使用过
				// (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(val) ? outArray.push(true) : outArray.push(false);
				/^\w+([-.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val) ? outArray.push(true) : outArray.push(false);
				break;
			case "notEmail": // 不为email
				// (/^([a-z0-9A-Z]+[_\-|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}/).test(val) ? outArray.push(false) : outArray.push(true);
				// (/\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/).test(val) ? outArray.push(false) : outArray.push(true)
				// (/^\w+([-.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(val) ? outArray.push(false) : outArray.push(true);
				/^\w+([-.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val) ? outArray.push(false) : outArray.push(true); // 支持英文大小写、数字、@、下划线、减号、小数点，减号和小数点仅用于字母、数字及下划线的连接，且不可重复；
				break;
			case "notMobile": // 不为手机号
				/^1[3|4|5|6|7|8|9]\d{9}$/.test(val) ? outArray.push(false) : outArray.push(true);
				break;
			case "sn": //是SN
				/^[A-Z0-9]{16}$/.test(val) ? outArray.push(true) : outArray.push(false);
				break;
			case "notSn": //不是SN
				/^[A-Z0-9]{16}$/.test(val) ? outArray.push(false) : outArray.push(true);
				break;
			// case "":
			// 	break;
		}
	});
	return { list: outArray, allClear: !($.inArray(false, outArray) >= 0) };
}
export function trace(data, clear, extend) {
	// 输出内容
	if (clear) console.clear();
	if (extend && data.constructor == Object) console.log($.extend(true, {}, data));
	else if (extend && $.isArray(data)) console.log(data.concat());
	else console.log(data);
}
window.trace = trace;

export function fill2str(number) {
	if (number.constructor != Number) number = "00";
	else {
		number = Math.abs(number);
		if (number < 10) number = "0" + number;
	}
	return String(number);
}

export function timeFormat(time, type, formatORfix, option) {
	const Highcharts = require("highcharts");
	//time:Date or unit s
	if (formatORfix) {
		//格式翻译
		formatORfix = formatORfix.replace(/YYYY/g, "%Y");
		formatORfix = formatORfix.replace(/MM/g, "%m");
		formatORfix = formatORfix.replace(/DD/g, "%d");
		formatORfix = formatORfix.replace(/HH/g, "%H");
		formatORfix = formatORfix.replace(/mm/g, "%M");
		formatORfix = formatORfix.replace(/ss/g, "%S");
	}
	// time:Date or unit s
	// trace(time);
	let utcStr = "";
	if ($.isNumeric(time)) {
		// 转成毫秒
		time *= 1000;
	} else time = Date.parse(time);
	if (option && option.offset) {
		if ($.isNumeric(option.offset)) time += option.offset;
		// 对该时间增加目标时区 'PRC'
		else time += mz.tz(option.offset)._offset * 60 * 1000; // 时区转成毫秒
	}

	switch (type) {
		case "system": // 使用本机系统的时区
			time += stage.time.localOffset;
			if (stage.time.localOffset != 0) a = stage.time.localOffset > 0 ? "+" : "-";
			utcStr = a + Highcharts.dateFormat("%H:%M", stage.time.localOffset);
			break;
		case "utc": // 直接呈现，不附加时区
			if (option && option.offset) utcStr = mz.tz(option.offset).format("Z");
			break;
		case "inc": // 使用登录的商家时区
			time += stage.time.offset;
			utcStr = mz.tz(stage.time.timeZoneCode).format("Z");
			break;
		case "offset":
			time += offset;
			break;
		case "targetZoneDateSec": // 使用目标时区值来呈现
			if ($.type(formatORfix) != "string") {
				// 格式传参可以直接跳过，
				option = $.extend(true, {}, formatORfix);
				formatORfix = "%Y-%m-%d %H:%M:%S"; //YYYY/MM/DD HH:mm:ss
			}
			time = timeFormat(time / 1000, "utc", formatORfix, {
				offset: option.targetOffset,
			});
			time = mz.tz(time, option.targetOffset).unix(); // format
			// time=new Date(time);//-stage.time.localOffset
			// trace(time,true);
			// time=time.replace(/-/g,"/");
			break;
		case "api":
			// time=new Date("2018-04-01");
			// time=Date.parse("Sun Apr 01 2018 19:29:58 GMT+0800 (中国标准时间)");
			// let d=new Date(time);
			// time=Date.parse(d.getFullYear()+"-"+fill2str(d.getMonth()+1)+"-"+fill2str(d.getDate()));
			time += stage.time.offset;
			time += $.isNumeric(formatORfix) ? formatORfix * 1000 : 0;
			let a = "",
				b = "Z";
			if (stage.time.offset) {
				if (stage.time.offset != 0) a = stage.time.offset > 0 ? "+" : "-";
				b = Highcharts.dateFormat("%H:%M", Math.abs(stage.time.offset));
			}
			formatORfix = "%Y/%m/%dT%H:%M:%S" + a + b;
			break;

		// case "":
		// 	break;
	}

	if (type == "targetZoneDateSec") {
		return time;
	} else {
		if (formatORfix.indexOf("UTC") != -1) {
			return $.isNumeric(time) ? Highcharts.dateFormat(formatORfix, time) + utcStr : "";
		} else {
			return $.isNumeric(time) ? Highcharts.dateFormat(formatORfix, time) : ""; // %Y/%m/%d or %Y/%m/%d and %H:%M:%S
		}
	}
}
window.mz = mz;
export function dateFormat(dateStr, splitString) {
	//20190828加分隔符 2019/08/28
	splitString = splitString || "/";
	dateStr = String(dateStr);
	let out = splitString;
	if (dateStr.length == 8) {
		let dateArr = new Array(3);
		dateArr[0] = dateStr.substr(0, 4);
		dateArr[1] = dateStr.substr(4, 2);
		dateArr[2] = dateStr.substr(6, 2);
		out = dateArr.join(splitString);
	}
	return out;
}
export function getTypeText(val, name, traceType) {
	// 类型数字转文字
	let types = {},
		token = null; //token:用户控制匹配失败的输出内容
	switch (
		name // 过滤器的组对象，可增加若干组
	) {
		case "visibleLimit":
			types = [
				// 报警影响范围
				{
					id: ["0"],
					name: getLanguageStr("device341", "外部商家") + "," + getLanguageStr("device338", "终端用户"),
					value: 0,
				},
				{
					id: ["1"],
					name: getLanguageStr("device207", "无"),
					value: 1,
				},
				{
					id: ["2"],
					name: getLanguageStr("device341", "外部商家"),
					value: 2,
				},
				{
					id: ["3"],
					name: getLanguageStr("device338", "终端用户"),
					value: 3,
				},
			];
			break;
		case "alarmFilterScope":
			types = [
				// 报警影响范围
				{
					id: ["0"],
					name: getLanguageStr("word1622", "无发电或安全影响"),
				},
				{ id: ["1"], name: getLanguageStr("word1495", "影响发电") },
				{ id: ["2"], name: getLanguageStr("word1496", "影响安全") },
				{
					id: ["3"],
					name: getLanguageStr("word1497", "影响发电及安全"),
				},
			];
			break;
		case "alarmInfluenceScope":
			types = [
				// 报警影响范围
				{
					id: ["-1"],
					name: [getLanguageStr("word1465", "无报警"), "cContent"],
				},
				{
					id: ["0"],
					name: [getLanguageStr("word1622", "无发电或安全影响"), "cSuccess"],
				},
				{
					id: ["1"],
					name: [getLanguageStr("word1495", "影响发电"), "cPrimary"],
				},
				{
					id: ["2"],
					name: [getLanguageStr("word1496", "影响安全"), "cDanger"],
				},
				{
					id: ["3"],
					name: [getLanguageStr("word1497", "影响发电及安全"), "cError"],
				},
			];
			break;
		case "alarmLevel":
			types = [
				// 报警级别
				{
					id: ["0"],
					name: [getLanguageStr("manage100", "提示"), "cPrompt", "bgPrompt"],
				},
				{
					id: ["1"],
					name: [getLanguageStr("word71", "警告"), "cDanger", "bgDanger"],
				},
				{
					id: ["2"],
					name: [getLanguageStr("word70", "故障"), "cWarning", "bgWarning"],
				},
			];
			break;
		case "alarmLevelFilter":
			types = [
				// 报警级别
				{ id: ["0"], name: getLanguageStr("manage100", "提示") },
				{ id: ["1"], name: getLanguageStr("word71", "警告") },
				{ id: ["2"], name: getLanguageStr("word70", "故障") },
			];
			break;
		case "alarmStateS":
			types = [
				// 全部报警状态、有报警电站、无报警电站
				{
					id: [""],
					value: null,
					name: getLanguageStr("cmd19", "全部"),
					def: getLanguageStr("word1658", "报警状态"),
				},
				{
					id: ["ALERTING"],
					value: "ALERTING",
					name: getLanguageStr("word1583", "有报警电站"),
				},
				{
					id: ["NORMAL"],
					value: "NORMAL",
					name: getLanguageStr("word1584", "无报警电站"),
				},
			];
			break;
		case "alarmStateChild":
			types = [
				// 全部报警状态、有报警电站、无报警电站
				{
					id: [""],
					value: null,
					name: getLanguageStr("cmd19", "全部"),
					def: getLanguageStr("word1658", "报警状态"),
				},
				{
					id: ["ALERTING"],
					value: "ALERTING",
					name: {
						name: getLanguageStr("word1464", "有报警"),
						color: "#ff7875 ",
					},
				},
				{
					id: ["NORMAL"],
					value: "NORMAL",
					name: {
						name: getLanguageStr("word1465", "无报警"),
						color: "#41d068",
					},
				},
			];
			break;
		case "alarmStatus":
			types = [
				// 报警状态
				{
					id: ["ALERTING"],
					name: getLanguageStr("word1464", "有报警"),
				},
				{ id: ["NORMAL"], name: getLanguageStr("word1465", "无报警") },
			];
			break;
		case "alarmType":
			types = [
				// 报警类型
				{ id: ["0"], name: getLanguageStr("word163", "协议报警") },
				{ id: ["1"], name: getLanguageStr("word1493", "自定义报警") },
			];
			break;
		case "applyFor":
			types = [
				// 报警影响范围
				{
					id: ["1"],
					value: 1,
					name: getLanguageStr("word204", "电站"),
				},
				// {id:["2"],value:2,name:getLanguageStr("word1185","线索")},
				// {id:["3"],value:3,name:getLanguageStr("word1183","客户")},
				// {id:["4"],value:4,name:getLanguageStr("word1202","项目")},
				// {id:["5"],value:5,name:getLanguageStr("图表分析","图表分析")}
			];
			break;
		case "balance":
			types = [
				// 币种
				{ id: ["1"], name: getLanguageStr("unit48", "欧元") },
				{ id: ["2"], name: getLanguageStr("unit1", "元") },
			];
			break;
		case "batchfailureReason":
			types = [
				// 批量任务
				{
					id: ["501"],
					name: getLanguageStr("task65", "指令任务冲突"),
					value: 501,
				},
				{
					id: ["530"],
					name: getLanguageStr("task66", "指令发送失败"),
					value: 530,
				},
				{
					id: ["510"],
					name: getLanguageStr("task67", "解析结果失败"),
					value: 510,
				},
				{ id: ["511"], name: getLanguageStr("manage484", "无效版本号"), value: 511 },
				{
					id: ["502"],
					name: getLanguageStr("task68", "设备不属于该产品"),
					value: 502,
				},
				{
					id: ["505"],
					name: getLanguageStr("task69", "系统错误"),
					value: 505,
				},
			];
			break;
		case "batchRange":
			types = [
				// 批量任务范围
				{
					id: ["0"],
					name: getLanguageStr("task25", "指定设备"),
					value: 0,
				},
				// { id: ['1'], name: getLanguageStr('task26', '指定条件'), value:1 }
			];
			break;
		case "batchReleaseTime":
			types = [
				// 批量任务发布时间
				{
					id: ["0"],
					name: getLanguageStr("device26", "立即发布"),
					value: 0,
				},
				{
					id: ["1"],
					name: getLanguageStr("device27", "定时发布"),
					value: 1,
				},
			];
			break;
		case "batchTaskStatus":
			types = [
				// 批量任务
				{
					id: [null],
					name: getLanguageStr("cmd19", "全部"),
					value: 0,
					def: getLanguageStr("task10", "任务状态"),
				},
				{
					id: ["1"],
					name: getLanguageStr("task5", "待发布"),
					value: 1,
				},
				{
					id: ["2"],
					name: getLanguageStr("task6", "执行中"),
					value: 2,
				},
				{
					id: ["3"],
					name: getLanguageStr("task7", "已结束"),
					value: 3,
				},
			];
			break;
		case "batchType":
			types = [
				// 批量任务
				{
					id: [null],
					name: getLanguageStr("cmd19", "全部"),
					value: 0,
					def: getLanguageStr("task9", "任务类型"),
				},
				{
					id: ["1"],
					name: getLanguageStr("word781", "设备控制"),
					value: 1,
				},
				{
					id: ["2"],
					name: getLanguageStr("word1563", "设备升级"),
					value: 2,
				},
			];
			break;
		case "batteryStatus":
			types = [
				// 升级指令状态
				{ id: ["CHARGE"], name: getLanguageStr("word185", "充电") },
				{ id: ["DISCHARGE"], name: getLanguageStr("word186", "放电") },
				{ id: ["STATIC"], name: getLanguageStr("word184", "静止") },
				{ id: ["UNKNOWN"], name: getLanguageStr("word1579", "未知") },
				// { id: ['3'], name: getLanguageStr('word202', '失败')}
			];
			break;
		case "brandS":
			types = [
				// 品牌
				{
					id: ["0"],
					name: getLanguageStr("brand0", "SolarMAN小麦光伏"),
				},
				{ id: ["3"], name: getLanguageStr("brand3", "三晶") },
				{ id: ["30"], name: getLanguageStr("brand30", "禾迈") },
				{ id: ["32"], name: getLanguageStr("brand32", "PEIMAR") },
				{ id: ["35"], name: getLanguageStr("brand35", "艾伏") },
				{ id: ["36"], name: getLanguageStr("brand36", "固德威") },
				{ id: ["5"], name: getLanguageStr("brand5", "华为") },
			];
			break;
		case "channelList":
			types = [
				// 流转状态
				{
					id: ["1"],
					name: getLanguageStr("通过采集器升级", "通过采集器升级"),
				},
				{
					id: ["2"],
					name: getLanguageStr("通过SIM卡升级", "通过SIM卡升级"),
				},
			];
			break;
		case "chargeMode":
			types = [
				{
					id: ["FREE"],
					name: getLanguageStr("word1951", "免费试用"),
					value: 1,
				},
				{ id: ["CHARGE"], name: "收费", value: 2 },
			];
			break;
		case "curveTargetType":
			types = [
				{ id: ["STATION"], name: getLanguageStr("plant172", "电站"), value: "STATION" },
				{ id: ["SYSTEM"], name: getLanguageStr("plant_alert33", "子系统"), value: "SYSTEM" },
				{ id: ["DEVICE"], name: getLanguageStr("device62", "设备"), value: "DEVICE" },
			];
			break;
		case "messageBoxType":
			types = [
				{
					id: ["ALERT"],
					name: getLanguageStr("word1955", "报警消息"),
					value: 1,
				},
				{
					id: ["WORKORDER"],
					name: getLanguageStr("message19", "工单消息"),
					value: 2,
				},
			];
			break;
		case "circulationStateS":
			types = [
				// 流转状态
				{ id: ["1"], name: getLanguageStr("word60", "已入库") },
				{ id: ["2"], name: getLanguageStr("word61", "已授权") },
				{ id: ["3"], name: getLanguageStr("word62", "已注册") },
			];
			break;
		case "clueStatus":
			types = [
				// 线索状态
				{
					id: ["1"],
					name: [getLanguageStr("word1201", "新线索"), "label-warning"],
				},
				{
					id: ["2"],
					name: [getLanguageStr("word1197", "开发中"), "label-primary"],
				},
				{
					id: ["99"],
					name: [getLanguageStr("word1198", "已成交"), "label-success"],
				},
				{
					id: ["3"],
					name: [getLanguageStr("word1199", "已暂停"), "label-fail"],
				},
			];
			break;
		// case "communicationStateS_plant_l":
		// types=[ //电站通讯状态(长)
		// { id: [""], name: getLanguageStr("word1516","全部通讯状态"), def:getLanguageStr("word1516","全部通讯状态")},
		// { id: ["NO_DEVICE"], name: getLanguageStr("word1641", "接入中电站") }, //建设中
		// { id: ["ALL_OFFLINE", "2"], name: getLanguageStr("word1462","全部设备离线电站"),title:getLanguageStr("phrase593", "电站下所有设备均离线")},
		// { id: ["PARTIAL_OFFLINE"], name: getLanguageStr("word1463","部分设备离线电站"),title:getLanguageStr("phrase595", "电站下部分设备离线了") },
		// { id: ["NORMAL", "1"], name: getLanguageStr("word1640","通讯正常电站") }
		// ];
		// break;
		case "connectStatus":
			types = [
				// 通讯状态
				{
					id: [""],
					name: getLanguageStr("cmd19", "全部"),
					value: null,
					def: getLanguageStr("word1460", "通讯状态"),
				},
				{
					id: ["NO_DEVICE"],
					name: getLanguageStr("word1641", "接入中电站"),
					value: "NO_DEVICE",
				}, // 建设中
				{
					id: ["ALL_OFFLINE", "2"],
					value: "ALL_OFFLINE",
					name: getLanguageStr("word1462", "全部设备离线电站"),
					title: getLanguageStr("phrase593", "电站下所有设备均离线"),
				},
				{
					id: ["PARTIAL_OFFLINE"],
					value: "PARTIAL_OFFLINE",
					name: getLanguageStr("word1463", "部分设备离线电站"),
					title: getLanguageStr("phrase595", "电站下部分设备离线了"),
				},
				{
					id: ["NORMAL", "1"],
					value: "NORMAL",
					name: getLanguageStr("word1640", "通讯正常电站"),
				},
			];
			break;
		case "connectStatusForchild":
			types = [
				// 通讯状态     : {name: getLanguageStr('plant_detail134', '通讯正常'), color: '#41d068'}
				{
					id: [""],
					name: getLanguageStr("cmd19", "全部"),
					value: null,
					def: getLanguageStr("word1460", "通讯状态"),
				},
				{
					id: ["NO_DEVICE"],
					name: {
						name: getLanguageStr("creat_plant40", "接入中"),
						color: "#048fff",
					},
					value: "NO_DEVICE",
				}, // 建设中
				{
					id: ["ALL_OFFLINE"],
					value: "ALL_OFFLINE",
					name: {
						name: getLanguageStr("plant_detail51", "全部设备离线"),
						color: "#c0c0c0",
					},
				},
				{
					id: ["PARTIAL_OFFLINE"],
					value: "PARTIAL_OFFLINE",
					name: {
						name: getLanguageStr("plant_detail52", "部分设备离线"),
						color: "#c0c0c0",
					},
				},
				{
					id: ["NORMAL"],
					value: "NORMAL",
					name: {
						name: getLanguageStr("plant_detail134", "通讯正常"),
						color: "#41d068",
					},
				},
			];
			break;
		case "configSelectStatus": // 数据来源设置
			types = [
				// 线索状态
				{
					id: ["METER"],
					value: "METER",
					name: getLanguageStr("word1966", "求和电表数据"),
				},
				{
					id: ["INVERTER_SUM"],
					value: "INVERTER_SUM",
					name: getLanguageStr("plant_detail128", "求和逆变器数据"),
				},
				{
					id: ["null"],
					value: null,
					name: getLanguageStr("word116", "无"),
				},
			];
			break;
		case "configSelectGeneration": //发电
			types = [
				// 发电
				{
					id: ["METER"],
					value: "METER",
					name: getLanguageStr("word1966", "求和电表数据"),
				},
				{
					id: ["MICRO_INVERTER_SUM"],
					value: "MICRO_INVERTER_SUM",
					name: getLanguageStr("plant474", "求和微逆数据"),
				},
				{
					id: ["PV_MODULE_SUM"],
					value: "PV_MODULE_SUM",
					name: getLanguageStr("plant_detail30", "求和组件数据"),
				},
				{
					id: ["EPM_SUM"],
					value: "EPM_SUM",
					name: getLanguageStr("plant439", "求和EPM数据"),
				},
				{
					id: ["HYBRID_ENERGY_SUM"],
					value: "HYBRID_ENERGY_SUM",
					name: getLanguageStr("plant440", "求和混合能源系统柜数据"),
				},
				{
					id: ["INVERTER_SUM"],
					value: "INVERTER_SUM",
					name: getLanguageStr("plant_detail128", "求和逆变器数据"),
				},
				{
					id: ["OFF_GRID_INVERTER_SUM"],
					value: "OFF_GRID_INVERTER_SUM",
					name: getLanguageStr("plant475", "求和离网逆变器数据"),
				},
				{
					id: ["FAN_SUM"],
					value: "FAN_SUM",
					name: getLanguageStr("plant377", "求和风机数据"),
				},
				{
					id: ["null"],
					value: null,
					name: getLanguageStr("word116", "无"),
				},
			];
			break;
		case "configSelectConsumption": //用电
			types = [
				// 用电
				{
					id: ["METER"],
					value: "METER",
					name: getLanguageStr("word1966", "求和电表数据"),
				},
				{
					id: ["EPM_SUM"],
					value: "EPM_SUM",
					name: getLanguageStr("plant439", "求和EPM数据"),
				},
				{
					id: ["HYBRID_ENERGY_SUM"],
					value: "HYBRID_ENERGY_SUM",
					name: getLanguageStr("plant440", "求和混合能源系统柜数据"),
				},
				{
					id: ["INVERTER_SUM"],
					value: "INVERTER_SUM",
					name: getLanguageStr("plant_detail128", "求和逆变器数据"),
				},
				{
					id: ["OFF_GRID_INVERTER_SUM"],
					value: "OFF_GRID_INVERTER_SUM",
					name: getLanguageStr("plant475", "求和离网逆变器数据"),
				},
				{
					id: ["null"],
					value: null,
					name: getLanguageStr("word116", "无"),
				},
			];
			break;
		case "configSelectBattery": //电池
			types = [
				// 用电
				{
					id: ["METER"],
					value: "METER",
					name: getLanguageStr("plant_detail129", "求和电表数据"),
				},
				{
					id: ["BATTERY_SUM"],
					value: "BATTERY_SUM",
					name: getLanguageStr("plant479", "求和电池数据"),
				},
				{
					id: ["HYBRID_ENERGY_SUM"],
					value: "HYBRID_ENERGY_SUM",
					name: getLanguageStr("plant440", "求和混合能源系统柜数据"),
				},
				{
					id: ["INVERTER_SUM"],
					value: "INVERTER_SUM",
					name: getLanguageStr("plant_detail128", "求和逆变器数据"),
				},
				{
					id: ["OFF_GRID_INVERTER_SUM"],
					value: "OFF_GRID_INVERTER_SUM",
					name: getLanguageStr("plant475", "求和离网逆变器数据"),
				},
				{
					id: ["null"],
					value: null,
					name: getLanguageStr("word116", "无"),
				},
			];
			break;
		case "configSelectGrid": //电网
			types = [
				// 电网
				{
					id: ["METER"],
					value: "METER",
					name: getLanguageStr("word1966", "求和电表数据"),
				},
				{
					id: ["EPM_SUM"],
					value: "EPM_SUM",
					name: getLanguageStr("plant439", "求和EPM数据"),
				},
				{
					id: ["HYBRID_ENERGY_SUM"],
					value: "HYBRID_ENERGY_SUM",
					name: getLanguageStr("plant440", "求和混合能源系统柜数据"),
				},
				{
					id: ["SMART_METER_SUM"],
					value: "SMART_METER_SUM",
					name: getLanguageStr("plant441", "求和智能表数据"),
				},
				{
					id: ["INVERTER_SUM"],
					value: "INVERTER_SUM",
					name: getLanguageStr("word1965", "求和逆变器数据"),
				},
				{
					id: ["OFF_GRID_INVERTER_SUM"],
					value: "OFF_GRID_INVERTER_SUM",
					name: getLanguageStr("plant475", "求和离网逆变器数据"),
				},
				{
					id: ["null"],
					value: null,
					name: getLanguageStr("word116", "无"),
				},
			];
			break;
		case "configIrrStatus": // 数据来源设置
			types = [
				// 线索状态
				{
					id: ["WEATHER_AVG"],
					value: "WEATHER_AVG",
					name: getLanguageStr("phrase658", "平均气象站数据"),
				},
				{
					id: ["null"],
					value: null,
					name: getLanguageStr("word116", "无"),
				},
			];
			break;
		case "currencyS":
			types = [
				// 币种
				{ id: ["19"], name: { currencyCode: "CNY", id: 19 } },
				{ id: ["51"], name: { currencyCode: "GBP", id: 51 } },
				{ id: ["73"], name: { currencyCode: "USD", id: 73 } },
				{ id: ["74"], name: { currencyCode: "EUR", id: 74 } },
				{ id: ["43"], name: { currencyCode: "JPY", id: 43 } },
				{ id: ["11"], name: { currencyCode: "KRW", id: 11 } },
				{ id: ["58"], name: { currencyCode: "HKD", id: 58 } },
				{ id: ["68"], name: { currencyCode: "THB", id: 68 } },
				{ id: ["1"], name: { currencyCode: "KWD", id: 1 } },
				{ id: ["2"], name: { currencyCode: "ZAR", id: 2 } },
				{ id: ["3"], name: { currencyCode: "UAH", id: 3 } },
				{ id: ["4"], name: { currencyCode: "AUD", id: 4 } },
				{ id: ["5"], name: { currencyCode: "CLP", id: 5 } },
				{ id: ["6"], name: { currencyCode: "CRC", id: 6 } },
				{ id: ["7"], name: { currencyCode: "QAR", id: 7 } },
				{ id: ["8"], name: { currencyCode: "DOP", id: 8 } },
				{ id: ["9"], name: { currencyCode: "YER", id: 9 } },
				{ id: ["10"], name: { currencyCode: "SAR", id: 10 } },
				{ id: ["12"], name: { currencyCode: "MAD", id: 12 } },
				{ id: ["13"], name: { currencyCode: "HNL", id: 13 } },
				{ id: ["14"], name: { currencyCode: "PAB", id: 14 } },
				{ id: ["15"], name: { currencyCode: "LBP", id: 15 } },
				{ id: ["16"], name: { currencyCode: "BAM", id: 16 } },
				{ id: ["17"], name: { currencyCode: "PEN", id: 17 } },
				{ id: ["18"], name: { currencyCode: "NZD", id: 18 } },
				{ id: ["20"], name: { currencyCode: "INR", id: 20 } },
				{ id: ["21"], name: { currencyCode: "SYP", id: 21 } },
				{ id: ["22"], name: { currencyCode: "DKK", id: 22 } },
				{ id: ["23"], name: { currencyCode: "UYU", id: 23 } },
				{ id: ["24"], name: { currencyCode: "TRY", id: 24 } },
				{ id: ["25"], name: { currencyCode: "CHF", id: 25 } },
				{ id: ["26"], name: { currencyCode: "VEF", id: 26 } },
				{ id: ["27"], name: { currencyCode: "AED", id: 27 } },
				{ id: ["28"], name: { currencyCode: "DZD", id: 28 } },
				{ id: ["29"], name: { currencyCode: "ISK", id: 29 } },
				{ id: ["30"], name: { currencyCode: "EGP", id: 30 } },
				{ id: ["31"], name: { currencyCode: "TND", id: 31 } },
				{ id: ["32"], name: { currencyCode: "HUF", id: 32 } },
				{ id: ["33"], name: { currencyCode: "CSD", id: 33 } },
				{ id: ["34"], name: { currencyCode: "JOD", id: 34 } },
				{ id: ["35"], name: { currencyCode: "SVC", id: 35 } },
				{ id: ["36"], name: { currencyCode: "ILS", id: 36 } },
				{ id: ["37"], name: { currencyCode: "TWD", id: 37 } },
				{ id: ["38"], name: { currencyCode: "CZK", id: 38 } },
				{ id: ["39"], name: { currencyCode: "ARS", id: 39 } },
				{ id: ["40"], name: { currencyCode: "ALL", id: 40 } },
				{ id: ["41"], name: { currencyCode: "NOK", id: 41 } },
				{ id: ["42"], name: { currencyCode: "COP", id: 42 } },
				{ id: ["44"], name: { currencyCode: "BYR", id: 44 } },
				{ id: ["45"], name: { currencyCode: "BHD", id: 45 } },
				{ id: ["46"], name: { currencyCode: "OMR", id: 46 } },
				{ id: ["47"], name: { currencyCode: "HRK", id: 47 } },
				{ id: ["48"], name: { currencyCode: "SDG", id: 48 } },
				{ id: ["49"], name: { currencyCode: "PYG", id: 49 } },
				{ id: ["50"], name: { currencyCode: "RON", id: 50 } },
				{ id: ["52"], name: { currencyCode: "PLN", id: 52 } },
				{ id: ["53"], name: { currencyCode: "MYR", id: 53 } },
				{ id: ["54"], name: { currencyCode: "IQD", id: 54 } },
				{ id: ["55"], name: { currencyCode: "GTQ", id: 55 } },
				{ id: ["56"], name: { currencyCode: "LYD", id: 56 } },
				{ id: ["57"], name: { currencyCode: "MXN", id: 57 } },
				{ id: ["59"], name: { currencyCode: "RUB", id: 59 } },
				{ id: ["60"], name: { currencyCode: "VND", id: 60 } },
				{ id: ["61"], name: { currencyCode: "PHP", id: 61 } },
				{ id: ["62"], name: { currencyCode: "SEK", id: 62 } },
				{ id: ["63"], name: { currencyCode: "BGN", id: 63 } },
				{ id: ["64"], name: { currencyCode: "MKD", id: 64 } },
				{ id: ["65"], name: { currencyCode: "NIO", id: 65 } },
				{ id: ["66"], name: { currencyCode: "RSD", id: 66 } },
				{ id: ["67"], name: { currencyCode: "CAD", id: 67 } },
				{ id: ["69"], name: { currencyCode: "SGD", id: 69 } },
				{ id: ["70"], name: { currencyCode: "BRL", id: 70 } },
				{ id: ["71"], name: { currencyCode: "IDR", id: 71 } },
				{ id: ["72"], name: { currencyCode: "BOB", id: 72 } },
				{ id: ["75"], name: { currencyCode: "MUR", id: 75 } },
			];
			break;
		case "customerSource":
			types = [
				// 客户来源
				{ id: ["1"], name: getLanguageStr("word1224", "客户介绍") },
				{ id: ["2"], name: getLanguageStr("assess8", "公司资源") },
				{ id: ["3"], name: getLanguageStr("assess9", "展会资源") },
				{ id: ["4"], name: getLanguageStr("assess10", "个人资源") },
				{ id: ["5"], name: getLanguageStr("assess11", "电话咨询") },
				{ id: ["6"], name: getLanguageStr("word1227", "线上注册") },
				{ id: ["7"], name: getLanguageStr("word1228", "其他方式") },
			];
			break;
		case "customerStatus":
			types = [
				// 客户状态
				{
					id: ["1"],
					name: [getLanguageStr("word1254", "新客户"), "label-warning"],
				},
				{
					id: ["5"],
					name: [getLanguageStr("word1255", "线索客户"), "label-primary"],
				},
				{
					id: ["9"],
					name: [getLanguageStr("word1256", "成交客户"), "label-success"],
				},
				// {id:["0"],name:['废弃客户',"label-fail"]}
			];
			break;
		case "customerType":
			types = [
				// 客户类型
				{ id: ["1"], name: getLanguageStr("word1547", "个人用户") },
				{ id: ["2"], name: getLanguageStr("word1231", "商家用户") },
			];
			break;
		case "codeType":
			types = [
				// 指令类型
				{
					id: ["1"],
					name: getLanguageStr("device292", "单个参数设置"),
					value: 1,
				},
				{
					id: ["2"],
					name: getLanguageStr("device293", "批量参数设置"),
					value: 2,
				},
				{
					id: ["3"],
					name: getLanguageStr("device294", "自定义命令"),
					value: 3,
				},
			];
			break;
		case "dataloggerTypes":
			types = [
				// 采集器类型/采集器通信方式	(过滤器的参数,判断是过滤哪组数据)
				{ id: ["12", "1", "2", "5", "6"], name: "GPRS" }, // id:被过滤值的范围(id[0]可用来定义select中的value)	name:过滤后的内容(文本)/select中显示的文字
				{ id: ["3"], name: "WIFI" },
				{ id: ["4"], name: getLanguageStr("device250", "以太网") },
			];
			break;
		case "deviceModelS":
			types = [
				// 设备型号
				{ id: ["983047"], name: "PSI1.1K-6K Series" },
				{ id: ["983048"], name: "PSI5.5K-30K Series" },
				{ id: ["300"], name: "SUN2000L-5KTL" },
				{ id: ["301"], name: "SUN2000L-4.6KTL" },
				{ id: ["302"], name: "SUN2000L-4KTL" },
				{ id: ["303"], name: "SUN2000L-3.68KTL" },
				{ id: ["304"], name: "SUN2000L-3KTL" },
				{ id: ["305"], name: "SUN2000L-2KTL" },
				{ id: ["306"], name: "SUN2000L-5KTL-CN" },
				{ id: ["307"], name: "SUN2000L-5KTL-CN-4G" },
				{ id: ["308"], name: "SUN2000L-4KTL-CN" },
				{ id: ["309"], name: "SUN2000L-4KTL-CN-4G" },
				{ id: ["310"], name: "SUN2000L-3KTL-CN" },
				{ id: ["311"], name: "SUN2000L-3KTL-CN-4G" },
			];
			break;
		case "deviceInTimeS":
			types = [
				// 入库时间
				{ id: ["1"], name: getLanguageStr("phrase223", "1小时内") },
				{ id: ["2"], name: getLanguageStr("phrase224", "12小时内") },
				{ id: ["3"], name: getLanguageStr("phrase225", "24小时内") },
				{ id: ["4"], name: getLanguageStr("phrase226", "7天内") },
				{ id: ["5"], name: i18n.t("fill3rdPay1", [1, "最近1月"]) },
				{ id: ["6"], name: getLanguageStr("phrase228", "最近1年") },
			];
			break;
		case "deviceIdToDirectory":
			types = [
				// 文件目录
				{ id: ["1"], name: "inverter" },
				{ id: ["99"], name: "dataLogger" },
				{ id: ["13"], name: "dtu" },
				{ id: ["14"], name: "repeater" },
				{ id: ["15"], name: "inverterMicro" },
				{ id: ["16"], name: "comp" },
				{ id: ["4"], name: "meteoStation" },
				{ id: ["5"], name: "ammeter" },
				{ id: ["17"], name: "power" },
				{ id: ["3"], name: "battery" },
			];
			break;
		case "deviceOperateType":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("word632+word1545", "读取指令"),
				},
				{
					id: ["2"],
					name: getLanguageStr("cmd16+word1545", "设置指令"),
				},
				{ id: ["3"], name: getLanguageStr("word639", "自定义") },
			];
			break;
		case "deviceOrderStatus": //设备指令状态
			types = [
				{
					id: ["0"],
					name: getLanguageStr("task36", "待发送"),
					value: "0",
				},
				{
					id: ["100"],
					name: getLanguageStr("word1542", "发送中"),
					value: "100",
				},
				{
					id: ["300"],
					name: getLanguageStr("task78", "升级中"),
					value: "300",
				},
				{
					id: ["400"],
					name: getLanguageStr("task80", "已终止"),
					value: "400",
				},
				{
					id: ["500"],
					name: getLanguageStr("word202", "已失败"),
					value: "500",
				},
				{
					id: ["666"],
					name: getLanguageStr("word201", "已成功"),
					value: "666",
				},
			];
			break;
		case "deviceOrderType":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("cmd173", "远程控制"),
					value: "1",
				},
				{
					id: ["2"],
					name: getLanguageStr("cmd21", "固件升级"),
					value: "2",
				},
			];
			break;
		case "deviceRecordType":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("word724", "网关/采集器"),
					value: "1",
				},
				{
					id: ["2"],
					name: getLanguageStr("word1544", "普通设备"),
					value: "2",
				},
			];
			break;
		case "deviceState": //设备状态
			types = [
				// {id:['0'],name: getLanguageStr('word94', '未激活'),value: 0},
				{
					id: ["1"],
					name: getLanguageStr("word1588", "在线"),
					value: 1,
				},
				{ id: ["2"], name: getLanguageStr("plant_alert59", "报警"), value: 2 },
				{ id: ["3"], name: getLanguageStr("word64", "离线"), value: 3 },
			];
			break;
		case "deviceTypeForPAAS":
			types = [
				{
					value: null,
					name: getLanguageStr("cmd19", "全部"),
					def: getLanguageStr("word75", "类型"),
				},
				{
					id: ["INVERTER", "1"],
					value: "INVERTER",
					name: getLanguageStr("word35", "逆变器"),
				},
				{
					id: ["COLLECTOR", "18", "99"],
					value: "COLLECTOR",
					name: getLanguageStr("word34", "采集器"),
				},
				{
					id: ["METER", "5"],
					value: "METER",
					name: getLanguageStr("word39", "电表"),
				},
				{
					id: ["BATTERY", "3"],
					value: "BATTERY",
					name: getLanguageStr("word37", "电池"),
				},
				{
					id: ["PV_MODULE", "16"],
					value: "PV_MODULE",
					name: getLanguageStr("word647", "组件"),
				},
				{
					id: ["COMBINER_BOX", "2"],
					value: "COMBINER_BOX",
					name: getLanguageStr("word36", "汇流箱"),
				},
				{
					id: ["WEATHER_STATION", "4"],
					value: "WEATHER_STATION",
					name: getLanguageStr("word38", "气象站"),
				},
				{
					id: ["MICRO_INVERTER", "15"],
					value: "MICRO_INVERTER",
					name: getLanguageStr("word804", "微逆"),
				},
				{
					id: ["SMART_METER", "26"],
					value: "SMART_METER",
					name: getLanguageStr("plant444", "智能表"),
				},
				{
					id: ["SOLAR_TRACKING_CONTROLLER", "11"],
					value: "SOLAR_TRACKING_CONTROLLER",
					name: getLanguageStr("device332", "太阳能支架"),
				},
				{
					id: ["TYPE_RF_SUB_DEVICE", "27"],
					value: "TYPE_RF_SUB_DEVICE",
					name: getLanguageStr("device333", "RF子设备"),
				},
				{
					id: ["TYPE_OFF_GRID_INVERTER", "28"],
					value: "TYPE_OFF_GRID_INVERTER",
					name: getLanguageStr("device391", "离网逆变器"),
				},
				{
					id: ["EPM", "23"],
					value: "EPM",
					name: getLanguageStr("plant443", "EPM"),
				},
				{
					id: ["DTU", "13"],
					value: "DTU",
					name: getLanguageStr("word802", "DTU"),
				},
				{
					id: ["REPEATER", "14"],
					value: "REPEATER",
					name: getLanguageStr("word803", "中继器"),
				},
				{
					id: ["ELECTRIC_SOURCE", "17"],
					value: "ELECTRIC_SOURCE",
					name: getLanguageStr("word876", "电源"),
				},
				{
					id: ["QUALITY_MONITOR", "9"],
					value: "QUALITY_MONITOR",
					name: getLanguageStr("word43", "质量监控"),
				},
				{
					id: ["HARMONIC_METER", "8"],
					value: "HARMONIC_METER",
					name: getLanguageStr("word42", "谐波表"),
				},
				{
					id: ["SMART_HOME", "10"],
					value: "SMART_HOME",
					name: getLanguageStr("word44", "智能家居"),
				},
				{
					id: ["AIR_CONDITIONING", "6"],
					value: "AIR_CONDITIONING",
					name: getLanguageStr("word40", "空调"),
				},
				{
					id: ["FAN", "19"],
					value: "FAN",
					name: getLanguageStr("word1819", "风机"),
				},
				{
					id: ["WATER_PUMP", "20"],
					value: "WATER_PUMP",
					name: getLanguageStr("word1820", "水泵"),
				},
				{
					id: ["HYBRID_POWER_SYSTEM_CABINET", "21"],
					value: "HYBRID_POWER_SYSTEM_CABINET",
					name: getLanguageStr("word1821", "混合能源系统柜"),
				},
				{
					id: ["GAS_METER", "24"],
					value: "GAS_METER",
					name: getLanguageStr("device299", "燃气传感器"),
				},
				{
					id: ["OTHER_TYPE", "0"],
					value: "OTHER_TYPE",
					name: getLanguageStr("word54", "其他"),
				},
			];
			break;
		case "deviceType":
			types = [
				// 设备类型,countField:统计接口返回的字段对应
				{
					id: ["INVERTER", "1"],
					name: getLanguageStr("word35", "逆变器"),
					countField: "inverterCount",
				},
				{
					id: ["COLLECTOR", "18"],
					name: getLanguageStr("word34", "采集器"),
					countField: "collectorCount",
				},
				{
					id: ["METER", "5"],
					name: getLanguageStr("word39", "电表"),
					countField: "meterCount",
				},
				{
					id: ["TYPE_OFF_GRID_INVERTER", "28"],
					value: "TYPE_OFF_GRID_INVERTER",
					name: getLanguageStr("device391", "离网逆变器"),
				},
				{
					id: ["BATTERY", "3"],
					name: getLanguageStr("word37", "电池"),
					countField: "batteryCount",
				},
				{
					id: ["PV_MODULE", "16"],
					name: getLanguageStr("word647", "组件"),
					countField: "pvModuleCount",
				},
				{
					id: ["COMBINER_BOX", "2"],
					name: getLanguageStr("word36", "汇流箱"),
					countField: "combinerBoxCount",
				},
				{
					id: ["WEATHER_STATION", "4"],
					name: getLanguageStr("word38", "气象站"),
					countField: "weatherStationCount",
				},
				{
					id: ["MICRO_INVERTER", "15"],
					name: getLanguageStr("word804", "微逆"),
					countField: "microInverterCount",
				},
				{
					id: ["SMART_METER", "26"],
					name: getLanguageStr("plant444", "智能表"),
					countField: "smartMeterCount",
				},
				{
					id: ["SOLAR_TRACKING_CONTROLLER", "11"],
					name: getLanguageStr("device332", "太阳能支架"),
					countField: "",
				},
				{
					id: ["SOLAR_TRACKING_CONTROLLER", "27"],
					name: getLanguageStr("device333", "RF子设备"),
					countField: "",
				},
				{
					id: ["DTU", "13"],
					name: getLanguageStr("word802", "DTU"),
					countField: "dtuCount",
				},
				{
					id: ["REPEATER", "14"],
					name: getLanguageStr("word803", "中继器"),
					countField: "repeaterCount",
				},
				{
					id: ["ELECTRIC_SOURCE", "17"],
					name: getLanguageStr("word876", "电源"),
					countField: "",
				},
				{
					id: ["QUALITY_MONITOR", "9"],
					name: getLanguageStr("word43", "质量监控"),
					countField: "",
				},
				{
					id: ["HARMONIC_METER", "8"],
					name: getLanguageStr("word42", "谐波表"),
					countField: "",
				},
				{
					id: ["SMART_HOME", "10"],
					name: getLanguageStr("word44", "智能家居"),
					countField: "",
				},
				{
					id: ["AIR_CONDITIONING", "6"],
					name: getLanguageStr("word40", "空调"),
					countField: "",
				},
				{
					id: ["FAN", "19"],
					name: getLanguageStr("word1819", "风机"),
					countField: "fanCount",
				},
				{
					id: ["WATER_PUMP", "20"],
					name: getLanguageStr("word1820", "水泵"),
					countField: "",
				},
				{
					id: ["HYBRID_POWER_SYSTEM_CABINET", "21"],
					name: getLanguageStr("word1821", "混合能源系统柜"),
					countField: "hybridPowerCount",
				},
				{
					id: ["GAS_METER", "24"],
					name: getLanguageStr("device299", "燃气传感器"),
					countField: "",
				},
				{
					id: ["OTHER_TYPE", "0"],
					name: getLanguageStr("word54", "其他"),
					countField: "",
				},
				{
					id: ["EPM", "23"],
					name: getLanguageStr("plant443", "EPM"),
					countField: "epmCount",
				},
				{
					id: ["STEAM_ENGINE", "22"],
					name: getLanguageStr("device327", "蒸汽机"),
					countField: "",
				},
				{
					id: ["GAS_METER", "24"],
					name: getLanguageStr("device299", "燃气传感器"),
					countField: "",
				},
				{
					id: ["SOLAR_TRACKING_CONTROLLER", "11"],
					value: "SOLAR_TRACKING_CONTROLLER",
					name: getLanguageStr("device332", "太阳能支架"),
				},
				{
					id: ["TYPE_RF_SUB_DEVICE", "27"],
					value: "TYPE_RF_SUB_DEVICE",
					name: getLanguageStr("device333", "RF子设备"),
				},
				//				{ id: ["11", "SOLAR_TRACKING_CONTROLLER"], name: getLanguageStr("word35", "太阳能跟踪器控制器") },
				//				{ id: ["12", "SOLAR_RADIATION_SPECTROMETER"], name: getLanguageStr("word35", "太阳能辐射光谱仪") },
			];
			break;
		case "deviceCapability": //设备性能
			types = [
				{
					id: ["DOWN"],
					name: getLanguageStr("plant412", "停机"),
					fontClass: "cFail",
				},
				{
					id: ["TOO_LOW"],
					name: getLanguageStr("plant411", "过低"),
					fontClass: "cError",
				},
				{
					id: ["LOW"],
					name: getLanguageStr("plant410", "偏低"),
					fontClass: "cDanger",
				},
				{
					id: ["NORMAL"],
					name: getLanguageStr("plant409", "正常"),
					fontClass: "cSuccess",
				},
			];
			break;
		case "directionOrder":
			types = [
				{ id: "DESC", name: i18n.t("fill3rd127", [10, "前10名"]) },
				{ id: "ASC", name: i18n.t("fill3rd128", [10, "后10名"]) },
			];
			break;
		case "domainC2B":
			types = [
				// 域名C2B
				{
					id: ["m.ginlong.com", "glhome.solarman.cn"],
					name: "pv.ginlong.com",
				}, // 锦浪
				{ id: ["log1.trannergy.com"], name: "monitor.trannergy.com" }, // 兆能
				{ id: ["v2.omnikportal.com"], name: "monitor.omnikpower.com" }, // 欧姆尼克
			];
			break;
		case "errorReason":
			types = [
				{ id: ["501"], name: getLanguageStr("task65", "指令任务冲突") },
				{
					id: ["502"],
					name: getLanguageStr("task68", "设备不属于该产品"),
				},
				{ id: ["505"], name: getLanguageStr("task69", "系统错误") },
				{ id: ["510"], name: getLanguageStr("task67", "解析结果失败") },
				{ id: ["511"], name: getLanguageStr("manage484", "无效版本号") },
				{ id: ["530"], name: getLanguageStr("task66", "指令发送失败") },
				{ id: ["570"], name: getLanguageStr("device393", "固件包下载失败") },
				{ id: ["571"], name: getLanguageStr("device394", "固件校验错误") },
				{ id: ["572"], name: getLanguageStr("device395", "固件名错误") },
				{ id: ["573"], name: getLanguageStr("device396", "设备交互失败") },
			];
			break;
		case "errorReasonMobile":
			types = [
				{ id: ["501"], name: getLanguageStr("task65", "指令任务冲突") },
				{
					id: ["502"],
					name: getLanguageStr("task68", "设备不属于该产品"),
				},
				{ id: ["505"], name: getLanguageStr("task69", "系统错误") },
				{ id: ["510"], name: getLanguageStr("device412", "指令已成功下发，设备未响应或响应结果与预期不符，请查看设备实际数据进行核实；") },
				{ id: ["511"], name: getLanguageStr("manage484", "无效版本号") },
				{ id: ["530"], name: getLanguageStr("device411", "指令未能成功下发，可能是网络问题，建议确认设备正常连接后重发；") },
				{ id: ["570"], name: getLanguageStr("device393", "固件包下载失败") },
				{ id: ["571"], name: getLanguageStr("device394", "固件校验错误") },
				{ id: ["572"], name: getLanguageStr("device395", "固件名错误") },
				{ id: ["573"], name: getLanguageStr("device396", "设备交互失败") },
			];
			break;
		case "errorS":
			types = [
				{
					id: ["required"],
					name: getLanguageStr("phrase3", "不能为空"),
				},
				{
					id: ["acOrPwError"],
					name: getLanguageStr("phrase28", "用户名或密码错误"),
				},
			];
			break;
		case "estimateInstalledCapacity":
			types = [
				// 装机容量
				{ id: ["0~3"], name: "<3 " + getLanguageStr("unit11", "kWp") },
				{ id: ["3~6"], name: "3~6 " + getLanguageStr("unit11", "kWp") },
				{ id: ["6~9"], name: "6~9 " + getLanguageStr("unit11", "kWp") },
				{
					id: ["9~12"],
					name: "9~12 " + getLanguageStr("unit11", "kWp"),
				},
				{
					id: ["12~-1"],
					name: ">12 " + getLanguageStr("unit11", "kWp"),
				},
			];
			break;
		case "followStateS":
			types = [
				// 全部关注状态、已关注、未关注
				{
					id: [""],
					value: null,
					name: getLanguageStr("cmd19", "全部"),
					def: getLanguageStr("word1466", "关注状态"),
				},
				{
					id: ["true"],
					value: "true",
					name: getLanguageStr("word1467", "已关注"),
				},
				{
					id: ["false"],
					value: "false",
					name: getLanguageStr("word1468", "未关注"),
				},
			];
			break;
		// "filterKey":[
		// 	{id:["customerType"],name:""},
		// 	{id:["0"],name:""}
		// ],
		case "frequency":
			types = [
				{ id: ["1"], name: "1", value: 1 },
				{ id: ["2"], name: "3", value: 3 },
				{ id: ["3"], name: "5", value: 5 },
			];
			break;
		case "infoBrand":
			types = [
				{ id: ["1"], name: "SOLARMAN", value: 1 },
				{ id: ["2"], name: "Growatt", value: 2 },
				{ id: ["3"], name: "Talent-M", value: 3 },
			];
			break;
		case "inspectLevel": // 体检级别
			types = [
				{
					id: ["A", "50"],
					name: {
						name: "",
						color: "#49cb77",
						valueForShow: 50,
						levelClass: "A",
						description: getLanguageStr("diagnosis40", "未发现电站异常与设备故障"),
					},
				},
				{
					id: ["B", "40"],
					name: {
						name: "",
						color: "#01cbcd",
						valueForShow: 40,
						levelClass: "B",
						description: getLanguageStr("diagnosis41", "电站可能存在故障，需要继续观察"),
					},
				},
				{
					id: ["C", "30"],
					name: {
						name: "",
						color: "#0093ff",
						valueForShow: 30,
						levelClass: "C",
						description: getLanguageStr("diagnosis42", "电站数据质量存在问题，不足以判断电站状态"),
					},
				},
				{
					id: ["D", "20"],
					name: {
						name: "",
						color: "#ffd200",
						valueForShow: 20,
						levelClass: "D",
						description: getLanguageStr("diagnosis43", "设备出现故障且影响电站发电"),
					},
				},
				{
					id: ["E", "10"],
					name: {
						name: "",
						color: "#ff6102",
						valueForShow: 10,
						levelClass: "E",
						description: getLanguageStr("diagnosis44", "电站存在安全隐患"),
					},
				},
			];
			break;
		case "inspectMethod": // 体检方式
			types = [
				{
					id: ["OFFLINE"],
					name: getLanguageStr("diagnosis62", "离线体检"),
				},
			];
			break;
		case "inspectProjectResult": // 体检类型
			types = [
				{
					id: ["PASS"],
					name: {
						text: getLanguageStr("diagnosis251", "通过"),
						class: "cSuccess",
					},
				},
				{
					id: ["FAIL"],
					name: {
						text: getLanguageStr("diagnosis252", "不通过"),
						class: "cError",
					},
				},
				{
					id: ["UNEXECUTE"],
					name: {
						text: getLanguageStr("diagnosis253", "未执行"),
						class: "cDanger",
					},
				},
				{
					id: ["OBSERVE"],
					name: {
						text: getLanguageStr("diagnosis254", "建议继续观察"),
						class: "cPrimary",
					},
				},
			];
			break;
		case "inspectProjectType": // 体检项类型
			types = [
				{ id: ["FB"], name: getLanguageStr("diagnosis18", "发电质量") },
				{ id: ["FA"], name: getLanguageStr("diagnosis17", "数据质量") },
				{ id: ["FC"], name: getLanguageStr("diagnosis19", "安全隐患") },
			];
			break;
		case "inspectResult": // 体检项类型
			types = [
				{
					id: ["FA_PASS"],
					name: getLanguageStr("diagnosis241", "电站数据质量合格"),
				},
				{
					id: ["FA_FAIL"],
					name: getLanguageStr("diagnosis242+, +diagnosis243", "电站数据质量不合格，影响发电质量检查和安全隐患检查"),
				},
				{
					id: ["FB_PASS"],
					name: getLanguageStr("diagnosis244", "电站发电正常且未发现设备异常"),
				},
				{
					id: ["FB_FAIL"],
					name: getLanguageStr("diagnosis245", "电站发电偏低且存在设备异常"),
				},
				{
					id: ["FB_UNEXECUTE"],
					name: getLanguageStr("diagnosis242+, +diagnosis246", "电站数据质量不合格，不进行发电质量检查"),
				},
				{
					id: ["FB_OBSERVE"],
					name: getLanguageStr("diagnosis247", "电站发电质量需要继续观察"),
				},
				{
					id: ["FC_PASS"],
					name: getLanguageStr("diagnosis248", "电站安全隐患检查合格"),
				},
				{
					id: ["FC_FAIL"],
					name: getLanguageStr("diagnosis249", "电站存在安全隐患"),
				},
				{
					id: ["FC_UNEXECUTE"],
					name: getLanguageStr("diagnosis242+, +diagnosis250", "电站数据质量不合格，不进行安全隐患检查"),
				},
			];
			break;
		case "inspectType": // 体检类型
			types = [{ id: ["STATION"], name: getLanguageStr("word204", "电站") }];
			break;
		case "inverterPerformance": //逆变器性能
			types = [
				{ id: ["NORMAL"], name: getLanguageStr("plant409", "正常") },
				{ id: ["LOW"], name: getLanguageStr("plant410", "偏低") },
				{ id: ["TOO_LOW"], name: getLanguageStr("plant411", "过低") },
				{ id: ["DOWN"], name: getLanguageStr("plant412", "停机") },
			];
			break;
		case "instructionsobject": // 体检级别
			types = [
				{
					id: ["1"],
					name: getLanguageStr("word34", "采集器"),
					value: "1",
				},
				{
					id: ["2"],
					name: getLanguageStr("control40", "485设备"),
					value: "2",
				},
				{
					id: ["3"],
					name: getLanguageStr("control41", "通讯地址可变的485设备"),
					value: "3",
				},
			];
			break;
		case "isActS":
			types = [
				// 激活状态
				{
					id: ["1"],
					value: 1,
					name: getLanguageStr("word93", "已激活"),
				},
				{
					id: ["0"],
					value: 0,
					name: getLanguageStr("word94", "未激活"),
				},
			];
			break;
		case "itemStatusS":
			types = [
				// 状态
				{ id: ["1"], name: getLanguageStr("wordPay16", "未付款") },
				{ id: ["2"], name: getLanguageStr("wordPay17", "支付成功") },
				{ id: ["3"], name: getLanguageStr("wordPay28", "支付失败") },
				// {id:["4"],name:getLanguageStr("cmd85","取消")},
				{ id: ["5"], name: getLanguageStr("wordPay19", "过期") },
			];
			break;
		case "maintenanceObject":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("word164", "设备"),
					value: 1,
				},
				{ id: ["2"], name: getLanguageStr("word54", "其他"), value: 2 },
			];
			break;
		case "mainTenanceObject": // 体检方式
			types = [
				{ id: ["device"], name: getLanguageStr("word164", "设备") },
				{ id: ["other"], name: getLanguageStr("word54", "其他") },
			];
			break;
		case "maintenanceSystem":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("word204", "电站"),
					value: 1,
				},
			];
			break;
		case "mainTenanceType": // 维保系统
			types = [{ id: ["STATION"], name: getLanguageStr("word204", "电站") }];
			break;
		case "messageType":
			types = [
				// 消息类型
				{ id: ["1"], name: getLanguageStr("word1065", "系统通知") },
				{ id: ["2"], name: getLanguageStr("word27", "报警") },
				// {id:["3"],name:getLanguageStr("word","电站被关注")},
				// {id:["4"],name:getLanguageStr("word","用户被关注")},
				{ id: ["5"], name: getLanguageStr("cmd72", "新建电站") },
				// {id:["6"],name:getLanguageStr("word","电站被赞")},
				{ id: ["7"], name: getLanguageStr("phrase497", "设置成功") }, // 设备
				{ id: ["8"], name: getLanguageStr("phrase498", "设置失败") }, // 设备
				{
					id: ["9"],
					name: getLanguageStr("phrase187", "电站已添加设备"),
				},
				{ id: ["10"], name: getLanguageStr("device3", "设备离线") },
				{ id: ["11"], name: getLanguageStr("device235", "采集器离线") },
				{ id: ["12"], name: getLanguageStr("plant286", "电站离线") },
				{ id: ["13"], name: getLanguageStr("plant287", "报警统计") },
				{
					id: ["14", "15"],
					name: getLanguageStr("word28", "电站通知"),
				},
			];
			break;
		case "Month":
			types = [
				{ id: ["1"], name: getLanguageStr("1月", "1月") },
				{ id: ["2"], name: getLanguageStr("2月", "2月") },
				{ id: ["3"], name: getLanguageStr("3月", "3月") },
				{ id: ["4"], name: getLanguageStr("4月", "4月") },
				{ id: ["5"], name: getLanguageStr("5月", "5月") },
				{ id: ["6"], name: getLanguageStr("6月", "6月") },
				{ id: ["7"], name: getLanguageStr("7月", "7月") },
				{ id: ["8"], name: getLanguageStr("8月", "8月") },
				{ id: ["9"], name: getLanguageStr("9月", "9月") },
				{ id: ["10"], name: getLanguageStr("10月", "10月") },
				{ id: ["11"], name: getLanguageStr("11月", "11月") },
				{ id: ["12"], name: getLanguageStr("12月", "12月") },
			];
			break;
		case "noticeType":
			types = [
				{ id: ["ALARM"], name: getLanguageStr("word1955", "报警消息") },
				{
					id: ["REMINDER"],
					name: getLanguageStr("提醒消息", "提醒消息"),
				},
				{
					id: ["APPROVAL"],
					name: getLanguageStr("审批消息", "审批消息"),
				},
			];
			break;
		case "net":
			types = [
				{ id: ["1"], name: "AP", value: 1 },
				{ id: ["2"], name: "Smart-Link", value: 2 },
				{ id: ["3"], name: "WiFi-S", value: 3 },
			];
			break;
		case "NETCONF":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("device100", "自动"),
					value: 1,
				},
				{
					id: ["2"],
					name: getLanguageStr("device101", "手动"),
					value: 2,
				},
			];
			break;
		case "netStatus":
			types = [
				// 通讯状态
				{
					id: ["NORMAL"],
					name: getLanguageStr("word1461", "通讯正常"),
				},
				{
					id: ["ALL_OFFLINE"],
					name: getLanguageStr("word1659", "全部设备离线"),
				},
				{
					id: ["PARTIAL_OFFLINE"],
					name: getLanguageStr("word1677", "部分设备离线"),
				},
				{
					id: ["NO_DEVICE"],
					name: getLanguageStr("word1269", "接入中"),
				},
			];
			break;
		case "network": //设备指令状态
			types = [
				{
					id: ["100"],
					name: getLanguageStr("Networking9", "组网中"),
					value: "100",
				},
				{
					id: ["500"],
					name: getLanguageStr("plant_detail169", "已失败"),
					value: "500",
				},
				{
					id: ["666"],
					name: getLanguageStr("plant_detail168", "已成功"),
					value: "666",
				},
			];
			break;
		case "networkStatus":
			types = [
				//网络状态
				{
					id: ["1"],
					name: getLanguageStr("word1588", "在线"),
					value: 1,
				},
				{
					id: ["0", "OFFLINE"],
					name: getLanguageStr("word64", "离线"),
					value: 0,
				},
			];
			break;
		case "networkType":
			types = [
				{ id: ["1"], name: "GPRS", value: 1 },
				{ id: ["2"], name: "WiFi", value: 2 },
				{ id: ["3"], name: "Ethernet", value: 3 },
				{ id: ["4"], name: "4G", value: 4 },
				{ id: ["5"], name: "CDMA", value: 5 },
				{ id: ["6"], name: "WCDMA", value: 6 },
				{ id: ["7"], name: "NB-IoT", value: 7 },
			];
			break;
		case "orgType": // 账号所属类型
			types = [
				{ id: ["1"], name: getLanguageStr("word1713", "企业商家") },
				{ id: ["2"], name: getLanguageStr("word1714", "个人商家") },
			];
			break;
		case "parDeviceState":
			types = [
				{
					id: ["4"],
					name: getLanguageStr("cmd19", "全部"),
					value: null,
				},
				{
					id: ["1"],
					name: getLanguageStr("word1588", "在线"),
					value: 1,
				},
				{ id: ["2"], name: getLanguageStr("plant_alert59", "报警"), value: 2 },
				{ id: ["3"], name: getLanguageStr("word64", "离线"), value: 3 },
			];
			break;
		case "productS":
			types = [
				// 产品
				{
					id: ["1"],
					name: getLanguageStr("brand26+word80", "兆伏单相"),
				},
				{ id: ["2"], name: getLanguageStr("brand18", "锦浪") },
				{ id: ["3"], name: getLanguageStr("brand18", "锦浪") },
				{ id: ["4"], name: getLanguageStr("brandEX1", "水晶石") },
				{
					id: ["5"],
					name: getLanguageStr("brand35+word81", "艾伏三相"),
				},
				{
					id: ["6"],
					name: getLanguageStr("brand35+word80", "艾伏单相"),
				},
				{
					id: ["7"],
					name: getLanguageStr("brand35+word81+(1E05)", "艾伏三相(1E05)"),
				},
				{
					id: ["8"],
					name: getLanguageStr("brand35+word81", "艾伏三相"),
				},
				{ id: ["9"], name: getLanguageStr("brand7", "首航") },
				{ id: ["10"], name: getLanguageStr("brand7+50-70kW", "首航") },
				{
					id: ["11"],
					name: getLanguageStr("brand26+word81", "兆伏三相"),
				},
				{
					id: ["12"],
					name: getLanguageStr("word80+word1274", "单相储能"),
				},
				{
					id: ["13"],
					name: getLanguageStr("word81+word1274", "三相储能"),
				},
				{
					id: ["14"],
					name: getLanguageStr("word80+word1053", "单相光伏"),
				},
				{
					id: ["15"],
					name: getLanguageStr("word81+word1053", "三相光伏"),
				},
				{
					id: ["16"],
					name: getLanguageStr("brand17+brandEX2", "易事特小蜜蜂"),
				},
				{ id: ["17"], name: getLanguageStr("brand37", "阿瑟顿") },
				{ id: ["18"], name: "Presola" },
			];
			break;
		case "paramType":
			types = [
				// 产品
				{ id: ["1"], name: getLanguageStr("device339", "协议参数") },
				{ id: ["2"], name: getLanguageStr("device340", "自定义参数") },
			];
			break;
		case "realDataRange":
			types = [
				// 产品
				{ id: ["0"], name: getLanguageStr("device207", "无") },
				{ id: ["1"], name: getLanguageStr("device341", "外部商家") },
				{ id: ["2"], name: getLanguageStr("device338", "终端用户") },
			];
			break;
		case "planHistoryStatus":
			types = [
				// 计划历史状态
				{ id: ["WAIT"], name: "审批中" },
				{ id: ["REJECT"], name: "审批未通过" },
				{ id: ["CURRENT"], name: "执行中" },
				{ id: ["HISTORY"], name: "历史记录" },
				{ id: ["END"], name: "执行结束" },
			];
			break;
		case "planStatus":
			types = [
				// 计划状态
				{ id: ["INIT"], name: "未开始" },
				{ id: ["DOING"], name: "进行中" },
				{ id: ["FINISHED"], name: "已完成" },
			];
			break;
		case "plantArea":
			types = [
				// 电站面积
				{ id: ["0~50"], name: "<50" + getLanguageStr("unit39", "m²") },
				{
					id: ["50~100"],
					name: "50~100" + getLanguageStr("unit39", "m²"),
				},
				{
					id: ["100~150"],
					name: "100~150" + getLanguageStr("unit39", "m²"),
				},
				{
					id: ["150~200"],
					name: "150~200" + getLanguageStr("unit39", "m²"),
				},
				{
					id: ["200~-1"],
					name: ">200" + getLanguageStr("unit39", "m²"),
				},
			];
			break;
		case "plantFieldS":
			types = [
				// 电站字段设置
				{ id: ["status"], name: getLanguageStr("word166", "状态") },
				{
					id: ["nameAddress"],
					name: getLanguageStr("plant139", "名称/位置"),
				},
				{ id: ["type"], name: getLanguageStr("word728", "电站类型") },
				{ id: ["power"], name: getLanguageStr("word727", "装机容量") },
				{ id: ["user"], name: getLanguageStr("word731", "业主信息") },
				{
					id: ["curPower"],
					name: getLanguageStr("word176", "发电功率"),
				},
				{
					id: ["energyToday"],
					name: getLanguageStr("word358", "当日发电量"),
				},
				{
					id: ["drfdqs"],
					name: getLanguageStr("word732", "当日发电趋势"),
				},
				{
					id: ["alarm"],
					name: getLanguageStr("word915", "今日最新报警"),
				},
				{
					id: ["updateTime"],
					name: getLanguageStr("word701", "最近更新时间"),
				},
			];
			break;
		case "plantStatus":
			types = [
				// 电站状态
				{
					id: ["BUILDING"],
					name: getLanguageStr("word1641", "接入中电站"),
				}, // 建设中
				{
					id: ["OFFLINE", "2"],
					name: getLanguageStr("word1462", "全部设备离线电站"),
					title: getLanguageStr("phrase593", "电站下所有设备均离线"),
				},
				{
					id: ["PARTIALOFFLINE"],
					name: getLanguageStr("word1463", "部分设备离线电站"),
					title: getLanguageStr("phrase595", "电站下部分设备离线了"),
				},
				{
					id: ["NORMAL", "1"],
					name: getLanguageStr("word1640", "通讯正常电站"),
				},
				// {id:["ALERT"],name:getLanguageStr("plant_alert59","报警")}
			];
			break;
		case "plantType":
			types = [
				// 电站类型
				{
					id: ["HOUSE_ROOF", "HOME"],
					name: getLanguageStr("word738", "家用屋顶"),
					value: "HOUSE_ROOF",
				},
				{
					id: ["COMMERCIAL_ROOF", "BUSINESS"],
					name: getLanguageStr("word739", "商业用屋顶"),
					value: "COMMERCIAL_ROOF",
				},
				{
					id: ["INDUSTRIAL_ROOF", "INDUSTRY"],
					name: getLanguageStr("word740", "工业用屋顶"),
					value: "INDUSTRIAL_ROOF",
				},
				{
					id: ["GROUND", "4"],
					name: getLanguageStr("word737", "地面电站"),
					value: "GROUND",
				},
				// { id: ["POVERTY_ALLEVIATION"],name:getLanguageStr("扶贫电站","扶贫电站")}
			];
			break;
		case "plantGridType":
			types = [
				// 电站并网类型
				{
					id: ["DISTRIBUTED_FULLY", "1"],
					name: getLanguageStr("word741", "分布式全额上网"),
					value: "DISTRIBUTED_FULLY",
				},
				{
					id: ["EXCESS", "2"],
					name: getLanguageStr("word742", "分布式自发自用余电上网"),
					value: "EXCESS",
				},
				// {id:["OFF_GRID","3"],name:getLanguageStr("word743","离网")},
				{
					id: ["BATTERY_BACKUP", "4"],
					name: getLanguageStr("word308", "储能系统"),
					value: "BATTERY_BACKUP",
				},
				// {id:["GROUND_FULLY","5"],name:getLanguageStr("word744","地面全额上网")},
				{
					id: ["CENTRALIZED_FULLY", "6"],
					name: getLanguageStr("plant398", "集中式全额上网"),
					value: "CENTRALIZED_FULLY",
				},
			];
			break;
		case "platformS":
			types = [
				// 平台
				{ id: ["1"], name: getLanguageStr("word214", "Solarman") },
				{ id: ["2"], name: getLanguageStr("brand2", "欧姆尼克") },
				{ id: ["3"], name: getLanguageStr("brand18", "锦浪") },
				{ id: ["4"], name: getLanguageStr("brand27", "兆能") },
			];
			break;
		case "ProgressType":
			types = [
				// 项目类型
				{ id: ["DELAY"], name: "延时(实际进度<计划进度)" },
				{ id: ["NORMAL"], name: "正常进行(实际进度=计划进度)" },
				{ id: ["SPEEDUP"], name: "提前(实际进度>计划进度)" },
			];
			break;
		case "projectCapacity":
			types = [
				// 工程装机容量
				{ id: ["0~10"], name: "<10" + getLanguageStr("unit11", "kWp") },
				{
					id: ["10~100"],
					name: "10~100" + getLanguageStr("unit11", "kWp"),
				},
				{
					id: ["100~1000"],
					name: "100~1000" + getLanguageStr("unit11", "kWp"),
				},
				{ id: ["1~10"], name: "1~10" + getLanguageStr("MWp", "MWp") },
				{ id: [">10"], name: ">10" + getLanguageStr("MWp", "MWp") },
			];
			break;
		case "projectDates":
			types = [
				// 工程筛选时间
				{ id: ["TODAY"], name: getLanguageStr("word1475", "今天") },
				{ id: ["WEEK"], name: getLanguageStr("本周", "本周") },
				{ id: ["MONTH"], name: getLanguageStr("本月", "本月") },
			];
			break;
		case "projectStatus":
			types = [
				// 项目状态
				{ id: ["READY"], name: ["准备中", "label-warning"] }, // ready
				{ id: ["BUILDING"], name: ["建设中", "label-success"] }, // building
				{ id: ["FINISHED"], name: ["已完成", "label-finish"] }, //
				{ id: ["END"], name: ["已结束", "label-end"] },
				{ id: ["STOP"], name: ["中止", "label-error"] }, // stop
			];
			break;
		case "projectType":
			types = [
				// 项目类型
				{ id: ["HOME"], name: "家用屋顶" },
				{ id: ["BUSINESS"], name: "商用屋顶" },
				{ id: ["INDUSTRY"], name: "工业屋顶" },
				{ id: ["GROUND"], name: "地面电站" },
			];
			break;
		case "promptMode":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("word1945", "邮件"),
					hname: "emailChannel",
					value: 1,
					isSelect: false,
				},
				{
					id: ["2"],
					name: getLanguageStr("word1946", "短信"),
					hname: "smsChannel",
					value: 2,
					isSelect: false,
				},
				{
					id: ["3"],
					name: getLanguageStr("word1947", "电话语言"),
					hname: "voiceChannel",
					value: 3,
					isSelect: false,
				},
				{
					id: ["4"],
					name: getLanguageStr("word1940", "APP推送"),
					hname: "pushChannel",
					value: 4,
					isSelect: true,
				},
			];
			break;
		case "promptModeEn":
			types = [
				{
					id: ["MAIL"],
					name: getLanguageStr("word1945", "邮件"),
					value: 1,
				},
				{
					id: ["SMS"],
					name: getLanguageStr("word1946", "短信"),
					value: 2,
				},
				{
					id: ["VOICE"],
					name: getLanguageStr("word1947", "电话语言"),
					value: 3,
				},
				{
					id: ["APP"],
					name: getLanguageStr("word1940", "APP推送"),
					value: 4,
					isSelect: true,
				},
			];
			break;
		case "priority": //优先级
			types = [
				{
					id: ["LOWER"],
					name: getLanguageStr("manage434", "较低"),
					value: "LOWER",
				},
				{
					id: ["NORMAL"],
					name: getLanguageStr("manage435", "普通"),
					value: "NORMAL",
				},
				{
					id: ["CRITICAL"],
					name: getLanguageStr("manage436", "紧急"),
					value: "CRITICAL",
				},
				{
					id: ["URGENT"],
					name: getLanguageStr("manage437", "非常紧急"),
					value: "URGENT",
				},
			];
			break;
		case "relation":
			types = [
				// 还款方式
				{
					id: ["2"],
					name: getLanguageStr("device21", "已关联"),
					value: 2,
				},
				{
					id: ["3"],
					name: getLanguageStr("device22", "未关联"),
					value: 3,
				},
			];
			break;
		case "repaymentMethod":
			types = [
				// 还款方式
				{
					id: ["EQUAL_LOAN", "2"],
					name: getLanguageStr("word754", "等额本息"),
				},
				{
					id: ["EQUAL_PRINCIPAL", "1"],
					name: getLanguageStr("word755", "等额本金"),
				},
				{ id: ["RENTAL"], name: getLanguageStr("word1292", "租金表") },
			];
			break;
		case "reportType":
			types = [
				// 平台
				{
					id: ["STATION"],
					name: getLanguageStr("word204", "电站"),
					value: "STATION",
				},
				{
					id: ["INVERTER"],
					name: getLanguageStr("word35", "逆变器"),
					value: "INVERTER",
				},
				{
					id: ["METER"],
					name: getLanguageStr("word39", "电表"),
					value: "METER",
				},
			];
			break;
		case "roleType": //内部默认配置的角色
			token = "";
			types = [
				{ id: ["1"], name: getLanguageStr("word76", "超级管理员") },
				{ id: ["2"], name: getLanguageStr("word1333", "默认普通用户") },
				{ id: ["6"], name: getLanguageStr("word1990", "运维主管") },
				{ id: ["7"], name: getLanguageStr("word1989", "运维人员") },
				{ id: ["8"], name: getLanguageStr("word1988", "代理商") },
				{ id: ["11"], name: getLanguageStr("manage454", "运维调度") },
			];
			break;
		case "roleType-outer": //外部默认配置的角色
			token = "";
			types = [
				{ id: ["3"], name: getLanguageStr("manage472", "仅查看电站角色") },
				{ id: ["9"], name: getLanguageStr("manage473", "可编辑电站角色") },
				{ id: ["10"], name: getLanguageStr("manage474", "全部电站权限角色") },
			];
			break;
		// case "roleS":
		// 	types=[ //用户类型
		// 		{ id: ["2"], name: getLanguageStr("word77", "管理员") },
		// 		{ id: ["3"], name: getLanguageStr("word78", "客服") },
		// 		{ id: ["4"], name: getLanguageStr("word79", "工程师") }
		// 	];
		// 	break;
		case "roofType":
			types = [
				// 屋顶类型
				{ id: ["2"], name: getLanguageStr("word1304", "平屋顶") },
				{ id: ["3"], name: getLanguageStr("word1305", "斜屋顶") },
			];
			break;
		case "runState":
			types = [
				// 投产状态：全部、已运行、未运行
				{
					id: ["1", "running"],
					name: getLanguageStr("word1491", "已投产"),
					value: "1",
				},
				{
					id: ["0", "unRunning"],
					name: getLanguageStr("word1492", "未投产"),
					value: "0",
				},
			];
			break;
		case "runType":
			types = [
				// 平台运行类型
				{ id: ["B"], name: getLanguageStr("word24", "专业版") },
				{ id: ["C"], name: getLanguageStr("word1145", "光伏监控") },
			];
			break;
		case "scanState": // 扫描状态
			types = [
				{
					id: ["10"],
					name: getLanguageStr("device268", "扫描中"),
					value: 10,
				},
				{
					id: ["20"],
					name: getLanguageStr("device300", "成功"),
					value: 20,
				},
				{
					id: ["30"],
					name: getLanguageStr("device301", "失败"),
					value: 30,
				},
			];
			break;
		case "scanFailure": // 扫描失败原因
			types = [
				{
					id: ["501"],
					name: getLanguageStr("device280", "连接逆变器失败"),
					value: "501",
				},
				{
					id: ["502"],
					name: getLanguageStr("device281", "扫描逆变器失败"),
					value: "502",
				},
				{
					id: ["503"],
					name: getLanguageStr("device282", "上传中断"),
					value: "503",
				},
			];
			break;
		case "searchTypeS_create":
			types = [
				// 创建时间 0：全部、1：1 个月内、2：3 个月内、3：6 个月内、4：8 个月内、5：1 年内
				{ id: ["1"], name: i18n.t("fill3rdPay1", [1, "最近1月"]) },
				{ id: ["2"], name: i18n.t("fill3rdPay1", [3, "最近3月"]) },
				{ id: ["3"], name: i18n.t("fill3rdPay1", [6, "最近6月"]) },
				{ id: ["4"], name: i18n.t("fill3rdPay1", [8, "最近8月"]) },
				{ id: ["5"], name: getLanguageStr("phrase228", "最近1年") },
			];
			break;
		case "sensor":
			types = [
				// sensor号
				{
					id: ["0102"],
					name: getLanguageStr("brand26+word80", "兆伏单相"),
				},
				{
					id: ["0501", "0503", "0504", "0505", "0506", "0507"],
					name: getLanguageStr("brand18", "锦浪"),
				},
				{
					id: ["0504,0505,0506,0507"],
					name: getLanguageStr("brand18", "锦浪"),
				},
				{ id: ["0F01"], name: getLanguageStr("brandEX1", "水晶石") },
				{
					id: ["1E03"],
					name: getLanguageStr("brand35+word81", "艾伏三相"),
				},
				{
					id: ["1E04"],
					name: getLanguageStr("brand35+word80", "艾伏单相"),
				},
				{
					id: ["1E05"],
					name: getLanguageStr("brand35+word81+(1E05)", "艾伏三相(1E05)"),
				},
				{
					id: ["1E03,1E05"],
					name: getLanguageStr("brand35+word81", "艾伏三相"),
				},
				{ id: ["2701"], name: getLanguageStr("brand7", "首航") },
				{
					id: ["2706"],
					name: getLanguageStr("brand7+50-70kW", "首航"),
				},
				{
					id: ["6406"],
					name: getLanguageStr("brand26+word81", "兆伏三相"),
				},
				{
					id: ["7802"],
					name: getLanguageStr("word80+word1274", "单相储能"),
				},
				{
					id: ["7A02"],
					name: getLanguageStr("word81+word1274", "三相储能"),
				},
				{
					id: ["7803"],
					name: getLanguageStr("word80+word1053", "单相光伏"),
				},
				{
					id: ["7A05"],
					name: getLanguageStr("word81+word1053", "三相光伏"),
				},
				{
					id: ["8306"],
					name: getLanguageStr("brand17+brandEX2", "易事特小蜜蜂"),
				},
				{ id: ["A501"], name: getLanguageStr("brand37", "阿瑟顿") },
				{ id: ["A502"], name: "Presola" },
			];
			break;
		case "serviceType": //服务类型
			types = [
				//{ id: ['1'], name: getLanguageStr('login1', '安装商'),value:1},//word655
				//{ id: ['2'], name: getLanguageStr('login2', '运维商'),value:2},//word1150
				{
					id: ["1"],
					name: getLanguageStr("manage343", "安装运维商"),
					value: 1,
				},
				{
					id: ["3"],
					name: getLanguageStr("login3", "分销商"),
					value: 3,
				}, //word644
				{
					id: ["4"],
					name: getLanguageStr("login4", "设备商"),
					value: 4,
				}, //word643
			];
			break;
		case "simShowStatusS":
			types = [
				// sim卡状态
				{ id: ["1"], name: getLanguageStr("word94", "未激活") },
				{ id: ["3"], name: getLanguageStr("wordPay1", "欠费") },
				{ id: ["6"], name: getLanguageStr("wordPay15", "即将到期") },
				{ id: ["2"], name: getLanguageStr("word1123", "正常") },
				{
					id: ["4"],
					name: getLanguageStr("com_check40", "充值完成，处理中"),
				},
				{ id: ["5"], name: getLanguageStr("wordPay14", "注销停卡") },
			];
			break;
		case "stationtype":
			types = [
				// sim卡状态
				{
					id: ["GENERATION"],
					name: getLanguageStr("plant_detail250", "发电"),
				},
				{
					id: ["CONSUMPTION"],
					name: getLanguageStr("word561", "用电"),
				},
				{ id: ["GRID"], name: getLanguageStr("plant85", "并网") },
				{ id: ["BATTERY"], name: getLanguageStr("word37", "电池") },
			];
			break;
		case "timeDimensionType": //时间维度ByPlant
			types = [
				{
					id: ["1", "MINUTE"],
					name: getLanguageStr("word1865", "按分钟"),
					value: "1",
				},
				{
					id: ["2", "DAY"],
					name: getLanguageStr("word1866", "按日"),
					value: "2",
				},
				{
					id: ["3", "MONTH"],
					name: getLanguageStr("word1867", "按月"),
					value: "3",
				},
			];
			break;
		// case 'timeDimensionTypeByDevice':
		// 	types = [	// 时间维度
		// 		{id: ['1', 'MINUTE'], name: getLanguageStr('word1865', '按分钟'), value: '1'},
		// 		{id: ['2', 'DAY'], name: getLanguageStr('word1866', '按日'), value: '2'},
		// 		{id: ['3', 'MONTH'], name: getLanguageStr('word1867', '按月'), value: '3'}
		// 	]
		// 	break
		case "temperatureUnitS":
			types = [
				// 温度单位
				{ id: ["1"], name: getLanguageStr("unit4", "摄氏度（℃）") },
				{ id: ["2"], name: getLanguageStr("unit5", "华氏度（℉）") },
			];
			break;
		case "validDateS":
			types = [
				// 停卡到期时间
				{ id: ["1"], name: i18n.t("fill3rdPay1", [1, "最近1月"]) },
				{ id: ["2"], name: i18n.t("fill3rdPay1", [2, "最近2月"]) },
				{ id: ["3"], name: i18n.t("fill3rdPay1", [3, "最近3月"]) },
				{ id: ["4"], name: i18n.t("fill3rdPay1", [6, "最近6月"]) },
			];
			break;
		case "weatherState":
		case "weatherPic":
			types = [
				// 天气情况
				{ id: ["cloudy"], name: getLanguageStr("weather1", "多云") },
				{ id: ["sunny"], name: getLanguageStr("weather2", "晴") },
				{ id: ["foggy"], name: getLanguageStr("weather3", "雾") },
				{ id: ["snow-s"], name: getLanguageStr("weather4", "雪") },
				{ id: ["rainy-s"], name: getLanguageStr("weather6", "大雨") },
				{ id: ["rainy-l"], name: getLanguageStr("weather5", "小雨") },
				{ id: ["thunder"], name: getLanguageStr("weather7", "雷电") },
				{ id: ["unknow"], name: getLanguageStr("--", "--") },
			];
			break;
		case "wireStatus":
			types = [
				// 电网状态
				{ id: ["UNKNOWN"], name: getLanguageStr("word1579", "未知") },
				{ id: ["STATIC"], name: getLanguageStr("word184", "静止") },
				{
					id: ["GRID_CONNECTED"],
					name: getLanguageStr("word162", "并网"),
				},
				{
					id: ["PURCHASE"],
					name: getLanguageStr("plant_detail235", "购电"),
				},
			];
			break;
		case "workOrderNodeForCreat": //工单节点-创建用
			types = [
				{
					id: ["HANDLE"],
					name: getLanguageStr("ticket32", "处理人"),
				},
				{ id: ["APPROVE"], name: getLanguageStr("ticket75", "验证人") },
				{
					id: ["EVALUATE"],
					name: getLanguageStr("ticket77", "评价人"),
				},
				// {id:[""],name:getLanguageStr('','')},
				// {id:[""],name:getLanguageStr('','')}
			];
			break;
		case "workOrderNodeForRunning": //工单节点-流转用
			types = [
				{
					id: ["START"],
					name: getLanguageStr("ticket108", "发起工单"),
				},
				{ id: ["PICK"], name: getLanguageStr("ticket109", "接受工单") },
				{
					id: ["HANDLE"],
					name: getLanguageStr("ticket110", "处理工单"),
				},
				{
					id: ["APPROVE"],
					name: getLanguageStr("ticket111", "验证工单"),
				},
				{
					id: ["EVALUATE"],
					name: getLanguageStr("ticket107", "评价工单"),
				},
				// {id:[""],name:getLanguageStr('','')},
				// {id:[""],name:getLanguageStr('','')}
			];
			break;
		case "workingState": //工单节点-流转用
			types = [
				{
					id: ["FREE"],
					name: getLanguageStr("ticket19", "空闲"),
					value: "FREE",
				},
				{ id: ["WORKING"], name: getLanguageStr("ticket18", "工作中"), value: "WORKING" },
			];
			break;
		case "weekDay": //星期几
			types = [
				{
					id: ["1"],
					name: getLanguageStr("ticket71", "星期日"),
				},
				{ id: ["2"], name: getLanguageStr("ticket65", "星期一") },
				{
					id: ["3"],
					name: getLanguageStr("ticket66", "星期二"),
				},
				{
					id: ["4"],
					name: getLanguageStr("ticket67", "星期三"),
				},
				{
					id: ["5"],
					name: getLanguageStr("ticket68", "星期四"),
				},
				{
					id: ["6"],
					name: getLanguageStr("ticket69", "星期五"),
				},
				{
					id: ["7"],
					name: getLanguageStr("ticket70", "星期六"),
				},
				// {id:[""],name:getLanguageStr('','')},
				// {id:[""],name:getLanguageStr('','')}
			];
			break;
		case "timeFrequency":
			types = [
				{ id: ["DAY"], name: getLanguageStr("ticket57", "每天"), value: "DAY" },
				{ id: ["WEEK"], name: i18n.t("ticket58", ["xx", "每周"]), value: "WEEK" },
				{ id: ["MONTH"], name: getLanguageStr("ticket190", "每月"), value: "MONTH" },
				{ id: ["YEAR"], name: i18n.t("ticket59", ["xx", "每年"]), value: "YEAR" },
			];
			break;
		case "1E03":
			types = [
				//
				{ id: ["sj"], name: getLanguageStr("word210", "时间") },
				// {id:["sj"],name:getLanguageStr("word632+word35+word210","读取逆变器时间")},
				{ id: ["kgj"], name: getLanguageStr("control6", "开关机") },
				{ id: ["djs"], name: getLanguageStr("word895", "倒计时") },
				{ id: ["ag"], name: getLanguageStr("word896", "安规") },
			];
			break;
		case "unitSetup":
			types = [
				{
					id: ["ELECTRICNUMBER"],
					name: getLanguageStr("bill29", "电量单位"),
				},
				{
					id: ["ELECTRICCHARGE"],
					name: getLanguageStr("bill30", "电费单位"),
				},
			];
			break;
		case "powerUnit":
			types = [
				{
					id: ["WKWH"],
					name: getLanguageStr("bill31", "万kWh"),
					value: "WKWH",
				},
				{
					id: ["KKWH"],
					name: getLanguageStr("bill32", "千kWh"),
					value: "KKWH",
				},
				{
					id: ["KWH"],
					name: getLanguageStr("unit10", "kWh"),
					value: "KWH",
				},
			];
			break;
		case "electricityUnit":
			types = [
				{
					id: ["WAN"],
					name: getLanguageStr("bill33", "万元"),
					value: "WAN",
				},
				{
					id: ["YUAN"],
					name: getLanguageStr("unit1", "元"),
					value: "YUAN",
				},
			];
			break;
		case "electricityUnit":
			types = [
				{
					id: ["WAN"],
					name: getLanguageStr("bill33", "万元"),
					value: "WAN",
				},
				{
					id: ["YUAN"],
					name: getLanguageStr("unit1", "元"),
					value: "YUAN",
				},
			];
			break;
		case "fillHours":
			types = [
				{ id: ["0"], name: "0", value: 0 },
				{ id: ["1"], name: "1", value: 1 },
				{ id: ["2"], name: "2", value: 2 },
				{ id: ["3"], name: "3", value: 3 },
				{ id: ["4"], name: "4", value: 4 },
				{ id: ["5"], name: "5", value: 5 },
				{ id: ["6"], name: "6", value: 6 },
				{ id: ["7"], name: "7", value: 7 },
				{ id: ["8"], name: "8", value: 8 },
				{ id: ["9"], name: "9", value: 9 },
				{ id: ["10"], name: "10", value: 10 },
				{ id: ["11"], name: "11", value: 11 },
				{ id: ["12"], name: "12", value: 12 },
				{ id: ["13"], name: "13", value: 13 },
				{ id: ["14"], name: "14", value: 14 },
				{ id: ["15"], name: "15", value: 15 },
				{ id: ["16"], name: "16", value: 16 },
				{ id: ["17"], name: "17", value: 17 },
				{ id: ["18"], name: "18", value: 18 },
				{ id: ["19"], name: "19", value: 19 },
				{ id: ["20"], name: "20", value: 20 },
				{ id: ["21"], name: "21", value: 21 },
				{ id: ["22"], name: "22", value: 22 },
				{ id: ["23"], name: "23", value: 23 },
			];
			break;
		case "fillMinutes":
			types = [
				{ id: ["00"], name: "00", value: "00" },
				{ id: ["01"], name: "01", value: "01" },
				{ id: ["02"], name: "02", value: "02" },
				{ id: ["03"], name: "03", value: "03" },
				{ id: ["04"], name: "04", value: "04" },
				{ id: ["05"], name: "05", value: "05" },
				{ id: ["06"], name: "06", value: "06" },
				{ id: ["07"], name: "07", value: "07" },
				{ id: ["08"], name: "08", value: "08" },
				{ id: ["09"], name: "09", value: "09" },
				{ id: ["10"], name: "10", value: "10" },
				{ id: ["11"], name: "11", value: "11" },
				{ id: ["12"], name: "12", value: "12" },
				{ id: ["13"], name: "13", value: "13" },
				{ id: ["14"], name: "14", value: "14" },
				{ id: ["15"], name: "15", value: "15" },
				{ id: ["16"], name: "16", value: "16" },
				{ id: ["17"], name: "17", value: "17" },
				{ id: ["18"], name: "18", value: "18" },
				{ id: ["19"], name: "19", value: "19" },
				{ id: ["20"], name: "20", value: "20" },
				{ id: ["21"], name: "21", value: "21" },
				{ id: ["22"], name: "22", value: "22" },
				{ id: ["23"], name: "23", value: "23" },
				{ id: ["24"], name: "24", value: "24" },
				{ id: ["25"], name: "25", value: "25" },
				{ id: ["26"], name: "26", value: "26" },
				{ id: ["27"], name: "27", value: "27" },
				{ id: ["28"], name: "28", value: "28" },
				{ id: ["29"], name: "29", value: "29" },
				{ id: ["30"], name: "30", value: "30" },
				{ id: ["31"], name: "31", value: "31" },
				{ id: ["32"], name: "32", value: "32" },
				{ id: ["33"], name: "33", value: "33" },
				{ id: ["34"], name: "34", value: "34" },
				{ id: ["35"], name: "35", value: "35" },
				{ id: ["36"], name: "36", value: "36" },
				{ id: ["37"], name: "37", value: "37" },
				{ id: ["38"], name: "38", value: "38" },
				{ id: ["39"], name: "39", value: "39" },
				{ id: ["40"], name: "40", value: "40" },
				{ id: ["41"], name: "41", value: "41" },
				{ id: ["42"], name: "42", value: "42" },
				{ id: ["43"], name: "43", value: "43" },
				{ id: ["44"], name: "44", value: "44" },
				{ id: ["45"], name: "45", value: "45" },
				{ id: ["46"], name: "46", value: "46" },
				{ id: ["47"], name: "47", value: "47" },
				{ id: ["48"], name: "48", value: "48" },
				{ id: ["49"], name: "49", value: "49" },
				{ id: ["50"], name: "50", value: "50" },
				{ id: ["51"], name: "51", value: "51" },
				{ id: ["52"], name: "52", value: "52" },
				{ id: ["53"], name: "53", value: "53" },
				{ id: ["54"], name: "54", value: "54" },
				{ id: ["55"], name: "55", value: "55" },
				{ id: ["56"], name: "56", value: "56" },
				{ id: ["57"], name: "57", value: "57" },
				{ id: ["58"], name: "58", value: "58" },
				{ id: ["59"], name: "59", value: "59" },
			];
			break;
		case "fillHours":
			types = [
				{ id: ["1"], name: "1", value: 1 },
				{ id: ["2"], name: "2", value: 2 },
				{ id: ["3"], name: "3", value: 3 },
				{ id: ["4"], name: "4", value: 4 },
				{ id: ["5"], name: "5", value: 5 },
				{ id: ["6"], name: "6", value: 6 },
				{ id: ["7"], name: "7", value: 7 },
				{ id: ["8"], name: "8", value: 8 },
				{ id: ["9"], name: "9", value: 9 },
				{ id: ["10"], name: "10", value: 10 },
				{ id: ["11"], name: "11", value: 11 },
				{ id: ["12"], name: "12", value: 12 },
			];
			break;
		case "authorizeScope":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("device335", "全部授权"),
					value: 1,
				},
				{
					id: ["2"],
					name: getLanguageStr("device336", "指定授权"),
					value: 2,
				},
			];
			break;
		case "workOrderState":
			types = [
				{
					id: ["WAIT_PICK"],
					name: getLanguageStr("ticket2", "待接受"),
					value: "WAIT_PICK",
				},
				{
					id: ["WAIT_HANDLE"],
					name: getLanguageStr("ticket4", "待处理"),
					value: "WAIT_HANDLE",
				},
				{
					id: ["IN_HANDLE"],
					name: getLanguageStr("task6", "执行中"),
					value: "IN_HANDLE",
				},
				{
					id: ["WAIT_APPROVE"],
					name: getLanguageStr("ticket6", "待验证"),
					value: "WAIT_APPROVE",
				},
				{
					id: ["WAIT_EVALUATE"],
					name: getLanguageStr("ticket7", "待评价"),
					value: "WAIT_EVALUATE",
				},
				{
					id: ["FINISH"],
					name: getLanguageStr("ticket8", "已完成"),
					value: "FINISH",
				},
				{
					id: ["REJECT"],
					name: getLanguageStr("ticket3", "拒绝接受"),
					value: "REJECT",
				},
				{
					id: ["CANCEL"],
					name: getLanguageStr("ticket9", "已撤销"),
					value: "CANCEL",
				},
			];
			break;
		case "workOrderTrace":
			types = [
				{
					id: ["WAIT_PICK"],
					name: getLanguageStr("ticket2", "待接受"),
					value: "WAIT_PICK",
				},
				{
					id: ["WAIT_HANDLE"],
					name: getLanguageStr("ticket4", "待处理"),
					value: "WAIT_HANDLE",
				},
				{
					id: ["IN_HANDLE"],
					name: getLanguageStr("task6", "执行中"),
					value: "IN_HANDLE",
				},
				{
					id: ["WAIT_APPROVE"],
					name: getLanguageStr("ticket6", "待验证"),
					value: "WAIT_APPROVE",
				},
				{
					id: ["WAIT_EVALUATE"],
					name: getLanguageStr("ticket7", "待评价"),
					value: "WAIT_EVALUATE",
				},
				{
					id: ["FINISH"],
					name: getLanguageStr("ticket8", "已完成"),
					value: "FINISH",
				},
				{
					id: ["REJECT"],
					name: getLanguageStr("ticket112", "已拒绝"),
					value: "REJECT",
				},
				{
					id: ["CANCEL"],
					name: getLanguageStr("ticket9", "已撤销"),
					value: "CANCEL",
				},
			];
			break;
		case "workOrderTodoTitle":
			types = [
				{
					id: ["STATION"],
					name: getLanguageStr("plant172", "电站"),
					value: "STATION",
				},
				{
					id: ["ALERT"],
					name: getLanguageStr("plant_alert59", "报警"),
					value: "ALERT",
				},
				{
					id: ["DEVICE"],
					name: getLanguageStr("device62", "设备"),
					value: "DEVICE",
				},
				{
					id: ["TEXTAREA"],
					name: getLanguageStr("plant_detail18", "描述"),
					value: "TEXTAREA",
				},
				{
					id: ["IMAGE"],
					name: getLanguageStr("图片描述", "图片描述"),
					value: "IMAGE",
				},
			];
			break;
		case "reportTitle":
			types = [
				{
					id: ["SWITCH"],
					name: getLanguageStr("巡视结果", "巡视结果"),
					value: "SWITCH",
				},
				{
					id: ["ALERT"],
					name: getLanguageStr("plant_alert59", "报警"),
					value: "ALERT",
				},
				{
					id: ["DEVICE"],
					name: getLanguageStr("device62", "设备"),
					value: "DEVICE",
				},
				{
					id: ["TEXTAREA"],
					name: getLanguageStr("plant_detail18", "描述"),
					value: "TEXTAREA",
				},
				{
					id: ["IMAGE"],
					name: getLanguageStr("图片描述", "图片描述"),
					value: "IMAGE",
				},
			];
			break;
		case "workOrderStateHome":
			types = [
				{
					id: ["WAIT_PICK"],
					name: {
						name: getLanguageStr("ticket2", "待接受"),
						color: "#F8B51E",
					},
					value: "WAIT_PICK",
				},
				{
					id: ["WAIT_HANDLE"],
					name: {
						name: getLanguageStr("ticket4", "待处理"),
						color: "#F8B51E",
					},
					value: "WAIT_HANDLE",
				},
				{
					id: ["IN_HANDLE"],
					name: {
						name: getLanguageStr("task6", "执行中"),
						color: "#048FFF",
					},
					value: "IN_HANDLE",
				},
				{
					id: ["WAIT_APPROVE"],
					name: {
						name: getLanguageStr("ticket6", "待验证"),
						color: "#F8B51E",
					},
					value: "WAIT_APPROVE",
				},
				{
					id: ["WAIT_EVALUATE"],
					name: {
						name: getLanguageStr("ticket7", "待评价"),
						color: "#F8B51E",
					},
					value: "WAIT_EVALUATE",
				},
				{
					id: ["FINISH"],
					name: {
						name: getLanguageStr("ticket8", "已完成"),
						color: "#41D068",
					},
					value: "FINISH",
				},
				{
					id: ["CANCEL"],
					name: {
						name: getLanguageStr("ticket9", "已撤销"),
						color: "rgba(0, 0, 0, 0.25)",
					},
					value: "CANCEL",
				},
				{
					id: ["REJECT"],
					name: {
						name: getLanguageStr("ticket3", "拒绝接受"),
						color: "#FF7875",
					},
					value: "REJECT",
				},
				// {id:['WAIT_PICK'],name:{name: getLanguageStr("验证失败", "验证失败"),color:'#FF7875'}, value:'WAIT_PICK'},
			];
			break;
		case "timeoutState":
			types = [
				{
					id: ["1"],
					name: getLanguageStr("ticket27", "已超时"),
					value: "1",
				},
				{
					id: ["0"],
					name: getLanguageStr("ticket28", "未超时"),
					value: "0",
				},
			];
			break;
		case "remindTimeSpan":
			types = [
				{
					id: [1800],
					name: getLanguageStr("ticket100", "30分钟前"),
					value: 1800,
				},
				{
					id: [3600],
					name: getLanguageStr("ticket101", "1小时前"),
					value: 3600,
				},
				{
					id: [86400],
					name: getLanguageStr("ticket102", "24小时前"),
					value: 86400,
				},
			];
			break;
	}
	function findVal(outType = "text") {
		// 查找val
		let text = "",
			list = -1,
			obj = {};
		val = val !== undefined && val !== null && val !== "" ? String(val) : text;
		$(types).each(function () {
			if ($.inArray(val, this.id) >= 0) {
				$.extend(true, obj, this);
				text = this.name;
				list = this.id;
				return false;
			}
		});
		switch (outType) {
			case "text":
				if (text === "") {
					//没有匹配到
					if (token == null) text = val;
					else text = token;
				}
				return text;
				break;
			case "list":
				return list;
				break;
			case "object":
				return obj;
				break;
		}
	}
	if (traceType === true) {
		if (val != undefined && val != null && val != "") {
			// 有查找值的话输出该组的id数组
			return findVal("list");
		} else return types;
	} else if (name) {
		return findVal(traceType);
	} else return val; // 索引名称不传则直接输出原本值
}
export function getBatteryIco(data) {
	// 处理电池图标
	let out = "battery-unknow";
	if ($.isNumeric(data)) {
		let soc = Math.round((data / 100) * 5);
		if (soc > 5) soc = 5;
		out = "battery-" + soc;
	}
	return out;
}
export function getSizeClass(sizeName) {
	switch (sizeName) {
		case "s":
			sizeName = "body-s";
			break;
		case "m":
			sizeName = "body-m";
			break;
		case "l":
			sizeName = "body-l";
			break;
		case "full":
			sizeName = "body-full";
			break;
		default:
			sizeName = "body-" + sizeName;
			break;
	}
	return sizeName;
}
export function getObjArray(Array, keyWord, inputKey, outputKey) {
	// 查找对象数组元素中某属性(inputKey)==keyWord的另一个属性(outputKey)的值, outputKey不传则返回索引index
	var text = "";
	$(Array).each(function (index) {
		if (this[inputKey] == keyWord) {
			text = outputKey ? this[outputKey] : index;
			return false;
		}
	});
	return text;
}
export function sortData(data, optionNew) {
	// 对数据进行排序，支持array和object
	if (data) {
		var option = {
			type: $.isArray(data) ? "array" : "object",
			orderBy: "up",
			byKey: "",
		};
		$.extend(option, optionNew);
		switch (option.type) {
			case "array":
				data.sort(function (a, b) {
					if (option.byKey !== "") {
						switch (option.orderBy) {
							case "up":
								return Number(a[option.byKey]) > Number(b[option.byKey]) ? 1 : -1;
								break;
							case "down":
								return Number(a[option.byKey]) < Number(b[option.byKey]) ? 1 : -1;
								break;
						}
					} else {
						switch (option.orderBy) {
							case "up":
								return Number(a) > Number(b) ? 1 : -1;
								break;
							case "down":
								return Number(a) < Number(b) ? 1 : -1;
								break;
						}
					}
				});
				break;
			case "map":
			case "object":
				var dataMap = Object.keys(data);
				dataMap.sort(function (a, b) {
					switch (option.orderBy) {
						case "up":
							return Number(a) > Number(b) ? 1 : -1;
							break;
						case "down":
							return Number(a) < Number(b) ? 1 : -1;
							break;
					}
				});
				// var dataMap=Object.keys(data);
				// dataMap.sort(function(a,b){
				// 	switch(option.orderBy){
				// 		case "up":
				// 			return Number(a)>Number(b)?1:-1
				// 			break;
				// 		case "down":
				// 			return Number(a)<Number(b)?1:-1
				// 			break;
				// 	}
				// });
				// var dataNew={};
				// $(dataMap).each(function(){
				// 	dataNew[this]=data[this];
				// });
				// data=dataNew;
				data = dataMap;
				break;
		}
		return data;
	}
}

export function getIpToDo(fn, outTimeSec = 1) {
	let delayDo = setTimeout(() => {
		// n秒后给出默认值
		if (fn) {
			fn(null);
			fn = null;
		}
	}, 1000 * outTimeSec);
	if (stage.loc.ip) {
		//已经拿到ip
		clearTimeout(delayDo);
		if (fn) {
			fn(stage.loc.ip);
			fn = null;
		}
	} else {
		$.ajax({
			// url:"http://chaxun.1616.net/s.php?type=ip&output=json",
			url: "https://jsonip.com",
			dataType: "jsonp",
			success: function (data) {
				stage.loc.ip = data.ip; //保存用户ip
				clearTimeout(delayDo);
				// trace(data,true)
				// ip=data.responseJSON.Ip;
				if (fn) {
					fn(data.ip);
					fn = null;
				}
			},
			error: function (data) {
				trace("获取IP地址失败");
				trace(data);
				if (fn) {
					fn(null);
					fn = null;
				}
			},
		});
	}
}

export function objAdd($content, $where, location, optionNew) {
	// option:{start:fn,end:fn}
	var option = {
		start: null,
		end: null,
	};
	$.extend(option, optionNew);

	function working() {
		targetSize = [$content.outerWidth(true), $content.outerHeight(true)];
		$content.css({ position: "absolute" });
	}
	var $token = $("<div></div>").css({
			width: 0,
			height: 0,
			transition: "none",
			padding: 0,
		}),
		targetSize = [];
	$content.css({ opacity: 0 }); //, "position":"absolute"
	switch (location) {
		case "outSide-first":
		case "outside-first":
			$where.before($content);
			working();
			$where.before($token);
			break;
		case "outSide-last":
		case "outside-last":
			$where.after($content);
			working();
			$where.after($token);
			break;
		case "inSide-first":
		case "inside-first":
			$where.prepend($content);
			working();
			$where.prepend($token);
			break;
		case "inSide-last":
		case "inside-last":
			$where.append($content);
			working();
			$where.append($token);
			break;
		case "":
			break;
	}
	$token.animate({ width: targetSize[0], height: targetSize[1] }, function () {
		$token.remove();
		$content.css({ opacity: "", position: "" });
		if (option.end) option.end.call($content);
		// $content.fadeIn();
	});
}
export function objRemove($target, option) {
	// option:{parent:$,start:fn,end:fn}
	var $parent = option && option.parent ? option.parent.parent() : $target.parent();
	if (option && option.start) option.start.apply($target);
	$target.css({
		transition: "none",
		pointerEvents: "none",
	});
	$target.animate(
		{
			opacity: 0,
		},
		400,
		function () {
			$target.css({
				width: $target.innerWidth(),
				height: $target.innerHeight(),
			});
			$target.html("");
			$target.animate({ width: 0, height: 0, lineHeight: 0, padding: 0, margin: 0 }, 400, function () {
				option && option.parent ? option.parent.remove() : $target.remove();
				if (option && option.end) option.end.apply($parent);
			});
		}
	);
}
export function objTool(obj, action, option) {
	// 处理对象或数组
	let out = false;
	switch (action) {
		case "isAllFalse":
			out = true;
			$.each(obj, function () {
				if (this) out = false;
			});
			break;
		case "isSame":
			out = true;
			$.each(obj, function (key) {
				if (this != option[key]) {
					out = false;
				}
			});
			break;
		case "setAll":
			$.each(obj, function (key) {
				obj[key] = option.value;
			});
			break;
		case "allFalse":
			$.each(obj, function (key) {
				obj[key] = false;
			});
			out = true;
			break;
		case "sum":
			out = 0;
			$.each(obj, function () {
				out += this;
			});
			break;
		case "findByKey": // 遍历数组，从中找出符合字段值的项。option:[要找的key,要找的值findValue]
			out = [-1, null];
			$.each(obj, function (index) {
				if (this[option[0]] == option[1]) {
					out = [index, this];
					return false;
				}
			});
			break;
		case "findByKeyFuzzy": // 遍历数组，从中模糊匹配符合字段值的项。option:[要找的key,要找的值findValue]
			out = [-1, null];
			$.each(obj, function (index) {
				if (this[option[0]].includes(option[1])) {
					out = [index, this];
					return false;
				}
			});
			break;
		case "findByValue": // 遍历obj，从中找出符合值的key。option:[要找的key,要找的值findValue]
			out = "";
			$.each(obj, function (key, val) {
				if (val == option) {
					out = key;
					return false;
				}
			});
			break;
		case "contrastFromArray": // 对比0和1索引的数据，输出不同和相同2组数组
			// obj=[]
			break;
		case "mergeArrayToStringByKey": // 合并array中对应key值，输出逗号连接的字符
			out = "";
			$.each(obj, function (index) {
				out += (option.before || "") + this[option.key];
				if (index < obj.length - 1) out += ",";
			});
			break;
		case "returnSelectData": //将api数据转换成可供select组件调用的格式，option:{fromTextKey:String,fromValueKey:String,toTextKey:String,toValueKey:String}
			// export function returnSelectData(data,fromTextKey,fromValueKey,toTextKey,toValueKey){
			// 	let list=[];
			// 	$.each(data,(index,value)=>{
			// 		let obj={};
			// 		obj[toTextKey]=value[fromTextKey];
			// 		obj[toValueKey]=value[fromValueKey];
			// 		list.push(obj);
			// 	});
			// }
			out = [];
			$.each(obj, (index, value) => {
				let li = {};
				li[option.toTextKey] = value[option.fromTextKey];
				li[option.toValueKey] = value[option.fromValueKey];
				out.push(li);
			});
			break;

		// case "":
		// 	break;
	}
	return out;
}

export function effectRowVisualRange($eventDom, $table) {
	//判断非可视范围
	let time = 0;
	function onWheel(e) {
		if (new Date().getTime() - time > 10 * 1) {
			//时间内只调用一次
			setTimeout(function () {
				//延时进行计算，滚轮操作在部分场景是立即到位的
				let $scope = $(e.currentTarget).parents(".mCustomScrollbar").first();
				if ($scope.length == 0) {
					$scope = $(e.currentTarget).parent();
				}
				let $content = $(e.currentTarget).parents(".mCSB_container").first();
				if ($content.length == 0) {
					$content = $(e.currentTarget).parent();
				}
				// let posTop=$scope.offset().top;
				// let posBottom=$scope.offset().top+$scope.innerHeight();
				$.each($table.find("tbody"), function (index, tbody) {
					$.each($(tbody).find("tr"), (i, row) => {
						requestAnimationFrame(function () {
							let t = Math.abs(parseInt($content.css("top")));
							let h = $(row).innerHeight();
							if (h * i < t || h * i - t > $scope.innerHeight()) {
								$(row).addClass("dpN_E");
							} else if ($(row).hasClass("dpN_E")) {
								$(row).removeClass("dpN_E");
							}
						});
					});
				});
			}, 10 * 0);
			time = new Date().getTime();
		}
	}
	if (list) {
		$.each($eventDom, function (index, table) {
			onWheel({ currentTarget: table });
		});
		$eventDom.off("mousewheel");
		$eventDom.on("mousewheel", onWheel);
	} else {
		$eventDom.off("mousewheel");
	}
}

function scrollReFixHeight() {
	// 动态修正滚动区域的高度，防止下拉被截断
	if ($(this).hasClass("select") && $(this).parents(".window-alert").length) {
		// 在非alert类窗体启用自动补充高度$this.parents(".window-alert").length==0
		return;
	}
	let spaceY = parseInt($(this).css("font-size"));
	var fixHeight = 0;
	var $contentBox = $(this).parents(".mCSB_container").first();
	if ($contentBox.length) {
		let contentMH = $contentBox.offset().top + $contentBox.height();

		let thisMH = (thisMH = $(this).offset().top + $(this).innerHeight());

		if ($(this).find(".drop-list").length > 0) {
			thisMH = $(this).offset().top + $(this).innerHeight() + $(this).find(".drop-list").innerHeight();
		} else {
			$(this)
				.find(".dropList")
				.each(function () {
					thisMH = $(this).offset().top + $(this).innerHeight();
				});
		}
		/*
		if ($(this).hasClass("datepicker-popup")) {
			thisMH = $(this).offset().top + $(this).innerHeight();
		}
		else if ($(this).hasClass("drop-list")) {
			// 修正drop-list 比如搜索框之类的
			thisMH = $(this).offset().top + $(this).innerHeight();
		}
		*/
		if (thisMH > contentMH) {
			if (thisMH - contentMH > fixHeight) {
				// 需要+上多出的部分高度
				fixHeight = thisMH - contentMH + spaceY * 2;
			}
		}
		$contentBox.animate(
			{
				"padding-bottom": fixHeight,
			},
			500
		); // if(fixHeight>0)
	}
}

import BetterScroll from "@better-scroll/core";
import BetterScroll_observeDom from "@better-scroll/observe-dom";
BetterScroll.use(BetterScroll_observeDom);
import BetterScroll_mouseWheel from "@better-scroll/mouse-wheel";
BetterScroll.use(BetterScroll_mouseWheel);
import BetterScroll_scrollBar from "@better-scroll/scroll-bar";
BetterScroll.use(BetterScroll_scrollBar);
export function setNewScroll($target, option = {}) {
	// 设置滚动
	if ($target instanceof jQuery == false) {
		//jQuery对象转换
		$target = $($target);
	}
	// return false;
	$.extend(true, option, {
		bounceTime: 400,
		swipeBounceTime: 200,
		stopPropagation: true,
		observeDOM: true,
		scrollbar: {
			interactive: true,
		},
		mouseWheel: {},
		// disableMouse: true,
		outOfBoundaryDampingFactor: 0.1,
	});
	// var optionStr=$target.attr("scroll");
	// switch(optionStr){
	// 	case "hide"://option.live=false;
	// 		break;
	// 	case "outside":option.scrollbarPosition="outside";
	// 		break;
	// 	case "":
	// 		break;
	// }
	/*
	 */
	let scrollList = [];
	$target.each(function (index) {
		// 对每个对象设置滚动
		$(this).on("mouseenter", function () {
			$(this).addClass("showScrollBar");
		});
		$(this).on("mouseleave", function () {
			$(this).removeClass("showScrollBar");
		});
		let $this = $(this);
		if ($this.attr("scroll") != "false") {
			// 只对未添加过的进行添加滚动条
			if ($(this).data("scroll")) {
				$(this).data("scroll").refresh();
				trace("此scroll已创建，已更新");
			} else {
				$(this).addClass("betterScroll");
				$(this).css({ overflow: "hidden", position: "relative" });
				let optionNew = $.parseJSON(stringFormatForJson($this.attr("scroll"), true));
				if (optionNew.axis == "x") {
					optionNew.scrollX = true;
					optionNew.scrollY = false;
				}
				if ((option.scrollX == true && option.scrollY === false) || (optionNew.scrollX == true && optionNew.scrollY === false)) {
					//x轴滚动禁用回弹
					optionNew.bounce = false;
				}

				if (optionNew.group) {
					$this.attr("scroll-group", optionNew.group).attr("scrollId", "scroll" + Math.round(Math.random() * 99999));
					$.extend(optionNew, { keyboard: { enable: false } }); // 编组的滚动禁用按键，避免不同步
				}

				if ($(this).is("[scroll-group]")) {
					$this.off("mouseover mousemove mouseenter mouseleave click mousedown mouseup");
					$this.on("mouseover", function (e) {
						// 只让编组中的一个为滚动基准
						// 如果非本区域，需要清除所有激活
						if ($(e.target).parents("[scroll-group].scrollActive").length == 0) {
							$("[scroll-group].scrollActive").removeClass("scrollActive");
							$(e.target).parents("[scroll-group]").addClass("scrollActive");
							$(this).find("[scroll-group]").addClass("scrollActive");
						}
						// $(this).addClass("scrollActive");
					});
					// $(this).on("mousedown",function(e){//拖动滚动条的处理
					// 	$('[scroll-group].scrollActive').removeClass('scrollActive scrollActive-lock');
					// 	$(e.target).parents('[scroll-group]').addClass('scrollActive scrollActive-lock');trace("asdsadasd")
					// 	// $(this).find('[scroll-group]').addClass('scrollActive')
					// });
					$this.on("mousemove", function () {
						// 防止拖动发生滚动，导致同组视图不同步
						return false;
					});
					$(this).on("mouseenter", "tbody tr", function () {
						// 跨组激活同行
						let $scope = $(this).parents(".tableScope").first();
						$scope.find("[scroll-group] tbody tr.hover").removeClass("hover");
						let index = $(this).index();
						$scope.find("[scroll-group] tbody").each(function () {
							$(this).find("tr").eq(index).addClass("hover");
						});
					});
					$(this).on("mouseleave", "tbody tr", function () {
						// 跨组取消激活同行
						let $scope = $(this).parents(".tableScope").first();
						$scope.find("[scroll-group] tbody tr.hover").removeClass("hover");
					});
				}
				if ($this.find(".drop-list-box,.drop-list").length) {
					$this.off("mouseenter", ".drop-list-box,.drop-list", scrollReFixHeight); //,.datepicker-popup
					$this.on("mouseenter", ".drop-list-box,.drop-list", scrollReFixHeight); //,.datepicker-popup
				}
				let bs = new BetterScroll(this, $.extend(true, {}, option, optionNew));
				scrollList.push(bs);
				$this.data("scroll", bs);
				// console.log($(this).hasClass("scroll"),scrollSize)
			}
		}
	});
	return scrollList;
}

export function setScroll($target, option = {}) {
	// 设置滚动
	$.extend(true, option, {
		documentTouchScroll: true,
		autoExpandScrollbar: true,
		scrollInertia: 600,
		autoDraggerLength: true,
		// snapOffset:100,
		// scrollbarPosition:"outside",
		mouseWheel: {
			// deltaFactor:30
			// scrollAmount:80,//设置鼠标滚轮滚动量（以像素为单位）。默认值"auto"根据可滚动内容的长度来调整滚动量。
			// normalizeDelta:1,
			preventDefault: true,
		},
		advanced: {
			autoScrollOnFocus: false,
			updateOnSelectorChange: ".select .dropList,.drop-list .list",
			// autoExpandHorizontalScroll:true
		},
		scrollButtons: { enable: false },
		// theme: "minimal-dark",
		callbacks: {
			onCreate: function () {
				// if()
			},
			onBeforeUpdate: function () {
				if (!$(this).hasClass("scrollX")) {
					// x滚动不做修正
					let int = $(this).data("scrollSize"),
						size = $(this).hasClass("scrollX") ? Math.round($(this).innerWidth() / 2) : Math.round($(this).innerHeight() / 2);
					if (size > 0 && Math.abs(int - size) > 10 * 5) {
						// console.log(this,int,size)
						$(this).mCustomScrollbar("destroy");
						setScroll($(this));
					}
				}
			},
			onUpdate: function () {
				if ($(this).is("[scroll-group]")) {
					// 修正滚动条的尺寸
					let $mCSB_dragger_bar = $(this).find(".mCSB_scrollTools_vertical .mCSB_dragger_bar");
					let $scope = $(this).parents(".tableScope").first();
					$mCSB_dragger_bar.css({
						height: $mCSB_dragger_bar.parent().height(),
						left: $scope.offset().left + $scope.innerWidth() - stage.space + "px",
					}); //修正滚动条的位置
				}
			},
			whileScrolling: function () {
				let $scope = $(this).parents(".tableScope").first();
				// if($scope.find(".scrollActive").length&&$(this).hasClass("scrollActive")==false){//直接拖动滚动条的场景
				// 	$scope.find(".scrollActive").removeClass("scrollActive");
				// 	$(this).addClass("scrollActive");
				// }

				if ($(this).is("[scroll-group]") && $(this).hasClass("scrollActive")) {
					let thisGroup = $(this).attr("scroll-group");
					let thisId = $(this).attr("scrollId");
					// $("[scroll-group='"+thisGroup+"']").not($("[scrollId='"+thisId+"']")[0]).mCustomScrollbar("scrollTo",this.mcs.top,{
					// 	scrollInertia:0,
					// 	scrollEasing:"linear"
					// });
					let $scroll = $scope.find("[scroll-group='" + thisGroup + "']").not($("[scroll-group='" + thisGroup + "']" + "[scrollId='" + thisId + "']")[0]);
					let $this = this;
					$scroll.find(".mCSB_container").each(function () {
						$(this).css("top", $this.mcs.top);
						$(this).css("left", $this.mcs.left);
					});
					$scroll.find(".mCSB_container").first().css("top", this.mcs.top);
					$scroll.find(".mCSB_container").first().css("left", this.mcs.left);
					// $scroll.mCustomScrollbar("scrollTo",this.mcs.top,{scrollEasing:"linear",scrollInertia:600,timeout:0,callbacks:false});
					// $scroll.mCustomScrollbar("scrollTo",this.mcs.top,{moveDragger:true,timeout:0});
					$scroll.mCustomScrollbar("update");
					// trace($scroll,true)
					// if($scroll.length>1) trace($scroll)
				}
				// console.log(this)
				// if ($(this).hasClass('scrollX')) {
				//   // console.log(this)
				//   let num = $($($($($(this).children('.mCSB_scrollTools_horizontal')[0]))[0]).find('.mCSB_dragger')[0])[0].style.left.split('p')[0]
				//   // console.log(Number(num))
				//   // console.log($($(this).find('.mCSB_container >.scrollActive > .mCSB_scrollTools_onDrag_expand')[0]))
				//   // console.log($($($(this).find('.mCSB_container')[0]).children('.scrollY')[0]).find('.mCSB_scrollTools_onDrag_expand'))
				//   console.log($(this ))
				// }

				// if ($(this).attr('scroll-group')) { // 避免客串导致不相关的滚动互相影响
				if ($(this).hasClass("scrollX") && $scope.find("[scrollFloatX]").length > 0) {
					// x轴滚动条联合css效果
					if (this.mcs.left < 0 && $scope.find("[scrollFloatX='false']").length > 0) {
						$scope.find("[scrollFloatX='false']").attr("scrollFloatX", "true");
					} else if (this.mcs.left == 0 && $scope.find("[scrollFloatX='true']").length > 0) {
						$scope.find("[scrollFloatX='true']").attr("scrollFloatX", "false");
					}
				} else if ($scope.find("[scrollFloatY]").length > 0) {
					// y轴滚动条联合css效果
					if (this.mcs.top < 0 && $scope.find("[scrollFloatY='false']").length > 0) {
						$scope.find("[scrollFloatY='false']").attr("scrollFloatY", "true");
					} else if (this.mcs.top == 0 && $scope.find("[scrollFloatY='true']").length > 0) {
						$scope.find("[scrollFloatY='true']").attr("scrollFloatY", "false");
					}
				}
				// }
				if (option.whileScrolling) {
					option.whileScrolling(this);
				}
			},
			onTotalScrollBack: option.onTotalScrollBack || null,
			onTotalScroll: option.onTotalScroll || null,
		},
	});
	// var optionStr=$target.attr("scroll");
	// switch(optionStr){
	// 	case "hide"://option.live=false;
	// 		break;
	// 	case "outside":option.scrollbarPosition="outside";
	// 		break;
	// 	case "":
	// 		break;
	// }
	/*
	 */
	$target.each(function (index) {
		// 对每个对象设置滚动
		let $this = $(this),
			scrollSize = $(this).hasClass("scrollX") ? Math.round($(this).innerWidth() / 2) : Math.round($(this).innerHeight() / 2);
		if ($this.attr("scroll") != "false" && $this.children(".mCustomScrollBox").length == 0 && $this.hasClass("betterScroll") == false) {
			// 只对未添加过的进行添加滚动条
			let optionNew = $.parseJSON(stringFormatForJson($this.attr("scroll"), true));

			if (optionNew.group) {
				$this.attr("scroll-group", optionNew.group).attr("scrollId", "scroll" + Math.round(Math.random() * 99999));
				$.extend(optionNew, { keyboard: { enable: false } }); // 编组的滚动禁用按键，避免不同步
			}

			if (optionNew.axis && optionNew.axis === "x") {
				$this.addClass("scrollX");
				scrollSize = Math.round($(this).innerWidth() / 2);
			}

			if ($(this).innerHeight() > 50) {
				// console.log(this,$(this).innerHeight()/3,scrollSize,"--------------")
				$.extend(true, optionNew, {
					mouseWheel: {
						// scrollAmount:20
						scrollAmount: scrollSize,
					},
				});
			}

			// 动态处理滚动量
			// $this.on("mouseenter",function(){
			// 	let $content=$(this).find(".mCSB_container");
			// 	let x=Math.abs($(this).innerHeight()-$content.innerHeight());
			// 	$(this).mCustomScrollbar({
			// 		scrollInertia:40,
			// 		mouseWheel:{scrollAmount:(x<100? 100:"auto")}
			// 	});
			// 	trace($(this))
			// })

			$this.off("mouseover mousemove mouseenter mouseleave click mousedown mouseup");
			if ($(this).is("[scroll-group]")) {
				$this.on("mouseover", function (e) {
					// 只让编组中的一个为滚动基准
					// 如果非本区域，需要清除所有激活
					if ($(e.target).parents("[scroll-group].scrollActive").length == 0) {
						$("[scroll-group].scrollActive").removeClass("scrollActive");
						$(e.target).parents("[scroll-group]").addClass("scrollActive");
						$(this).find("[scroll-group]").addClass("scrollActive");
					}
					// $(this).addClass("scrollActive");
				});
				// $(this).on("mousedown",function(e){//拖动滚动条的处理
				// 	$('[scroll-group].scrollActive').removeClass('scrollActive scrollActive-lock');
				// 	$(e.target).parents('[scroll-group]').addClass('scrollActive scrollActive-lock');trace("asdsadasd")
				// 	// $(this).find('[scroll-group]').addClass('scrollActive')
				// });
				$this.on("mousemove", function () {
					// 防止拖动发生滚动，导致同组视图不同步
					return false;
				});
				// if(optionNew.axis=="x"){
				// 	$this.find(".head").first().on("mouseenter", function() {
				// 		$("[scroll-group]").removeClass("scrollActive");
				// 		$(this).parents("[scroll-group]").first().addClass("scrollActive");
				// 	});
				// }
				$(this).on("mouseenter", "tbody tr", function () {
					// 跨组激活同行
					let $scope = $(this).parents(".tableScope").first();
					$scope.find("[scroll-group] tbody tr.hover").removeClass("hover");
					let index = $(this).index();
					$scope.find("[scroll-group] tbody").each(function () {
						$(this).find("tr").eq(index).addClass("hover");
					});
				});
				$(this).on("mouseleave", "tbody tr", function () {
					// 跨组取消激活同行
					let $scope = $(this).parents(".tableScope").first();
					$scope.find("[scroll-group] tbody tr.hover").removeClass("hover");
				});
			}
			// 解决滚动范围会裁掉超出范围的下拉内容
			// var fixHeight=0;
			// var $contentBox=$this.find(".mCSB_container");
			// $this.find(".dropList").each(function(){
			// 	if($(this).offset().top+$(this).innerHeight()>$contentBox.offset().top+$contentBox.height()){
			// 		if($(this).innerHeight()>fixHeight) fixHeight=$(this).innerHeight();
			// 	}
			// });
			// if(fixHeight>0) $contentBox.css("padding-bottom",fixHeight);
			/*
			if($(this).attr("scroll")=="noDrag"){
				$(this).niceScroll({bouncescroll:true,cursorborder:"none"});	//给所有需要滚动的元素设置不能拖动的滚动条horizrailenabled:false,
				if($(this).parents(".window").length>0)	$(this).getNiceScroll().hide();
			}else{
				$(this).niceScroll({touchbehavior:true,bouncescroll:true,cursorborder:"none"});	//给所有需要滚动的元素设置滚动条
				if($(this).parents(".window").length>0)	$(this).getNiceScroll().hide();
			}
			$(this).on("mouseenter",function(){
				$(this).getNiceScroll().resize();
				$(this).getNiceScroll().show();
			});
			$(this).on("click","label",function(){	//解决不能点击的问题
				var $label=$(this);
				setTimeout(function(){
					var $input=$label.find("[type='radio'],[type='checkbox']");
					if($input.length>0){
						if($input.prop("checked")==true&&$input.attr("type")!="radio")	$input.prop("checked",false);
						else	$input.prop("checked",true);
					}
				},0);
				return false;
			});
			*/
			$this.off("mouseenter", ".drop-list-box,.drop-list", scrollReFixHeight); //,.datepicker-popup
			$this.on("mouseenter", ".drop-list-box,.drop-list", scrollReFixHeight); //,.datepicker-popup
			// $this.on("click", ".datepicker", function () {
			// 	// 日历组件通过点击触发更新滚动范围
			// 	setTimeout(() => {
			// 		scrollReFixHeight.call($(this).find(".datepicker-popup"));
			// 	}, 100);
			// });
			$this.data("scrollSize", scrollSize); // 设置生效的滚动量
			// $this.attr("scrollSize",Math.round($this.innerHeight()/3));
			$this.mCustomScrollbar($.extend(true, {}, option, optionNew));
			// console.log($(this).hasClass("scroll"),scrollSize)
			// if(fixSize){
			// 	console.log(scrollSize)
			// }
		}
		// else if ($(this).data("scrollSize") === undefined) {
		// 	trace($(this));
		// }
		// else if (!$(this).hasClass('scrollX') && $(this).innerHeight() > 0 && scrollSize != $(this).data('scroll')) { // 需要重新设定符合尺寸的情况
		// 	// console.log($(this).innerHeight()/3,$(this).data("scrollSize"))
		// 	$(this).mCustomScrollbar('destroy');
		// 	setScroll($(this));
		// }
		else {
			$this.mCustomScrollbar("update");
			trace("此scroll已创建，已更新");
		}
	});
}

export function loadingChange($targets, action) {
	// action:String,切换加载状态层的呈现
	if (action == undefined) action = "toggle";
	$targets.each(function () {
		var $target = $(this);
		if (!$target.is("[loading]")) $target = $target.parents("[loading]").first(); // 如果本身不是状态层，默认往上找
		var statusNow = $target.attr("loading");
		switch (action) {
			case "toggle":
				if (statusNow != "true") $target.attr("loading", "true");
				else $target.attr("loading", "false");
				break;
			default:
				$target.attr("loading", action);
				break;
		}
	});
}

export function dragBar($dragBar, optionNew) {
	// option:{start:funtion,draging:function,end:function}
	var option = {
		min: 0,
		max: 0,
		def: 0,
		val: 0,
		unit: "",
		float: 0,
		lock: false,
		// reset:false,
		selector: {
			root: "",
			drag: ".drag",
			area: ".area",
			progress: ".progress",
			value: ".value",
		},
	};
	$.extend(option, optionNew);
	if (option.def < option.min) option.def = option.min;
	option.val = option.def;

	function formatValue(value) {
		// 格式化数字，根据设定保留小数
		value = Number(value);
		var pct = 1;
		for (var i = 1; i <= option.float; ++i) {
			pct *= 10;
		}
		value = Math.floor(value * pct) / pct;
		return value;
	}

	function getVal(event, ui) {
		var $root = $(event.target).data("root");
		var obj = $root.data("dragBar");
		var val = (ui.position.left / ($root.find(obj.selector.area).width() - $(event.target).outerWidth())) * (obj.max - obj.min) + obj.min;
		return formatValue(val);
	}

	function dataOut(event, data) {
		var $root = $(event.target).data("root");
		$root.data("dragBar").val = data;
		var obj = $root.data("dragBar");
		$(event.target)
			.find(obj.selector.value)
			.val(obj.val + obj.unit);
		$root.find(obj.selector.progress).css("width", $root.find(obj.selector.drag).css("left"));
	}
	$dragBar.each(function () {
		var refreshMode = false;
		if ($(this).data("dragBar") == undefined) $(this).data("dragBar", option);
		if (optionNew != undefined) {
			$.extend($(this).data("dragBar"), optionNew);
		} else refreshMode = true;
		$(this).find(option.selector.drag).data("root", $(this));
		var obj = $(this).data("dragBar");
		var $drag = $(this).find(obj.selector.drag);
		var $area = $(this).find(obj.selector.area);
		var $progress = $(this).find(obj.selector.progress);
		var pct = 0,
			leftData = 0;
		var def = obj.def;
		var min = obj.min;
		var max = obj.max;
		if (def < min) def = min;
		else if (def > max) def = max;
		if (obj.val < min) obj.val = min;
		else if (obj.val > max) obj.val = max;
		pct = (obj.val - min) / (max - min);
		if (pct > 1) pct = 1;
		leftData = pct * ($area.width() - $drag.outerWidth());
		// $drag.css("left",formatValue(leftData));
		$drag.animate({
			left: formatValue(leftData),
		});
		$progress.animate({
			width: Math.round(leftData),
		});
		$drag.find(obj.selector.value).val(obj.val + obj.unit);
		// $(this).data("dragBar",option);

		if (refreshMode == false) {
			$drag.draggable({
				// handle:option.selector.drag,
				containment: "parent",
				axis: "x",
				start: function (event, ui) {
					if (option.start) option.start.call(event, getVal(event, ui));
				},
				drag: function (event, ui) {
					var data = getVal(event, ui);
					dataOut(event, data);
					if (option.drag) option.drag.call(event, data);
				},
				stop: function (event, ui) {
					var data = getVal(event, ui);
					dataOut(event, data);
					if (option.end) option.end.call(event, getVal(event, ui));
				},
			});
			if (option.lock) $drag.draggable("disable");
			else if (option.lock == false) $drag.draggable("enable");
			$drag.animate({ opacity: 1 });
		}
	});
}
var lockPos = 0;
export function lockScroll(action) {
	if (action == undefined) {
		// 默认锁定
		// var scrollVal=$(window).scrollTop();
		$(window).on("scroll", lockScrollEvent);
	} else if (action === false) {
		// 解除
		$(window).off("scroll", lockScrollEvent);
	}
}
export function lockScrollEvent(e) {
	// 锁定页面不让滚动
	// reLocate($html);
	$(window).scrollTop(lockPos);
	// e.preventDefault();
}

import Cookies from "js-cookie";
export function setCookie(key, val, m) {
	// 设定cookie
	if (m) {
		m *= 60 * 1000;
	} else m = (365 / 2) * 24 * 3600 * 1000; // 默认半年
	var date = new Date();
	date.setTime(date.getTime() + m);
	let domain = location.hostname.split(".");
	if (domain.length > 2) {
		domain = domain[domain.length - 2] + "." + domain[domain.length - 1];
	} else {
		domain = domain[0];
	}
	if ($.isNumeric(domain)) {
		domain = "";
	}

	let _cookie = document.cookie.match(eval(`/${key}=/g`));
	if (_cookie && _cookie.length > 1) {
		//找到2个以上的cookie，可能由于不同域
		document.cookie = key + "=" + `;domain=www.${domain};path=/;expires=${new Date("1970-01-01").toGMTString()}`; //删除其它域同名cookie
		document.cookie = key + "=" + `;domain=pro.${domain};path=/;expires=${new Date("1970-01-01").toGMTString()}`; //删除其它域同名cookie
		Cookies.remove(key);
	}

	document.cookie = key + "=" + val + `;domain=${domain};path=/;expires=` + date.toGMTString();
}

export function fillHeight(delay, optionNew) {
	// 自动对带有fill属性的元素设定高
	var option = { $list: $("[fillHeight]"), autoMode: false };
	$.extend(option, optionNew);
	// if(option.autoMode==false){
	// clearInterval(delayFill);
	// }
	let space = stage.space;

	function returnEffective($from) {
		if ($from) {
			while (($from.width() == 0 || ($from.offset().top || 0) == 0) && !$from.is("body")) {
				// 自动往上递归，寻找大于0的容器
				$from = $from.parent();
			}
		}
		return $from;
	}

	function returnHeight($dom, str) {
		var val = 0;
		switch (str) {
			case "1":
				val = 1;
				break;
			case "2":
				val = 2;
				break;
			case "space":
				val = space;
				break;
			case "space2x":
				val = space * 2;
				break;
			case "space3x":
				val = space * 3;
				break;
			default:
				if ($dom.parents(".tableScope").hasClass(str.replace(/\./g, "").split(" ")[0]) == false && $dom.parents(".tableScope").length) {
					val = $dom.parents(".tableScope").find(str).innerHeight() || 0; //规避class和tableScope写在同一级
				} else {
					val = $(str).innerHeight() || 0;
				}
				break;
		}
		return val;
	}
	// $("[fillHeight]").css("height","");//清空原有高度
	function fill() {
		option.$list.each(function (index) {
			var minHeight = Number($(this).attr("minHeight")) || 100;
			var maxHeight_attr = $(this).attr("maxHeight");
			switch (maxHeight_attr) {
				case "document":
					maxHeight_attr = $(document).height();
					break;
				case undefined:
					maxHeight_attr = 0;
					break;
				case "":
					break;
				default:
					maxHeight_attr = Number(maxHeight_attr);
					break;
			}
			var maxHeight = Math.max($(window).height(), maxHeight_attr);
			var caseArray = $(this).attr("fillHeight").split(",");
			// var targetHeight=maxHeight-returnEffective($(this)).offset().top-space;
			var targetHeight = maxHeight - returnEffective($(this)).offset().top;
			if ($(this).is("iframe")) targetHeight += space;
			if ($(this).css("display") == "none") targetHeight = minHeight;
			// var targetHeight=($(this).is("[id]"))?	minHeight:0;	有ID的使用最小高度
			switch (caseArray[0]) {
				case "lastHeight":
					// if(height>targetHeight)	targetHeight=height;
					// $(this).html($(window).height()+"|"+$(this).offset().top);
					break;
				case "parent":
					targetHeight = $(this).parent().innerHeight();
					break;
				case "parentLastHeight":
					targetHeight = returnEffective($(this).parent()).innerHeight() - $(this).position().top - Number($(this).css("margin-top").replace(/px/g, ""));
					break;
				case "":
					break;
				default:
					var pct,
						str = "";
					if (caseArray[0].substr(0, 1) === "=") {
						str = caseArray[0].substr(1);
						str = str.split("*");
						if (str.length > 1) {
							str[1] = Number(str[1]);
							minHeight = targetHeight = $(str[0]).innerHeight() * str[1];
						} else {
							targetHeight = $(caseArray[0].substr(1)).innerHeight();
							minHeight = $(caseArray[0].substr(1)).innerHeight();
						}
					} else if (caseArray[0].substr(0, 5) === "width") {
						pct = Number(caseArray[0].substr(5).replace("*", ""));
						if (pct == 0) pct = 1;
						targetHeight = returnEffective($(this)).width() * pct;
					} else if (caseArray[0].substr(0, 6) === "height") {
						pct = Number(caseArray[0].substr(6).replace("*", ""));
						targetHeight = maxHeight * pct;
					} else if (caseArray[0].substr(0, 10) === "lastHeight") {
						pct = Number(caseArray[0].substr(10).replace("*", ""));
						targetHeight = targetHeight * pct;
					} else if (caseArray[0].substr(0, 6) === "parent") {
						pct = Number(caseArray[0].substr(6).replace("*", ""));
						targetHeight = $(this).parent().height() * pct;
					} else if (caseArray[0] === "window") {
						targetHeight = $(window).height();
					}
					break;
			}
			let $dom = $(this);
			$(caseArray)
				.slice(1)
				.each(function (index, e) {
					switch (e.substr(0, 1)) {
						case "+":
							Number(e.substr(1)) >= 0 ? (targetHeight += Number(e.substr(1))) : (targetHeight += returnHeight($dom, e.substr(1)));
							break;
						case "-":
							Number(e.substr(1)) >= 0 ? (targetHeight -= Number(e.substr(1))) : (targetHeight -= returnHeight($dom, e.substr(1)));
							break;
					}
				});
			if ($(this).css("display") != "none") {
				if (targetHeight < minHeight) targetHeight = minHeight;
				$(this).innerHeight(Math.round(targetHeight));
			}
			// if($(this).is("section")) alert(space);
			// if($(this).is("[draw='fdxl']")) trace($(this).parent().innerHeight())
			/*
			if($(this).find("[fillHeight]").length===0){	//没有子分配，直接设置
			}else{	//需要将剩余高度分配给子元素
				$(this).find("[fill]").each(function(){
					var optionArray=$(this).attr("fill").split("-");
				});
			}
			*/
		});
	}
	// if(delay==undefined)	delay=0;
	delay >= 0 ? setTimeout(fill, delay) : fill();
}

function setCheckAllStatus($form) {
	var checkedQty = $form.find("tr>:first-child :checked").not("[disable]").not(".disable").length;
	var maxQty = $form.find("tr>:first-child [type='checkbox']").not("[disable]").not(".disable").length;
	if (checkedQty == 0) $form.find(".checkAll").attr("status", 0);
	else if (checkedQty > 0 && checkedQty < maxQty) $form.find(".checkAll").attr("status", 1);
	else $form.find(".checkAll").attr("status", 2);
	if (checkedQty > 0) {
		$form.find(".tableBatch .batchBtn").each(function () {
			// 依据functionBtn来识别批量动作的按钮
			$(this).removeAttr("disable");
		});
	} else {
		$form.find(".tableBatch .batchBtn").each(function () {
			// 依据functionBtn来识别批量动作的按钮
			$(this).attr("disable", "");
		});
	}
	if ($form.find(".selectQty").length > 0) {
		$form.find(".selectQty").html("(" + $form.find("tr>:first-child :checked").not("[disable]").not(".disable").length + ")");
	}
}

export function startTime(fromDate, timeOffset) {
	var date = new Date(),
		utcInt = Date.UTC(
			date.getUTCFullYear(),
			date.getUTCMonth(),
			date.getUTCDate(),
			date.getUTCHours(),
			date.getUTCMinutes(),
			date.getUTCSeconds(),
			date.getUTCMilliseconds()
		);
	// timeOffsetJs=date.getTimezoneOffset()*60*1000;
	if (fromDate) stage.time.dateFix = fromDate - utcInt;
	if (timeOffset) {
		stage.time.offset = timeOffset * 60 * 1000; // timeZone
		setCookie("timeOffset", stage.time.offset);
	}

	// date=new Date(utcInt+timeObj.dateFix+getCookie("timeOffest"));
	stage.time.offset = $.isNumeric(Number(getCookie("timeOffset"))) ? Number(getCookie("timeOffset")) : stage.time.localOffset;
	stage.time.date = date = new Date(utcInt + stage.time.dateFix + stage.time.offset + date.getTimezoneOffset() * 60 * 1000);
	stage.time.utc = utcInt;

	function getWeekStr(number) {
		var str = "";
		switch (number) {
			case 0:
				str = getLanguageStr("word146", "周日");
				break;
			case 1:
				str = getLanguageStr("word140", "周一");
				break;
			case 2:
				str = getLanguageStr("word141", "周二");
				break;
			case 3:
				str = getLanguageStr("word142", "周三");
				break;
			case 4:
				str = getLanguageStr("word143", "周四");
				break;
			case 5:
				str = getLanguageStr("word144", "周五");
				break;
			case 6:
				str = getLanguageStr("word145", "周六");
				break;
		}
		return str;
	} // trace(getWeekStr)
	/*
	if(fromDate){//alert(fromDate.hours)
		date.setFullYear(fromDate.yy,fromDate.mm,fromDate.dd);
		date.setHours(fromDate.h,fromDate.m,fromDate.s);
	}
	*/
	var h = date.getHours();
	var m = date.getMinutes();
	var s = date.getSeconds();
	// var tz=(date.getTimezoneOffset());
	var tzh = Math.floor(Math.abs(stage.time.offset / 60 / 1000 / 60));
	var tzm = (stage.time.offset / 60 / 1000) % 60;

	m = fill2str(m);
	s = fill2str(s);
	tzh = fill2str(tzh);
	tzm = fill2str(tzm);
	// $("#time .time").html(h+":"+m+":"+s);
	// $("#time .date").html(date.getFullYear()+"-"+fill2str((date.getMonth()+1))+"-"+fill2str(date.getDate()));
	stage.time.week = getWeekStr(date.getDay());
	// $("#time .week").html(getWeekStr(date.getDay()));
	// $("#time .week").attr("week",date.getDay());
	// date.setSeconds(date.getSeconds()+1);
	if (stage.time.offset >= 0) {
		$(".zone").html("(UTC+" + tzh + ":" + tzm + ")");
	} else {
		$(".zone").html("(UTC-" + tzh + ":" + tzm + ")");
	}
	setTimeout(startTime, 1000);
}
/*
function setData_drawDataList(action){	//action:String new,update
	if(action=="update"){

	}

}
*/
function windowAlign($body, position = "") {
	// position:"center"
	if (!$body.attr("style") || $body.attr("style").indexOf("left") < 0 || $body.parent().hasClass("window-alert")) {
		// 仅对第一次进行设置
		var winW = $(window).width(),
			winH = $(window).height();
		var bodySize = [$body.outerWidth(true), $body.outerHeight(true)];
		var posList = position.split(",");
		if (posList.length == 1) posList.push(posList[0]);
		var left = 0,
			top = left;
		switch (
			posList[0] // 计算X
		) {
			case "center":
				left = (winW - bodySize[0]) / 2;
				break;
			case "":
				break;
		}
		switch (
			posList[1] // 计算Y
		) {
			case "center":
				top = (winH - bodySize[1]) / 2;
				break;
			case "":
				break;
		}
		if (left > 0) $body.css({ left: left }); //, transition:"none"
		if (top > 0) $body.css({ top: top });
		// setTimeout(function(){$body.css({transition:""});},0);
	}
}
export function windowCtrl(selector, action, optionNew) {
	let $win = $.type(selector) === "string" ? $(selector) : selector;
	let $body = $win.find(".body").first();
	if ($body.is("[windowAlign]"))
		setTimeout(function () {
			//避免因dom渲染延时导致不精准
			windowAlign($body, $body.attr("windowAlign")); // 没有该属性不作处理
		}, 0);

	if (
		$win.hasClass("window-view") == false &&
		$(selector).hasClass("window-setting") == false &&
		$win.find(".body.ui-draggable").length == 0 &&
		$body.hasClass("body-full") == false
	)
		$win.find(".body").draggable({
			handle: ".head",
			containment: "window",
		}); // 让所有窗口的head位置可以被拖动

	if ($win) {
		if ($win.parents(".window").length > 0) {
			if (action == "true" && $win.css("z-index") > $("#head").css("z-index")) {
				// &&$win.hasClass("window-new")
				$("#head").css("z-index", 9);
			} else if (action == "false" && $win.parents(".window").length == 1) {
				setTimeout(function () {
					$("#head").css("z-index", "");
				}, 500);
			}
		}
		var option = {
			start: null,
			end: null,
		};
		$.extend(option, optionNew);
		// var $body=$win.find(".body");
		if (option.start) option.start.apply($win);

		if (action && action == "true") action = "false";
		else if (action && action == "false") action = "true";

		let targetStyle = {};

		switch (action || $win.attr("status")) {
			case "true":
				$win.find(".body").first().css({
					willChange: "",
					transform: "",
					backdropFilter: "",
					transition: "",
				}); // 去除以呈现默认的动画
				if ($win.find("[scroll]").length > 0) {
					/*
					$win.find("[scroll]").each(function(){
						$(this).getNiceScroll().hide();
					});
					*/
				}
				$win.attr("status", "false");
				// targetStyle.right="-100%";
				// targetStyle.transform="translateX(100%)";
				setTimeout(function () {
					if ($(".window-bg[status='true']").length == 0) $("section").first().css({ zIndex: "" }); // 控制浮层层级，确保能覆在最顶层
					if ($win.parents("[status='true']").length) {
						$win.parents("[status='true']").first().find(".body").first().css({
							willChange: "",
							transform: "",
							backdropFilter: "",
							transition: "",
						}); // transform会导致内部fixed不是窗口大小
					}
				}, 500);
				break;
			case "false":
				if ($win.parents("[status='true']").length) {
					$win.parents("[status='true']").find(".body").first().css({
						willChange: "unset",
						transform: "unset",
						backdropFilter: "unset",
						transition: "unset",
					}); // transform会导致内部fixed不是窗口大小
				}
				// $(this).attr("onoff","on");
				//				$("section").first().css({ "z-index": 10 }); //控制浮层层级，确保能覆在最顶层
				$win.attr("status", "true");
				// targetStyle.right=0;
				// targetStyle."transform":"perspective(80em) rotatex(90deg) scale(.001) translatez(6em)";
				// targetStyle.transform="translateX(0)";
				break;
			/*
				default:
					$win.attr("status","open");
					setTimeout(function(){
						if($win.find("[scroll]").length>0&&$win.attr("status")=="open"){
							$win.find("[scroll]").each(function(){
								$(this).getNiceScroll().resize();
								$(this).getNiceScroll().show();
							});
						}
					},500);
					break;
				*/
		}
		// var $win=($(this).hasClass("window"))?	$(this):$(this).parents(".window");
		// if ($("[winID=" + $win.attr("id") + "]").attr("onoff") != undefined) $("[winID=" + $win.attr("id") + "]").attr("onoff", $win.attr("status")); //设置开关状态
		// if (
		// 	$win.find("[type='radio']").length > 0 &&
		// 	$win.find(":checked").length == 0
		// ) {
		// 	$win.find(".toolBar .bgMain").attr("disable", ""); // 将目标窗口中含有单选且没选中的情况，禁用确定按钮
		// 	$win.on("click", "*", function () {
		// 		if ($win.find(":checked").length > 0)
		// 			$win.find(".toolBar .bgMain").removeAttr("disable");
		// 	});
		// }
		setTimeout(function () {
			if ($win.hasClass("window-alert")) {
				if ($body.offset().left + $body.innerWidth() > $(window).width()) {
					//x超出窗口
					$body.css("left", $(window).width() - $body.innerWidth());
				}
				if ($body.offset().top + $body.innerHeight() > $(window).height()) {
					//y超出窗口
					$body.css("top", $(window).height() - $body.innerHeight());
				}
			}
			if (option.end) {
				option.end.apply($win);
			}
		}, 600);
		// $win.find(".body").first().animate(targetStyle,600,"easeInOutExpo",function(){
		// });
	}
}
function toNonExponential(num) {
	var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
	return num.toFixed(Math.max(0, (m[1] || "").length - m[2]));
}
export function floatFix(num, n = 2, afterStr = null, round = false, forceFix = false) {
	// debugger;
	// 强制n位小数（返回字符窜类型）
	if ($.isNumeric(num)) {
		num = Number(num);
		let fix = "1";
		for (var i = 0; i < n; i++) {
			fix += "0";
		}
		fix = Number(fix); // 以上根据n循环出因数并转成数字
		if (round) {
			// 四舍五入
			num = Math.round(num * fix) / fix;
		} else {
			// 无需四舍五入
			// let float=parseFloat(num).toFixed(n+1) //此方法对于999.999类似无法精确
			//Math.trunc()
			let float = toNonExponential(parseFloat(num)).toString();
			if (float.indexOf(".") != -1) {
				// 判断是否有小数点
				num = Number(float.substring(0, float.indexOf(".") + n + 1));
			} else {
				num = Number(float);
			}
			// num = parseInt(num * 10000/10000*fix) / fix; //此方法有弱精度问题，如4.56
		}
		if (forceFix) {
			num = num.toString();
			let numArr = num.split(".");
			if (numArr.length > 1) {
				let arrS = numArr[1].toString();
				for (let i = 0; i < n - arrS.length; i++) {
					num += "0";
				}
			} else {
				num += ".";
				for (let i = 0; i < n; i++) {
					num += "0";
				}
			}
			num = Number(num);
		}
	}

	// return (Math.floor(num*fix)/fix).toFixed(n);	//*因数，舍小数，除因数，不足位补0
	if ($.isNumeric(num)) {
		return afterStr ? num + " " + afterStr : num;
	} else return "--";
}
function unitConversionMul(arg1, arg2) {
	// js 浮点型乘法
	let m = 0;
	let s1 = arg1.toString();
	let s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length;
	} catch (e) {}
	try {
		m += s2.split(".")[1].length;
	} catch (e) {}
	return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
}
function unitConversionDiv(arg1, arg2) {
	// js 浮点型除法
	let t1 = 0;
	let t2 = 0;
	let r1;
	let r2;
	try {
		t1 = arg1.toString().split(".")[1].length;
	} catch (e) {}
	try {
		t2 = arg2.toString().split(".")[1].length;
	} catch (e) {}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	let intDiv = r1 / r2;
	let pow = Math.pow(10, t2 - t1);
	return unitConversionMul(intDiv, pow); // 这里用上面定义好的乘法运算
}
export function unitConversion(value, unit) {
	switch (unit) {
		case "WAN":
		case "WKWH":
		case "W":
		case "w":
			value = unitConversionMul(value, 10000);
			break;
		case "KKWH":
		case "K":
		case "k":
			value = unitConversionMul(value, 1000);
			break;
		case "reverseW":
			value = unitConversionDiv(value, 10000);
			break;
		case "reverseK":
			value = unitConversionDiv(value, 1000);
			break;
		default:
			value = value;
	}
	return value;
}
// 浮点数相乘
function mul(a, b) {
	var c = 0,
		d = a.toString(),
		e = b.toString();
	try {
		c += d.split(".")[1].length;
	} catch (f) {}
	try {
		c += e.split(".")[1].length;
	} catch (f) {}
	return (Number(d.replace(".", "")) * Number(e.replace(".", ""))) / Math.pow(10, c);
}
//相除
function chu(a, b) {
	var c,
		d,
		e = 0,
		f = 0;
	try {
		e = a.toString().split(".")[1].length;
	} catch (g) {}
	try {
		f = b.toString().split(".")[1].length;
	} catch (g) {}
	return (c = Number(a.toString().replace(".", ""))), (d = Number(b.toString().replace(".", ""))), mul(c / d, Math.pow(10, f - e));
}

function accAdd(arg1, arg2) {
	var r1, r2, m;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	return (arg1 * m + arg2 * m) / m;
}

//温度换算
export function tempChange(data, value) {
	if (data == 1) {
		return [value + "℃", value, "℃"];
	} else {
		let temp = accAdd(32, mul(Number(value), 1.8));
		return [temp + "℉", temp, "℉"];
	}
}
// 需要换算的单位
export function unitinclude(unit) {
	let initARR = ["kWh", "kWh/㎡", "W", "MWh", "MWh/㎡"];
	return initARR.includes(unit);
}
// 单位转换 传入浮点数字、浮点位数要求、prd要求的单位、附加单位字符(页面返回的单位)；
// 输出要求的浮点位数的数字+目标单位
export function convertData(value, rounding = 2, origin = "", unit = "", forceFix = false) {
	// 数据折算
	// debugger;fa
	if (unit == "CNY" && stage.languageId == "zh") unit = "元"; // unit值，针对货币进行折算，会特殊处理,CNY="元"
	if ($.isNumeric(value)) {
		let sValue = "";
		let newValue = "";
		let arr = new Array(3);
		if (origin != "") {
			if (value != 0) {
				if (origin === "k") {
					sValue = mul(Number(value), 1000);
				} else if (origin === "M") {
					sValue = mul(Number(value), 1000000);
				} else if (origin === "G") {
					sValue = mul(Number(value), 1000000000);
				}
				if (sValue >= 1000000000 || sValue <= -1000000000) {
					newValue = rounding !== null ? floatFix(sValue / 1000000000, rounding, null, false, forceFix) : chu(sValue, 1000000000);
					return (arr = [newValue + " G" + unit, newValue, "G" + unit]);
				} else if (sValue >= 1000000 || sValue <= -1000000) {
					newValue = rounding !== null ? floatFix(sValue / 1000000, rounding, null, false, forceFix) : chu(sValue, 1000000);
					return (arr = [newValue + " M" + unit, newValue, "M" + unit]);
				} else if (sValue >= 1000 || sValue <= -1000) {
					newValue = rounding !== null ? floatFix(sValue / 1000, rounding, null, false, forceFix) : chu(sValue, 1000);
					return (arr = [newValue + " k" + unit, newValue, "k" + unit]);
				}
			} else {
				return (arr = [value + " " + origin + unit, value, origin + unit]);
			}
		}
		if (unit == "元") {
			// 中文货币特殊折算
			if (Number(value) >= 100000000) {
				// E
				newValue = rounding !== null ? floatFix(value / 100000000, rounding, null, false, forceFix) : chu(value, 100000000);
				return (arr = [newValue + " 亿" + unit, newValue, "亿" + unit]);
				// return floatFix((Number(value) / 1000), rounding, null, false) + 'M' + unit;
			} else if (Number(value) >= 10000) {
				// W
				newValue = rounding !== null ? floatFix(value / 10000, rounding, null, false, forceFix) : chu(value, 10000);
				return (arr = [newValue + " 万" + unit, newValue, "万" + unit]);
				// return floatFix(Number(value), rounding, null, false) + 'k' + unit;
			} else {
				newValue = rounding !== null ? floatFix(value, rounding, null, false, forceFix) : value;
				return (arr = [newValue + " " + unit, newValue, origin + unit]);
			}
		} else if (unit == "Ω") {
			if (Number(value) >= 1000000) {
				newValue = rounding !== null ? floatFix(value / 1000000, rounding, null, false, forceFix) : chu(value, 1000000);
				return (arr = [newValue + " MΩ" + unit, newValue, "MΩ" + unit]);
			} else if (Number(value) >= 1000 && Number(value) < 1000000) {
				newValue = rounding !== null ? floatFix(value / 1000, rounding, null, false, forceFix) : chu(value, 1000);
				return (arr = [newValue + " KΩ" + unit, newValue, "KΩ" + unit]);
			} else if (Number(value) < 1000) {
				newValue = rounding !== null ? floatFix(value, rounding, null, false, forceFix) : value;
				return (arr = [newValue + " " + unit, newValue, origin + unit]);
			}
		} else {
			// 正常折算
			if (Number(value) > 1000000000 || Number(value) < -1000000000) {
				newValue = rounding !== null ? floatFix(value / 1000000000, rounding, null, false, forceFix) : chu(value, 1000000000);
				return (arr = [newValue + " G" + unit, newValue, "G" + unit]);
				// return floatFix((Number(value) / 1000000), rounding, null, false) + 'G' + unit;
			} else if (Number(value) > 1000000 || Number(value) < -1000000) {
				newValue = rounding !== null ? floatFix(value / 1000000, rounding, null, false, forceFix) : chu(value, 1000000);
				return (arr = [newValue + " M" + unit, newValue, "M" + unit]);
				// return floatFix((Number(value) / 1000), rounding, null, false) + 'M' + unit;
			} else if (Number(value) > 1000 || Number(value) < -1000) {
				newValue = rounding !== null ? floatFix(value / 1000, rounding, null, false, forceFix) : chu(value, 1000);
				return (arr = [newValue + " k" + unit, newValue, "k" + unit]);
				// return floatFix(Number(value), rounding, null, false) + 'k' + unit;
			} else {
				newValue = rounding !== null ? floatFix(value, rounding, null, false, forceFix) : value;
				return (arr = [newValue + " " + origin + unit, newValue, origin + unit]);
			}
		}
	} else return ["--", "--", null]; // [value+unit,value,unit]
}

export function mathSUM(fn, start = 0, end = 0) {
	// 求和函数
	let i = start,
		sumList = [];
	if (fn) {
		while (i <= end) {
			sumList.push(fn(i));
			++i;
		}
	}
	return { list: sumList, total: eval(sumList.join("+")) };
}
export function getMathData(type, data, fix = true) {
	// 各种数据的计算
	data = $.extend(true, {}, data); // 创建副本，避免操作数据后影响元数据
	if (fix) {
		// 百分比转换成小数
		data.IC /= 100;
		data.ID /= 100;
		data.IF /= 100;
		data.IG /= 100;
		data.IH /= 100;
		data.II /= 100;
	}
	/*
data={
	IA=单位投资
	IB=装机容量
	IC=负债率
	ID=利率（融资年利率）
	IE=贷款期限
	IF=预估系统效率
	IG=首年组件衰减率
	IH=次年组件衰减率
	II=预计自发自用比例
	IJ=国补
	IK=省补
	IL=市补
	IM=自发自用电价
	IN=并网电价
	OA={1:,2:,....,13:Number}预测光照小时
	//IO=电站经度
	//IP=电站纬度
}
*/
	let i = null,
		d = null,
		x = null,
		y = null,
		OD = null,
		OF = null,
		OG = null,
		OGs = null,
		OX = null,
		OE = null,
		OW = null,
		out = null;
	switch (type) {
		case "OC": // out={list:[],total:Number},预期首年发电量（KWh）
			out = mathSUM(
				(index) => {
					// let d;
					// if(index===1){
					// }
					// else{
					// 	d=;
					// }
					return data.OA["13"] * 365 * data.IF * data.IB * (1 - data.IG - index * data.IH);
				},
				0,
				24
			);
			break;
		case "OD": // 预期投资总额（万元）
			out = (data.IA * data.IB) / 10 - data.IV / 10000;
			break;
		case "OE": // 贷款总额（万元）
			out = getMathData("OD", data, false) * data.IC;
			break;
		case "OF": // 年均还贷额（万元）
			out = (getMathData("OE", data, false) * data.ID * Math.pow(1 + data.ID, data.IE)) / (Math.pow(1 + data.ID, data.IE) - 1);
			break;
		case "OG": // out={list:[],total:Number},25年总收入（万元）、每年收入
			let OCs = getMathData("OC", data, false).list;
			out = mathSUM(
				(index) => {
					// if(index<5) return OCs[index]*(data.II*(data.IM+data.IJ+data.IK+data.IL)+(1-data.II)*(data.IN+data.IJ+data.IK+data.IL))/10000;
					// else return OCs[index]*(data.II*(data.IM+data.IK+data.IL)+(1-data.II)*(data.IN+data.IK+data.IL))/10000;
					let count = (OCs[index] * (data.II * data.IM + (1 - data.II) * data.IN)) / 10000;
					if (index < data.IR) count = count + (OCs[index] * (data.II * data.IJ + (1 - data.II) * data.IJ)) / 10000; // 国补修正
					if (index < data.IS) count = count + (OCs[index] * (data.II * data.IK + (1 - data.II) * data.IK)) / 10000; // 省补修正
					if (index < data.IT) count = count + (OCs[index] * (data.II * data.IL + (1 - data.II) * data.IL)) / 10000; // 市补修正
					if (index < data.IU) count = count + (OCs[index] * (data.II * data.IQ + (1 - data.II) * data.IQ)) / 10000; // 县补修正
					return count;
				},
				0,
				24
			);
			break;
		case "OH": // 年平均收入（万元）
			OG = getMathData("OG", data, false);
			out = OG.total / OG.list.length;
			break;
		case "OQ": // 投资回收期（融资前）
			i = 1;
			d = [];
			// OF=getMathData("OF",data,false);
			OGs = getMathData("OG", data, false).list;
			OD = getMathData("OD", data, false);
			OX = getMathData("OX", data, false);
			while (i <= 25) {
				out =
					-OD +
					mathSUM(
						(index) => {
							return OGs[index - 1];
						},
						1,
						i
					).total;
				if (out > 0) {
					if (i === 1) {
						out = OX / OGs[i - 1];
					} else {
						out = i - 1 + Math.abs(d[i - 2]) / OGs[i - 1];
					}
					break;
				} else {
					d.push(out);
					++i;
				}
			}
			if (i > 25) out = ">25";
			break;
		case "OI": // 投资回收期（融资后）
			i = 1;
			d = [];
			OGs = getMathData("OG", data, false).list;
			OF = getMathData("OF", data, false);
			OD = getMathData("OD", data, false);
			OW = getMathData("OW", data, false);
			while (i <= 25) {
				if (i <= data.IE) {
					out =
						-OD * (1 - data.IC) +
						mathSUM(
							(index) => {
								return OGs[index - 1] - OF;
							},
							1,
							i
						).total;
				} else {
					out =
						-OD * (1 - data.IC) +
						mathSUM(
							(index) => {
								return OGs[index - 1] - OF;
							},
							1,
							data.IE
						).total +
						mathSUM(
							(index) => {
								return OGs[index - 1];
							},
							data.IE + 1,
							i
						).total;
				}
				if (out > 0) {
					if (i === 1) {
						out = OW / (OGs[0] - OF);
					} else {
						if (i <= data.IE) {
							out = i - 1 + Math.abs(d[i - 2]) / (OGs[i - 1] - OF);
						} else {
							out = i - 1 + Math.abs(d[i - 2]) / OGs[i - 1];
						}
					}
					break;
				} else {
					d.push(out);
					++i;
				}
			}
			if (i > 25) out = ">25";
			break;
		case "OJ": // 项目IRR
			OD = getMathData("OD", data, false);
			OG = getMathData("OG", data, false);
			OGs = OG.list;
			x = -OD + OG.total;
			y =
				-OD +
				mathSUM(
					(index) => {
						return OGs[index] / Math.pow(1 + 0.1, index + 1);
					},
					0,
					24
				).total;
			out = (-x / (y - x)) * 0.1 * 100;
			break;
		case "OK": // 权益IRR
			OD = getMathData("OD", data, false);
			OGs = getMathData("OG", data, false).list;
			OF = getMathData("OF", data, false);

			x =
				-OD * (1 - data.IC) +
				mathSUM(
					(index) => {
						return OGs[index] - OF;
					},
					0,
					data.IE - 1
				).total +
				mathSUM(
					(index) => {
						return OGs[index];
					},
					data.IE,
					OGs.length - 1
				).total;

			y =
				-OD * (1 - data.IC) +
				mathSUM(
					(index) => {
						return (OGs[index] - OF) / Math.pow(1 + 0.1, index + 1);
					},
					0,
					data.IE - 1
				).total +
				mathSUM(
					(index) => {
						return OGs[index] / Math.pow(1 + 0.1, index + 1);
					},
					data.IE,
					OGs.length - 1
				).total;

			out = (-x / (y - x)) * 0.1 * 100;
			break;
		case "OM": // out=[number],净利润
			OGs = getMathData("OG", data, false).list;
			OE = getMathData("OE", data, false);
			OF = getMathData("OF", data, false);
			out = mathSUM(
				(index) => {
					if (index <= data.IE) {
						return (
							OGs[index - 1] -
							(OE * Math.pow(1 + data.ID, index) -
								OF *
									mathSUM(
										(n) => {
											return Math.pow(1 + data.ID, n - 1);
										},
										1,
										index
									).total) *
								data.ID
						);
					} else return OGs[index - 1];
				},
				1,
				25
			);
			break;
		case "ON": // out={list:[],total:Number},项目资本金现金流
			out = getMathData("OG", data, false);
			break;
		case "OP": // out={list:[],total:Number},项目全投资现金流
			OF = getMathData("OF", data, false);
			OGs = getMathData("OG", data, false).list;
			out = mathSUM(
				(index) => {
					if (index <= data.IE - 1) return OGs[index] - OF;
					else return OGs[index];
				},
				0,
				24
			);
			break;
		case "OX": // 自有资金投入（万元）融资前
			out = getMathData("OD", data, false);
			break;
		case "OW": // 自有资金投入（万元）融资后 OW=OD-OE
			out = getMathData("OD", data, false) - getMathData("OE", data, false);
			break;
		case "OR": // 总收益（万元）融资后 OR=OG-(OF*25-OE)
			OG = getMathData("OG", data, false).total;
			OF = getMathData("OF", data, false);
			OE = getMathData("OE", data, false);
			out = OG - (OF * data.IE - OE);
			break;
		case "OS": // 总收益（万元）融资前 OS=OG
			out = getMathData("OG", data, false).total;
			break;
		case "OU": // 首年收益（万元）融资后 OU=OG1-OE*ID
			out = getMathData("OG", data, false).list[0] - getMathData("OE", data, false) * data.ID;
			break;
		case "OV": // 首年收益（万元）融资前 OV=OG1
			out = getMathData("OG", data, false).list[0];
			break;
	}
	return out;
}

// 图标数据格式化处理
// data:图表数据(数组)
// type: w-功率，wh-电量
// decimalDigits: 小数位
export function convertChartData(data, type, decimalDigits = 2) {
	let max = 0;
	let formatTimes = 0; // 按千转算的次数
	let unitStrs = ["", "k", "M", "G"];
	let result = {
		datas: [],
		unit: "",
	};
	for (var index in data) {
		if (data[index] && max < Number(data[index])) {
			max = data[index];
		}
	}
	while (max >= 1000 && formatTimes < 3) {
		max = parseInt(max / 1000);
		formatTimes++;
	}

	switch (type) {
		case "w":
			result.unit = unitStrs[formatTimes] + "W";
			break;
		case "wh":
			result.unit = unitStrs[formatTimes] + "Wh";
			break;
		default:
			break;
	}
	for (var index in data) {
		let val = data[index] ? (Number(data[index]) / Math.pow(1000, formatTimes)).toFixed(decimalDigits) : data[index];
		result.datas.push(val);
	}
	return result;
}

export function tabChange(index, indexName, callback) {
	this[indexName] = index;
	// if(typeof(callback)=='function') setTimeout(function() {callback()}, 0)
}
export function judge(e, t, r) {
	// 参数说明：e:为entityRelId  t:type r:rolecode数组 (当e==null||e=='')为内部电站
	// 判断是否可以点击
	let buttonPermissions = JSON.parse(localStorage.getItem("buttonPermissions"));
	if (buttonPermissions.includes("A/B/A6")) {
		// 查看电站详情A/B/A6
		if (t == "ChildSys") {
			if (buttonPermissions.includes("A/B/A7")) {
				// 子系统
				if (e == null || e == "") {
					//内部电站
					return true;
				} else {
					for (let i = 0; i < r.length; i++) {
						if (r[i].code.indexOf("A3") > 0) {
							// 外部子系统
							if (r[i].isOn == 2) {
								return true;
							} else {
								return false;
							}
						}
					}
				}
			} else {
				return false;
			}
		} else {
			if (buttonPermissions.includes("A/D/A1")) {
				// 报警
				if (e == null || e == "") {
					//内部电站
					return true;
				} else {
					for (let i = 0; i < r.length; i++) {
						if (r[i].code.indexOf("A7") > 0) {
							// 外部报警
							if (r[i].isOn == 2) {
								return true;
							} else {
								return false;
							}
						}
					}
				}
			} else {
				return false;
			}
		}
	} else {
		return false;
	}
}
export function getVarietyDevices(res) {
	let btnState = [
		{
			title: getLanguageStr("word35", "逆变器"),
			api: "OperationInverter",
			childRef: "InverterList",
			count: res.inverterCount && res.inverterCount.total ? res.inverterCount.total : 0,
		},
		{
			title: getLanguageStr("word39", "电表"),
			api: "OperationAmmeter",
			childRef: "AmmeterList",
			count: res.meterCount.total,
		},
		{
			title: getLanguageStr("word647", "组件"),
			api: "OperationComponet",
			childRef: "ComponetList",
			count: res.pvModuleCount.total,
		},
		{
			title: getLanguageStr("word38", "气象站"),
			api: "OperationWeather",
			childRef: "WeatherList",
			count: res.weatherStationCount.total,
		},
		{
			title: getLanguageStr("word804", "微逆"),
			api: "OperationMicroInverter",
			childRef: "MicroInverterList",
			count: res.microInverterCount.total,
		},
		{
			title: getLanguageStr("word36", "汇流箱"),
			api: "OperationCombinerBox",
			childRef: "CombinerBoxList",
			count: res.combinerBoxCount.total,
		},
		{
			title: getLanguageStr("word803", "中继器"),
			api: "OperationRepeater",
			childRef: "RepeaterList",
			count: res.repeaterCount.total,
		},
		{
			title: getLanguageStr("word37", "电池"),
			api: "OperationBattery",
			childRef: "BatteryList",
			count: res.batteryCount.total,
		},
		{
			title: getLanguageStr("plant240", "风机"),
			api: "OperationFAN",
			childRef: "FANList",
			count: res.fanCount.total,
		},
		{
			title: getLanguageStr("plant443", "EPM"),
			api: "OperationEPM",
			childRef: "EPMList",
			count: res.epmCount && res.epmCount.total ? res.epmCount.total : 0,
		},
		{
			title: getLanguageStr("word1821", "混合能源系统柜"),
			api: "OperationHybridPower",
			childRef: "HybridPowerList",
			count: res.hybridPowerCount && res.hybridPowerCount.total ? res.hybridPowerCount.total : 0,
		},
		{
			title: getLanguageStr("plant444", "智能表"),
			api: "OperationSmartMeter",
			childRef: "SmartMeterList",
			count: res.smartMeterCount && res.smartMeterCount.total ? res.smartMeterCount.total : 0,
		},
		{
			title: getLanguageStr("device391", "离网逆变器"),
			api: "OperationtypeOffGridInverter",
			childRef: "TypeOffGridInverterList",
			count: res.offGridInverterCount && res.offGridInverterCount.total ? res.offGridInverterCount.total : 0,
		},
		{
			title: getLanguageStr("word34", "采集器"),
			api: "OperationCollector",
			childRef: "CollectorList",
			count: res.collectorCount.total,
		},
		{
			title: getLanguageStr("DTU", "DTU"),
			api: "OperationDTU",
			childRef: "DTUList",
			count: res.dtuCount.total,
		},
		{
			title: getLanguageStr("API", "API"),
			api: "OperationAPI",
			childRef: "APIList",
			count: res.apiCount && res.apiCount.total ? res.apiCount.total : 0,
		},
	];
	btnState = btnState.filter((el) => el.count > 0);
	return btnState;
}

export function runCallback(name) {
	//用于回调app的方法
	console.info(name);
	var data = [...arguments];
	data.shift();
	if (name) {
		if ($.type(name) == "string") {
			if ($.type(data[0]) == "object" || $.type(data[0]) == "array") data[0] = JSON.stringify(data);
			var pathField = name.split(".");
			var fieldNow = window;
			$.each(pathField, function (index, field) {
				//支持多级变量，ios有这样的需求
				fieldNow = fieldNow[field];
			});
			// alert(name,window[pathField[0]],window[pathField[0]][pathField[1]],data);
			switch (stage.browser.system) {
				case "ios":
					if (data.length) {
						fieldNow.postMessage(...data); //ios用别的写法不执行
					} else {
						fieldNow.postMessage(""); //ios必须始终传递
					}
					break;
				case "android":
					switch (pathField.length) {
						case 2:
							window[pathField[0]][pathField[1]](...data);
							break;
						case 3:
							window[pathField[0]][pathField[1]][pathField[2]](...data);
							break;
						case 4:
							window[pathField[0]][pathField[1]][pathField[2]][pathField[3]](...data);
							break;
						default:
							fieldNow(...data);
							break;
					}
					break;
			}
		} else {
			name(...data);
		}
	}
}



// WEBPACK FOOTER //
// ./src/util/lib.js